
export const gameData = [
	{
		"code": "rJybo6nfdgb",
		"url": "https://9786.play.gamezop.com/g/rJybo6nfdgb",
		"name": {
			"en": "Ship It Up!"
		},
		"isPortrait": true,
		"description": {
			"en": "How far can you take the boxes? Make bridges between islands, avoid the watchtowers!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/uHfh_ox1iRo"
		},
		"assets": {
			"cover": "https://static.gamezop.com/rJybo6nfdgb/cover.jpg",
			"brick": "https://static.gamezop.com/rJybo6nfdgb/brick.png",
			"thumb": "https://static.gamezop.com/rJybo6nfdgb/thumb.png",
			"wall": "https://static.gamezop.com/rJybo6nfdgb/wall.png",
			"square": "https://static.gamezop.com/rJybo6nfdgb/square.png",
			"screens": [
				"https://static.gamezop.com/rJybo6nfdgb/game-1.png",
				"https://static.gamezop.com/rJybo6nfdgb/game-2.png",
				"https://static.gamezop.com/rJybo6nfdgb/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/rJybo6nfdgb/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/rJybo6nfdgb/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": [
				"Endless",
				"Fun",
				"Kids",
				"Time Mgmt.",
				"Cute"
			]
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#876148",
		"colorVibrant": "#084d7b",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 13334824,
		"hasIntegratedAds": false
	},
	{
		"code": "rkt7TzJv9k7",
		"url": "https://9786.play.gamezop.com/g/rkt7TzJv9k7",
		"name": {
			"en": "Battleships Armada"
		},
		"isPortrait": true,
		"description": {
			"en": "Deploy your fleet carefully and scan the seas in search of your rival's ships. Bomb the fleet before yours gets bombed!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/d7SGcw1kNt8"
		},
		"assets": {
			"cover": "https://static.gamezop.com/rkt7TzJv9k7/cover.jpg",
			"brick": "https://static.gamezop.com/rkt7TzJv9k7/brick.png",
			"thumb": "https://static.gamezop.com/rkt7TzJv9k7/thumb.png",
			"wall": "https://static.gamezop.com/rkt7TzJv9k7/wall.png",
			"square": "https://static.gamezop.com/rkt7TzJv9k7/square.png",
			"screens": [
				"https://static.gamezop.com/rkt7TzJv9k7/game-1.png",
				"https://static.gamezop.com/rkt7TzJv9k7/game-2.png",
				"https://static.gamezop.com/rkt7TzJv9k7/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/rkt7TzJv9k7/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/rkt7TzJv9k7/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": []
		},
		"width": 768,
		"height": 1024,
		"colorMuted": "#375054",
		"colorVibrant": "#0a5575",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 4739367,
		"hasIntegratedAds": false
	},
	{
		"code": "r1Xm38FQkl",
		"url": "https://9786.play.gamezop.com/g/r1Xm38FQkl",
		"name": {
			"en": "Alien Kindergarten"
		},
		"isPortrait": false,
		"description": {
			"en": "Puzzle game in which you play an alien mom hatching slimy, oozing eggs across several levels."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/r1Xm38FQkl/cover.jpg",
			"brick": "https://static.gamezop.com/r1Xm38FQkl/brick.png",
			"thumb": "https://static.gamezop.com/r1Xm38FQkl/thumb.png",
			"wall": "https://static.gamezop.com/r1Xm38FQkl/wall.png",
			"square": "https://static.gamezop.com/r1Xm38FQkl/square.png",
			"screens": [
				"https://static.gamezop.com/r1Xm38FQkl/game-1.png",
				"https://static.gamezop.com/r1Xm38FQkl/game-2.png",
				"https://static.gamezop.com/r1Xm38FQkl/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/r1Xm38FQkl/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/r1Xm38FQkl/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": [
				"Logic",
				"Fun",
				"Level-based",
				"Story-based",
				"HD",
				"Cute",
				"Puzzle"
			]
		},
		"width": 1024,
		"height": 672,
		"colorMuted": "#344c68",
		"colorVibrant": "#084e75",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 1590703,
		"hasIntegratedAds": false
	},
	{
		"code": "B1SmafkP5kQ",
		"url": "https://9786.play.gamezop.com/g/B1SmafkP5kQ",
		"name": {
			"en": "Holiday Cheer"
		},
		"isPortrait": true,
		"description": {
			"en": "Fly over snowy landscapes as Santa, delivering presents to houses. Be careful, Santa must have a gift for each house!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/07X1Cstu-kU"
		},
		"assets": {
			"cover": "https://static.gamezop.com/B1SmafkP5kQ/cover.jpg",
			"brick": "https://static.gamezop.com/B1SmafkP5kQ/brick.png",
			"thumb": "https://static.gamezop.com/B1SmafkP5kQ/thumb.png",
			"wall": "https://static.gamezop.com/B1SmafkP5kQ/wall.png",
			"square": "https://static.gamezop.com/B1SmafkP5kQ/square.png",
			"screens": [
				"https://static.gamezop.com/B1SmafkP5kQ/game-1.png",
				"https://static.gamezop.com/B1SmafkP5kQ/game-2.png",
				"https://static.gamezop.com/B1SmafkP5kQ/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/B1SmafkP5kQ/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/B1SmafkP5kQ/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": []
		},
		"width": 640,
		"height": 1136,
		"colorMuted": "#60422c",
		"colorVibrant": "#641c0c",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 10366599,
		"hasIntegratedAds": false
	},
	{
		"code": "NJ3xGOyfb5l",
		"url": "https://9786.play.gamezop.com/g/NJ3xGOyfb5l",
		"name": {
			"en": "Tricky Trip"
		},
		"isPortrait": true,
		"description": {
			"en": "Tap to build bridges to get the car moving. But wait! It can't be that simple, can it? Length is key!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/9aEHWB02cWM"
		},
		"assets": {
			"cover": "https://static.gamezop.com/NJ3xGOyfb5l/cover.jpg",
			"brick": "https://static.gamezop.com/NJ3xGOyfb5l/brick.png",
			"thumb": "https://static.gamezop.com/NJ3xGOyfb5l/thumb.png",
			"wall": "https://static.gamezop.com/NJ3xGOyfb5l/wall.png",
			"square": "https://static.gamezop.com/NJ3xGOyfb5l/square.png",
			"screens": [
				"https://static.gamezop.com/NJ3xGOyfb5l/game-1.png",
				"https://static.gamezop.com/NJ3xGOyfb5l/game-2.png",
				"https://static.gamezop.com/NJ3xGOyfb5l/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/NJ3xGOyfb5l/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/NJ3xGOyfb5l/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Arcade"
			]
		},
		"tags": {
			"en": [
				"Boys",
				"Endless",
				"Exclusive",
				"Family",
				"Fun",
				"Girls",
				"Physics",
				"Arcade",
				"Cars"
			]
		},
		"width": 338,
		"height": 600,
		"colorMuted": "#383749",
		"colorVibrant": "#2c345c",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 42435008,
		"hasIntegratedAds": false
	},
	{
		"code": "r1zCFBZdV",
		"url": "https://9786.play.gamezop.com/g/r1zCFBZdV",
		"name": {
			"en": "Defense of Karmax 3"
		},
		"isPortrait": false,
		"description": {
			"en": "In this HTML5 game, Captain Rogers is a hero defending the galaxy against the alien invasion."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/r1zCFBZdV/cover.jpg",
			"brick": "https://static.gamezop.com/r1zCFBZdV/brick.png",
			"thumb": "https://static.gamezop.com/r1zCFBZdV/thumb.png",
			"wall": "https://static.gamezop.com/r1zCFBZdV/wall.png",
			"square": "https://static.gamezop.com/r1zCFBZdV/square.png",
			"screens": [
				"https://static.gamezop.com/r1zCFBZdV/game-1.png",
				"https://static.gamezop.com/r1zCFBZdV/game-2.png",
				"https://static.gamezop.com/r1zCFBZdV/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/r1zCFBZdV/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/r1zCFBZdV/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Action"
			]
		},
		"tags": {
			"en": [
				"Action",
				"Boys",
				"Shooting",
				"Space",
				"Arcade"
			]
		},
		"width": 800,
		"height": 600,
		"colorMuted": "#446a69",
		"colorVibrant": "#a46306",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 2456441,
		"hasIntegratedAds": false
	},
	{
		"code": "HJXei0j",
		"url": "https://9786.play.gamezop.com/g/HJXei0j",
		"name": {
			"en": "Cyberfusion"
		},
		"isPortrait": true,
		"description": {
			"en": "Numbers merge to make higher numbers, stars blast when merged. The best match-3 HTML5 game!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/YG0hhWSsM18"
		},
		"assets": {
			"cover": "https://static.gamezop.com/HJXei0j/cover.jpg",
			"brick": "https://static.gamezop.com/HJXei0j/brick.png",
			"thumb": "https://static.gamezop.com/HJXei0j/thumb.png",
			"wall": "https://static.gamezop.com/HJXei0j/wall.png",
			"square": "https://static.gamezop.com/HJXei0j/square.png",
			"screens": [
				"https://static.gamezop.com/HJXei0j/game-1.png",
				"https://static.gamezop.com/HJXei0j/game-2.png",
				"https://static.gamezop.com/HJXei0j/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/HJXei0j/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/HJXei0j/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": [
				"Boys",
				"Logic",
				"Endless",
				"Exclusive",
				"Family",
				"Girls",
				"Strategy",
				"Match-3"
			]
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#2c2f4f",
		"colorVibrant": "#1e5c92",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 21463942,
		"hasIntegratedAds": false
	},
	{
		"code": "ByGqEfCXa",
		"url": "https://9786.play.gamezop.com/g/ByGqEfCXa",
		"name": {
			"en": "Falling Through"
		},
		"isPortrait": false,
		"description": {
			"en": "In this addictive game, smartly find the nearest gaps for the ball to pass through. Be quick!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/qHgBRuv5Lf4"
		},
		"assets": {
			"cover": "https://static.gamezop.com/ByGqEfCXa/cover.jpg",
			"brick": "https://static.gamezop.com/ByGqEfCXa/brick.png",
			"thumb": "https://static.gamezop.com/ByGqEfCXa/thumb.png",
			"wall": "https://static.gamezop.com/ByGqEfCXa/wall.png",
			"square": "https://static.gamezop.com/ByGqEfCXa/square.png",
			"screens": [
				"https://static.gamezop.com/ByGqEfCXa/game-1.png",
				"https://static.gamezop.com/ByGqEfCXa/game-2.png",
				"https://static.gamezop.com/ByGqEfCXa/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/ByGqEfCXa/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/ByGqEfCXa/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Arcade"
			]
		},
		"tags": {
			"en": [
				"Endless",
				"Family",
				"Fun",
				"Racing",
				"Arcade",
				"Minimal",
				"HD",
				"Difficult"
			]
		},
		"width": 800,
		"height": 451,
		"colorMuted": "#3c2c54",
		"colorVibrant": "#432b5c",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 23032667,
		"hasIntegratedAds": false
	},
	{
		"code": "SkKlAYSbuE",
		"url": "https://9786.play.gamezop.com/g/SkKlAYSbuE",
		"name": {
			"en": "Snack Time"
		},
		"isPortrait": false,
		"description": {
			"en": "It's snack time and there's only one rule: eat! Solve the puzzles to feed porky in this HTML5 game."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/SkKlAYSbuE/cover.jpg",
			"brick": "https://static.gamezop.com/SkKlAYSbuE/brick.png",
			"thumb": "https://static.gamezop.com/SkKlAYSbuE/thumb.png",
			"wall": "https://static.gamezop.com/SkKlAYSbuE/wall.png",
			"square": "https://static.gamezop.com/SkKlAYSbuE/square.png",
			"screens": [
				"https://static.gamezop.com/SkKlAYSbuE/game-1.png",
				"https://static.gamezop.com/SkKlAYSbuE/game-2.png",
				"https://static.gamezop.com/SkKlAYSbuE/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SkKlAYSbuE/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SkKlAYSbuE/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": [
				"Logic",
				"Food",
				"Animal",
				"Strategy",
				"Level-based"
			]
		},
		"width": 800,
		"height": 600,
		"colorMuted": "#645c38",
		"colorVibrant": "#896104",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 402945,
		"hasIntegratedAds": false
	},
	{
		"code": "BJ9ZE86I6Wg",
		"url": "https://9786.play.gamezop.com/g/BJ9ZE86I6Wg",
		"name": {
			"en": "Aqua Thief"
		},
		"isPortrait": false,
		"description": {
			"en": "Dive into hours of fun as you help Aqua Thief in his quest to capture the underwater treasure!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/n4VHltUAMHU"
		},
		"assets": {
			"cover": "https://static.gamezop.com/BJ9ZE86I6Wg/cover.jpg",
			"brick": "https://static.gamezop.com/BJ9ZE86I6Wg/brick.png",
			"thumb": "https://static.gamezop.com/BJ9ZE86I6Wg/thumb.png",
			"wall": "https://static.gamezop.com/BJ9ZE86I6Wg/wall.png",
			"square": "https://static.gamezop.com/BJ9ZE86I6Wg/square.png",
			"screens": [
				"https://static.gamezop.com/BJ9ZE86I6Wg/game-1.png",
				"https://static.gamezop.com/BJ9ZE86I6Wg/game-2.png",
				"https://static.gamezop.com/BJ9ZE86I6Wg/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/BJ9ZE86I6Wg/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/BJ9ZE86I6Wg/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": [
				"Logic",
				"Family",
				"Fun",
				"Strategy",
				"Level-based",
				"HD",
				"Cute"
			]
		},
		"width": 1120,
		"height": 840,
		"colorMuted": "#0c1117",
		"colorVibrant": "#857c14",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 1173443,
		"hasIntegratedAds": false
	},
	{
		"code": "rJJMVIa8p-x",
		"url": "https://9786.play.gamezop.com/g/rJJMVIa8p-x",
		"name": {
			"en": "Sticky Goo"
		},
		"isPortrait": true,
		"description": {
			"en": "Creepy spiders and bleak platforms leave no room for error as you set out to save your love!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/QQUFvu9jF88"
		},
		"assets": {
			"cover": "https://static.gamezop.com/rJJMVIa8p-x/cover.jpg",
			"brick": "https://static.gamezop.com/rJJMVIa8p-x/brick.png",
			"thumb": "https://static.gamezop.com/rJJMVIa8p-x/thumb.png",
			"wall": "https://static.gamezop.com/rJJMVIa8p-x/wall.png",
			"square": "https://static.gamezop.com/rJJMVIa8p-x/square.png",
			"screens": [
				"https://static.gamezop.com/rJJMVIa8p-x/game-1.png",
				"https://static.gamezop.com/rJJMVIa8p-x/game-2.png",
				"https://static.gamezop.com/rJJMVIa8p-x/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/rJJMVIa8p-x/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/rJJMVIa8p-x/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": [
				"Adventure",
				"Endless",
				"Fun",
				"Girls",
				"Kids",
				"HD",
				"Cute",
				"Difficult"
			]
		},
		"width": 1344,
		"height": 1008,
		"colorMuted": "#485845",
		"colorVibrant": "#13765f",
		"privateAllowed": true,
		"rating": 4,
		"numberOfRatings": 4,
		"gamePlays": 83779300,
		"hasIntegratedAds": false
	},
	{
		"code": "HkBWwMUFOye",
		"url": "https://9786.play.gamezop.com/g/HkBWwMUFOye",
		"name": {
			"en": "Terra Infirma"
		},
		"isPortrait": false,
		"description": {
			"en": "Skate without falling over as the Earth moves beneath you! Swipe up and down as fast as you can."
		},
		"gamePreviews": {
			"en": "https://youtu.be/9NChZBSn2eI"
		},
		"assets": {
			"cover": "https://static.gamezop.com/HkBWwMUFOye/cover.jpg",
			"brick": "https://static.gamezop.com/HkBWwMUFOye/brick.png",
			"thumb": "https://static.gamezop.com/HkBWwMUFOye/thumb.png",
			"wall": "https://static.gamezop.com/HkBWwMUFOye/wall.png",
			"square": "https://static.gamezop.com/HkBWwMUFOye/square.png",
			"screens": [
				"https://static.gamezop.com/HkBWwMUFOye/game-1.png",
				"https://static.gamezop.com/HkBWwMUFOye/game-2.png",
				"https://static.gamezop.com/HkBWwMUFOye/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/HkBWwMUFOye/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/HkBWwMUFOye/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": [
				"Adventure",
				"Boys",
				"Endless",
				"Exclusive",
				"Family",
				"Fun",
				"Kids",
				"Physics",
				"HD",
				"Cute"
			]
		},
		"width": 800,
		"height": 451,
		"colorMuted": "#343a42",
		"colorVibrant": "#5d2727",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 8018118,
		"hasIntegratedAds": false
	},
	{
		"code": "SyQZs6nzueW",
		"url": "https://9786.play.gamezop.com/g/SyQZs6nzueW",
		"name": {
			"en": "The Sea Lion Act"
		},
		"isPortrait": true,
		"description": {
			"en": "Here's a circus sea lion with a twitchy nose: balance as many objects on the beam as you can!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/c_iTmYDqMR8"
		},
		"assets": {
			"cover": "https://static.gamezop.com/SyQZs6nzueW/cover.jpg",
			"brick": "https://static.gamezop.com/SyQZs6nzueW/brick.png",
			"thumb": "https://static.gamezop.com/SyQZs6nzueW/thumb.png",
			"wall": "https://static.gamezop.com/SyQZs6nzueW/wall.png",
			"square": "https://static.gamezop.com/SyQZs6nzueW/square.png",
			"screens": [
				"https://static.gamezop.com/SyQZs6nzueW/game-1.png",
				"https://static.gamezop.com/SyQZs6nzueW/game-2.png",
				"https://static.gamezop.com/SyQZs6nzueW/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SyQZs6nzueW/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SyQZs6nzueW/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": [
				"Endless",
				"Family",
				"Fun",
				"Animal",
				"Kids",
				"Physics",
				"Cute"
			]
		},
		"width": 338,
		"height": 600,
		"colorMuted": "#57493c",
		"colorVibrant": "#7c4d07",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 7070597,
		"hasIntegratedAds": false
	},
	{
		"code": "rJsWV8aIa-l",
		"url": "https://9786.play.gamezop.com/g/rJsWV8aIa-l",
		"name": {
			"en": "Jelly Doods"
		},
		"isPortrait": true,
		"description": {
			"en": "Combine jelly shapes of the same color by sliding the jellies together. Use fewest possible moves."
		},
		"gamePreviews": {
			"en": "https://youtu.be/CDMOJez2n5Y"
		},
		"assets": {
			"cover": "https://static.gamezop.com/rJsWV8aIa-l/cover.jpg",
			"brick": "https://static.gamezop.com/rJsWV8aIa-l/brick.png",
			"thumb": "https://static.gamezop.com/rJsWV8aIa-l/thumb.png",
			"wall": "https://static.gamezop.com/rJsWV8aIa-l/wall.png",
			"square": "https://static.gamezop.com/rJsWV8aIa-l/square.png",
			"screens": [
				"https://static.gamezop.com/rJsWV8aIa-l/game-1.png",
				"https://static.gamezop.com/rJsWV8aIa-l/game-2.png",
				"https://static.gamezop.com/rJsWV8aIa-l/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/rJsWV8aIa-l/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/rJsWV8aIa-l/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": [
				"Logic",
				"Food",
				"Fun",
				"Strategy",
				"Physics",
				"HD",
				"Cute",
				"Puzzle"
			]
		},
		"width": 1008,
		"height": 756,
		"colorMuted": "#2b4859",
		"colorVibrant": "#0464a4",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 2290570,
		"hasIntegratedAds": false
	},
	{
		"code": "rkXGK1_L",
		"url": "https://9786.play.gamezop.com/g/rkXGK1_L",
		"name": {
			"en": "Monster Wants Candy"
		},
		"isPortrait": true,
		"description": {
			"en": "Could you help the monster avoid the bombs and snag lots of sweets in this point and click game?"
		},
		"gamePreviews": {
			"en": "https://youtu.be/8A-lTQCfqNM"
		},
		"assets": {
			"cover": "https://static.gamezop.com/rkXGK1_L/cover.jpg",
			"brick": "https://static.gamezop.com/rkXGK1_L/brick.png",
			"thumb": "https://static.gamezop.com/rkXGK1_L/thumb.png",
			"wall": "https://static.gamezop.com/rkXGK1_L/wall.png",
			"square": "https://static.gamezop.com/rkXGK1_L/square.png",
			"screens": [
				"https://static.gamezop.com/rkXGK1_L/game-1.png",
				"https://static.gamezop.com/rkXGK1_L/game-2.png",
				"https://static.gamezop.com/rkXGK1_L/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/rkXGK1_L/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/rkXGK1_L/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": [
				"Adventure",
				"Endless",
				"Food",
				"Kids",
				"Cute"
			]
		},
		"width": 640,
		"height": 960,
		"colorMuted": "#58435c",
		"colorVibrant": "#864f3f",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 1313435,
		"hasIntegratedAds": false
	},
	{
		"code": "mfuw6HsxP",
		"url": "https://9786.play.gamezop.com/g/mfuw6HsxP",
		"name": {
			"en": "Templok"
		},
		"isPortrait": true,
		"description": {
			"en": "Who are you, oh mysterious traveler? Are you the chosen one, the destined Unraveler? Chasing secrets of Templok: the Sunken City so spectacular? Line up the jumbled gems, to smash them with your Excalibur!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/mfuw6HsxP/cover.jpg",
			"brick": "https://static.gamezop.com/mfuw6HsxP/brick.png",
			"thumb": "https://static.gamezop.com/mfuw6HsxP/thumb.png",
			"wall": "https://static.gamezop.com/mfuw6HsxP/wall.png",
			"square": "https://static.gamezop.com/mfuw6HsxP/square.png",
			"screens": [
				"https://static.gamezop.com/mfuw6HsxP/game-1.png",
				"https://static.gamezop.com/mfuw6HsxP/game-2.png",
				"https://static.gamezop.com/mfuw6HsxP/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/mfuw6HsxP/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/mfuw6HsxP/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": []
		},
		"width": 768,
		"height": 1024,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 833642,
		"hasIntegratedAds": false
	},
	{
		"code": "BJ-ZsT2zOeZ",
		"url": "https://9786.play.gamezop.com/g/BJ-ZsT2zOeZ",
		"name": {
			"en": "One More Flight"
		},
		"isPortrait": false,
		"description": {
			"en": "Can you fly through the obstacles the first time, or will you need one more flight?"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/BJ-ZsT2zOeZ/cover.jpg",
			"brick": "https://static.gamezop.com/BJ-ZsT2zOeZ/brick.png",
			"thumb": "https://static.gamezop.com/BJ-ZsT2zOeZ/thumb.png",
			"wall": "https://static.gamezop.com/BJ-ZsT2zOeZ/wall.png",
			"square": "https://static.gamezop.com/BJ-ZsT2zOeZ/square.png",
			"screens": [
				"https://static.gamezop.com/BJ-ZsT2zOeZ/game-1.png",
				"https://static.gamezop.com/BJ-ZsT2zOeZ/game-2.png",
				"https://static.gamezop.com/BJ-ZsT2zOeZ/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/BJ-ZsT2zOeZ/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/BJ-ZsT2zOeZ/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": [
				"Boys",
				"Fun",
				"Kids",
				"Physics",
				"Racing",
				"Level-based"
			]
		},
		"width": 854,
		"height": 480,
		"colorMuted": "#6f513c",
		"colorVibrant": "#a75435",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 8795794,
		"hasIntegratedAds": false
	},
	{
		"code": "B1gBpzJwqJQ",
		"url": "https://9786.play.gamezop.com/g/B1gBpzJwqJQ",
		"name": {
			"en": "Pirate Hunt"
		},
		"isPortrait": false,
		"description": {
			"en": "Protect your waters from the notorious pirates by hunting them one by one, but spare the hostages and keep an eye out for the bonus!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/yTNEEmKBRW8"
		},
		"assets": {
			"cover": "https://static.gamezop.com/B1gBpzJwqJQ/cover.jpg",
			"brick": "https://static.gamezop.com/B1gBpzJwqJQ/brick.png",
			"thumb": "https://static.gamezop.com/B1gBpzJwqJQ/thumb.png",
			"wall": "https://static.gamezop.com/B1gBpzJwqJQ/wall.png",
			"square": "https://static.gamezop.com/B1gBpzJwqJQ/square.png",
			"screens": [
				"https://static.gamezop.com/B1gBpzJwqJQ/game-1.png",
				"https://static.gamezop.com/B1gBpzJwqJQ/game-2.png",
				"https://static.gamezop.com/B1gBpzJwqJQ/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/B1gBpzJwqJQ/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/B1gBpzJwqJQ/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Action"
			]
		},
		"tags": {
			"en": []
		},
		"width": 804,
		"height": 452,
		"colorMuted": "#c15777",
		"colorVibrant": "#a43c5c",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 9640849,
		"hasIntegratedAds": false
	},
	{
		"code": "HJ-72IFXyg",
		"url": "https://9786.play.gamezop.com/g/HJ-72IFXyg",
		"name": {
			"en": "Stay On The Road"
		},
		"isPortrait": false,
		"description": {
			"en": "A single track, coins to collect, and difficult corners to drift on and save the driver's life."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/HJ-72IFXyg/cover.jpg",
			"brick": "https://static.gamezop.com/HJ-72IFXyg/brick.png",
			"thumb": "https://static.gamezop.com/HJ-72IFXyg/thumb.png",
			"wall": "https://static.gamezop.com/HJ-72IFXyg/wall.png",
			"square": "https://static.gamezop.com/HJ-72IFXyg/square.png",
			"screens": [
				"https://static.gamezop.com/HJ-72IFXyg/game-1.png",
				"https://static.gamezop.com/HJ-72IFXyg/game-2.png",
				"https://static.gamezop.com/HJ-72IFXyg/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/HJ-72IFXyg/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/HJ-72IFXyg/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Arcade"
			]
		},
		"tags": {
			"en": [
				"Boys",
				"Endless",
				"Racing",
				"Arcade",
				"Cars",
				"Difficult"
			]
		},
		"width": 800,
		"height": 450,
		"colorMuted": "#414c34",
		"colorVibrant": "#223c4a",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 21307496,
		"hasIntegratedAds": false
	},
	{
		"code": "B1JBaM1D9y7",
		"url": "https://9786.play.gamezop.com/g/B1JBaM1D9y7",
		"name": {
			"en": "Colour Chase"
		},
		"isPortrait": true,
		"description": {
			"en": "See beautiful landscapes unfold as you navigate the twists and turns of these endless roads: just make sure you only clash with balls of your own colour."
		},
		"gamePreviews": {
			"en": "https://youtu.be/UGsPvDxHOqU"
		},
		"assets": {
			"cover": "https://static.gamezop.com/B1JBaM1D9y7/cover.jpg",
			"brick": "https://static.gamezop.com/B1JBaM1D9y7/brick.png",
			"thumb": "https://static.gamezop.com/B1JBaM1D9y7/thumb.png",
			"wall": "https://static.gamezop.com/B1JBaM1D9y7/wall.png",
			"square": "https://static.gamezop.com/B1JBaM1D9y7/square.png",
			"screens": [
				"https://static.gamezop.com/B1JBaM1D9y7/game-1.png",
				"https://static.gamezop.com/B1JBaM1D9y7/game-2.png",
				"https://static.gamezop.com/B1JBaM1D9y7/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/B1JBaM1D9y7/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/B1JBaM1D9y7/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": []
		},
		"width": 540,
		"height": 960,
		"colorMuted": "#65d0fc",
		"colorVibrant": "#1b2478",
		"privateAllowed": true,
		"rating": 3.4,
		"numberOfRatings": 5,
		"gamePlays": 87081414,
		"hasIntegratedAds": false
	},
	{
		"code": "4ykgM_yzbcg",
		"url": "https://9786.play.gamezop.com/g/4ykgM_yzbcg",
		"name": {
			"en": "Rescue Juliet"
		},
		"isPortrait": true,
		"description": {
			"en": "Help Romeo find his way to Juliet in this puzzle game. Love and mind games have an old connect!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/6btoT2oI3-U"
		},
		"assets": {
			"cover": "https://static.gamezop.com/4ykgM_yzbcg/cover.jpg",
			"brick": "https://static.gamezop.com/4ykgM_yzbcg/brick.png",
			"thumb": "https://static.gamezop.com/4ykgM_yzbcg/thumb.png",
			"wall": "https://static.gamezop.com/4ykgM_yzbcg/wall.png",
			"square": "https://static.gamezop.com/4ykgM_yzbcg/square.png",
			"screens": [
				"https://static.gamezop.com/4ykgM_yzbcg/game-1.png",
				"https://static.gamezop.com/4ykgM_yzbcg/game-2.png",
				"https://static.gamezop.com/4ykgM_yzbcg/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/4ykgM_yzbcg/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/4ykgM_yzbcg/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": [
				"Board",
				"Logic",
				"Fun",
				"Strategy",
				"Minimal",
				"Level-based",
				"HD",
				"Cute",
				"Puzzle"
			]
		},
		"width": 338,
		"height": 600,
		"colorMuted": "#37201f",
		"colorVibrant": "#7c3434",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 4147918,
		"hasIntegratedAds": false
	},
	{
		"code": "SJXbW8smUUx",
		"url": "https://9786.play.gamezop.com/g/SJXbW8smUUx",
		"name": {
			"en": "Quack Hunt"
		},
		"isPortrait": false,
		"description": {
			"en": "Move the scope and shoot the ducks before they fly away from the screen!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/ZNX8tGkDIto"
		},
		"assets": {
			"cover": "https://static.gamezop.com/SJXbW8smUUx/cover.jpg",
			"brick": "https://static.gamezop.com/SJXbW8smUUx/brick.png",
			"thumb": "https://static.gamezop.com/SJXbW8smUUx/thumb.png",
			"wall": "https://static.gamezop.com/SJXbW8smUUx/wall.png",
			"square": "https://static.gamezop.com/SJXbW8smUUx/square.png",
			"screens": [
				"https://static.gamezop.com/SJXbW8smUUx/game-1.png",
				"https://static.gamezop.com/SJXbW8smUUx/game-2.png",
				"https://static.gamezop.com/SJXbW8smUUx/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SJXbW8smUUx/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SJXbW8smUUx/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": [
				"Boys",
				"Classics",
				"Shooting",
				"Fun",
				"Animal",
				"Kids"
			]
		},
		"width": 1500,
		"height": 768,
		"colorMuted": "#459404",
		"colorVibrant": "#3a7c04",
		"privateAllowed": true,
		"rating": 4.75,
		"numberOfRatings": 1,
		"gamePlays": 3643457,
		"hasIntegratedAds": false
	},
	{
		"code": "EJoezu1MWqg",
		"url": "https://9786.play.gamezop.com/g/EJoezu1MWqg",
		"name": {
			"en": "Rock the Dock"
		},
		"isPortrait": true,
		"description": {
			"en": "Stack the containers on the ship to accommodate most number of containers; try being perfect."
		},
		"gamePreviews": {
			"en": "https://youtu.be/YiCevjMUitI"
		},
		"assets": {
			"cover": "https://static.gamezop.com/EJoezu1MWqg/cover.jpg",
			"brick": "https://static.gamezop.com/EJoezu1MWqg/brick.png",
			"thumb": "https://static.gamezop.com/EJoezu1MWqg/thumb.png",
			"wall": "https://static.gamezop.com/EJoezu1MWqg/wall.png",
			"square": "https://static.gamezop.com/EJoezu1MWqg/square.png",
			"screens": [
				"https://static.gamezop.com/EJoezu1MWqg/game-1.png",
				"https://static.gamezop.com/EJoezu1MWqg/game-2.png",
				"https://static.gamezop.com/EJoezu1MWqg/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/EJoezu1MWqg/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/EJoezu1MWqg/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Arcade"
			]
		},
		"tags": {
			"en": [
				"Endless",
				"Exclusive",
				"Fun",
				"Kids",
				"Arcade",
				"HD"
			]
		},
		"width": 338,
		"height": 600,
		"colorMuted": "#434c4d",
		"colorVibrant": "#047ca4",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 14415337,
		"hasIntegratedAds": false
	},
	{
		"code": "rkwCYBZuV",
		"url": "https://9786.play.gamezop.com/g/rkwCYBZuV",
		"name": {
			"en": "Furious Speed"
		},
		"isPortrait": true,
		"description": {
			"en": "Your goal is to get as far as you can. Give the cops a bad time as they try and find their way to you!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/bPC72iU-YNg"
		},
		"assets": {
			"cover": "https://static.gamezop.com/rkwCYBZuV/cover.jpg",
			"brick": "https://static.gamezop.com/rkwCYBZuV/brick.png",
			"thumb": "https://static.gamezop.com/rkwCYBZuV/thumb.png",
			"wall": "https://static.gamezop.com/rkwCYBZuV/wall.png",
			"square": "https://static.gamezop.com/rkwCYBZuV/square.png",
			"screens": [
				"https://static.gamezop.com/rkwCYBZuV/game-1.png",
				"https://static.gamezop.com/rkwCYBZuV/game-2.png",
				"https://static.gamezop.com/rkwCYBZuV/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/rkwCYBZuV/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/rkwCYBZuV/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": [
				"Action",
				"Boys",
				"Endless",
				"Fun",
				"Kids",
				"Racing",
				"Arcade",
				"Cars"
			]
		},
		"width": 400,
		"height": 600,
		"colorMuted": "#733435",
		"colorVibrant": "#55058b",
		"privateAllowed": true,
		"rating": 4.38,
		"numberOfRatings": 4,
		"gamePlays": 43040333,
		"hasIntegratedAds": false
	},
	{
		"code": "41FZfdyG-5x",
		"url": "https://9786.play.gamezop.com/g/41FZfdyG-5x",
		"name": {
			"en": "1212!"
		},
		"isPortrait": true,
		"description": {
			"en": "Don't let the grid fill up! Fit all the pieces in this brain challenging puzzle game!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/gTaW5Vqa-Pg"
		},
		"assets": {
			"cover": "https://static.gamezop.com/41FZfdyG-5x/cover.jpg",
			"brick": "https://static.gamezop.com/41FZfdyG-5x/brick.png",
			"thumb": "https://static.gamezop.com/41FZfdyG-5x/thumb.png",
			"wall": "https://static.gamezop.com/41FZfdyG-5x/wall.png",
			"square": "https://static.gamezop.com/41FZfdyG-5x/square.png",
			"screens": [
				"https://static.gamezop.com/41FZfdyG-5x/game-1.png",
				"https://static.gamezop.com/41FZfdyG-5x/game-2.png",
				"https://static.gamezop.com/41FZfdyG-5x/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/41FZfdyG-5x/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/41FZfdyG-5x/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": [
				"Board",
				"Logic",
				"Classics",
				"Family",
				"Fun",
				"Strategy",
				"Physics",
				"Puzzle"
			]
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#3e443a",
		"colorVibrant": "#732d1d",
		"privateAllowed": true,
		"rating": 2.75,
		"numberOfRatings": 1,
		"gamePlays": 4074941,
		"hasIntegratedAds": false
	},
	{
		"code": "XxembtJs1",
		"url": "https://9786.play.gamezop.com/g/XxembtJs1",
		"name": {
			"en": "Merge The Gems"
		},
		"isPortrait": true,
		"description": {
			"en": "Time's running out, the mine's falling down; merge the gems now, or the miner's gonna drown!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/XxembtJs1/cover.jpg",
			"brick": "https://static.gamezop.com/XxembtJs1/brick.png",
			"thumb": "https://static.gamezop.com/XxembtJs1/thumb.png",
			"wall": "https://static.gamezop.com/XxembtJs1/wall.png",
			"square": "https://static.gamezop.com/XxembtJs1/square.png",
			"screens": [
				"https://static.gamezop.com/XxembtJs1/game-1.png",
				"https://static.gamezop.com/XxembtJs1/game-2.png",
				"https://static.gamezop.com/XxembtJs1/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/XxembtJs1/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/XxembtJs1/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": []
		},
		"width": 768,
		"height": 1024,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 493041,
		"hasIntegratedAds": false
	},
	{
		"code": "H1AN6fkwqJ7",
		"url": "https://9786.play.gamezop.com/g/H1AN6fkwqJ7",
		"name": {
			"en": "Bubble Wipeout"
		},
		"isPortrait": true,
		"description": {
			"en": "Shoot down as many bubbles as you can - aim, match, shoot and burst the same colored bubbles. There is a timer to watch out for!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/pEBhpJN0yQo"
		},
		"assets": {
			"cover": "https://static.gamezop.com/H1AN6fkwqJ7/cover.jpg",
			"brick": "https://static.gamezop.com/H1AN6fkwqJ7/brick.png",
			"thumb": "https://static.gamezop.com/H1AN6fkwqJ7/thumb.png",
			"wall": "https://static.gamezop.com/H1AN6fkwqJ7/wall.png",
			"square": "https://static.gamezop.com/H1AN6fkwqJ7/square.png",
			"screens": [
				"https://static.gamezop.com/H1AN6fkwqJ7/game-1.png",
				"https://static.gamezop.com/H1AN6fkwqJ7/game-2.png",
				"https://static.gamezop.com/H1AN6fkwqJ7/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/H1AN6fkwqJ7/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/H1AN6fkwqJ7/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": []
		},
		"width": 810,
		"height": 1440,
		"colorMuted": "#65d0fc",
		"colorVibrant": "#1b2478",
		"privateAllowed": true,
		"rating": 3.1,
		"numberOfRatings": 5,
		"gamePlays": 117406552,
		"hasIntegratedAds": false
	},
	{
		"code": "ByRkh6XcAB",
		"url": "https://9786.play.gamezop.com/g/ByRkh6XcAB",
		"name": {
			"en": "Car Flip"
		},
		"isPortrait": true,
		"description": {
			"en": "Drive a car on the road: change lanes as obstacles come your way. How hard can it be? Play Car Flip to find out."
		},
		"gamePreviews": {
			"en": "https://youtu.be/YQsgYJbac0A"
		},
		"assets": {
			"cover": "https://static.gamezop.com/ByRkh6XcAB/cover.jpg",
			"brick": "https://static.gamezop.com/ByRkh6XcAB/brick.png",
			"thumb": "https://static.gamezop.com/ByRkh6XcAB/thumb.png",
			"wall": "https://static.gamezop.com/ByRkh6XcAB/wall.png",
			"square": "https://static.gamezop.com/ByRkh6XcAB/square.png",
			"screens": [
				"https://static.gamezop.com/ByRkh6XcAB/game-1.png",
				"https://static.gamezop.com/ByRkh6XcAB/game-2.png",
				"https://static.gamezop.com/ByRkh6XcAB/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/ByRkh6XcAB/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/ByRkh6XcAB/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Arcade"
			]
		},
		"tags": {
			"en": []
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 8334084,
		"hasIntegratedAds": false
	},
	{
		"code": "rkYbNLTIT-x",
		"url": "https://9786.play.gamezop.com/g/rkYbNLTIT-x",
		"name": {
			"en": "Knight Ride"
		},
		"isPortrait": false,
		"description": {
			"en": "The canon's loaded and the knight's ready! Bounce through your flight while avoiding the onslaught of monsters."
		},
		"gamePreviews": {
			"en": "https://youtu.be/hIVrutv2gvM"
		},
		"assets": {
			"cover": "https://static.gamezop.com/rkYbNLTIT-x/cover.jpg",
			"brick": "https://static.gamezop.com/rkYbNLTIT-x/brick.png",
			"thumb": "https://static.gamezop.com/rkYbNLTIT-x/thumb.png",
			"wall": "https://static.gamezop.com/rkYbNLTIT-x/wall.png",
			"square": "https://static.gamezop.com/rkYbNLTIT-x/square.png",
			"screens": [
				"https://static.gamezop.com/rkYbNLTIT-x/game-1.png",
				"https://static.gamezop.com/rkYbNLTIT-x/game-2.png",
				"https://static.gamezop.com/rkYbNLTIT-x/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/rkYbNLTIT-x/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/rkYbNLTIT-x/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": [
				"Adventure",
				"Endless",
				"Kids",
				"Physics",
				"Arcade"
			]
		},
		"width": 800,
		"height": 450,
		"colorMuted": "#543a32",
		"colorVibrant": "#bb2137",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 17824159,
		"hasIntegratedAds": false
	},
	{
		"code": "S1_V6GyP5ym",
		"url": "https://9786.play.gamezop.com/g/S1_V6GyP5ym",
		"name": {
			"en": "Basket Champs"
		},
		"isPortrait": false,
		"description": {
			"en": "Take part in this classical free shots tournament and lead your team to victory. Each round is more thrilling than the last!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/OVniEggm1CQ"
		},
		"assets": {
			"cover": "https://static.gamezop.com/S1_V6GyP5ym/cover.jpg",
			"brick": "https://static.gamezop.com/S1_V6GyP5ym/brick.png",
			"thumb": "https://static.gamezop.com/S1_V6GyP5ym/thumb.png",
			"wall": "https://static.gamezop.com/S1_V6GyP5ym/wall.png",
			"square": "https://static.gamezop.com/S1_V6GyP5ym/square.png",
			"screens": [
				"https://static.gamezop.com/S1_V6GyP5ym/game-1.png",
				"https://static.gamezop.com/S1_V6GyP5ym/game-2.png",
				"https://static.gamezop.com/S1_V6GyP5ym/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/S1_V6GyP5ym/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/S1_V6GyP5ym/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": []
		},
		"width": 600,
		"height": 375,
		"colorMuted": "#3c4454",
		"colorVibrant": "#973608",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 17407997,
		"hasIntegratedAds": false
	},
	{
		"code": "SkQwnwnbK",
		"url": "https://9786.play.gamezop.com/g/SkQwnwnbK",
		"name": {
			"en": "Flexi Snake"
		},
		"isPortrait": true,
		"description": {
			"en": "It's like the old-school snake but super flexi! If you're a snake game fan, this HTML5 game will delight you!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/8RF7k3EMRlc"
		},
		"assets": {
			"cover": "https://static.gamezop.com/SkQwnwnbK/cover.jpg",
			"brick": "https://static.gamezop.com/SkQwnwnbK/brick.png",
			"thumb": "https://static.gamezop.com/SkQwnwnbK/thumb.png",
			"wall": "https://static.gamezop.com/SkQwnwnbK/wall.png",
			"square": "https://static.gamezop.com/SkQwnwnbK/square.png",
			"screens": [
				"https://static.gamezop.com/SkQwnwnbK/game-1.png",
				"https://static.gamezop.com/SkQwnwnbK/game-2.png",
				"https://static.gamezop.com/SkQwnwnbK/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SkQwnwnbK/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SkQwnwnbK/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Arcade"
			]
		},
		"tags": {
			"en": [
				"Endless",
				"Animal",
				"Arcade",
				"Minimal"
			]
		},
		"width": 338,
		"height": 600,
		"colorMuted": "#844c44",
		"colorVibrant": "#845c14",
		"privateAllowed": true,
		"rating": 4.08,
		"numberOfRatings": 3,
		"gamePlays": 37439384,
		"hasIntegratedAds": false
	},
	{
		"code": "WaQryduJa",
		"url": "https://9786.play.gamezop.com/g/WaQryduJa",
		"name": {
			"en": "Football Kickoff"
		},
		"isPortrait": true,
		"description": {
			"en": "Close your eyes, hear the crowds roar: the goal is ahead, your heart wants more! Focus on your target, let the winds soar; remember your destiny to be a legend, to be a lore!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/WaQryduJa/cover.jpg",
			"brick": "https://static.gamezop.com/WaQryduJa/brick.png",
			"thumb": "https://static.gamezop.com/WaQryduJa/thumb.png",
			"wall": "https://static.gamezop.com/WaQryduJa/wall.png",
			"square": "https://static.gamezop.com/WaQryduJa/square.png",
			"screens": [
				"https://static.gamezop.com/WaQryduJa/game-1.png",
				"https://static.gamezop.com/WaQryduJa/game-2.png",
				"https://static.gamezop.com/WaQryduJa/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/WaQryduJa/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/WaQryduJa/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": []
		},
		"width": 768,
		"height": 1024,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 288492,
		"hasIntegratedAds": false
	},
	{
		"code": "HJee0YHZ_E",
		"url": "https://9786.play.gamezop.com/g/HJee0YHZ_E",
		"name": {
			"en": "Penguin Skip"
		},
		"isPortrait": false,
		"description": {
			"en": "Collect as may fish as possible but avoid falling in the icy cold water. Hop your way to endless fun."
		},
		"gamePreviews": {
			"en": "https://youtu.be/Rq92ax8Ib4Q"
		},
		"assets": {
			"cover": "https://static.gamezop.com/HJee0YHZ_E/cover.jpg",
			"brick": "https://static.gamezop.com/HJee0YHZ_E/brick.png",
			"thumb": "https://static.gamezop.com/HJee0YHZ_E/thumb.png",
			"wall": "https://static.gamezop.com/HJee0YHZ_E/wall.png",
			"square": "https://static.gamezop.com/HJee0YHZ_E/square.png",
			"screens": [
				"https://static.gamezop.com/HJee0YHZ_E/game-1.png",
				"https://static.gamezop.com/HJee0YHZ_E/game-2.png",
				"https://static.gamezop.com/HJee0YHZ_E/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/HJee0YHZ_E/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/HJee0YHZ_E/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": [
				"Adventure",
				"Endless",
				"Family",
				"Fun",
				"Animal",
				"Girls",
				"Kids",
				"Physics",
				"Arcade",
				"Cute"
			]
		},
		"width": 800,
		"height": 600,
		"colorMuted": "#22223e",
		"colorVibrant": "#0c0ca8",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 12396787,
		"hasIntegratedAds": false
	},
	{
		"code": "rJsl0KSbuN",
		"url": "https://9786.play.gamezop.com/g/rJsl0KSbuN",
		"name": {
			"en": "Swipe Art Puzzle"
		},
		"isPortrait": false,
		"description": {
			"en": "Move the pieces to recreate some super famous paintings made by old masters in this HTML5 game."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/rJsl0KSbuN/cover.jpg",
			"brick": "https://static.gamezop.com/rJsl0KSbuN/brick.png",
			"thumb": "https://static.gamezop.com/rJsl0KSbuN/thumb.png",
			"wall": "https://static.gamezop.com/rJsl0KSbuN/wall.png",
			"square": "https://static.gamezop.com/rJsl0KSbuN/square.png",
			"screens": [
				"https://static.gamezop.com/rJsl0KSbuN/game-1.png",
				"https://static.gamezop.com/rJsl0KSbuN/game-2.png",
				"https://static.gamezop.com/rJsl0KSbuN/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/rJsl0KSbuN/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/rJsl0KSbuN/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": [
				"Board",
				"Logic",
				"Educa-tional",
				"Family",
				"Girls",
				"Kids",
				"Level-based",
				"Puzzle"
			]
		},
		"width": 800,
		"height": 600,
		"colorMuted": "#523c67",
		"colorVibrant": "#4a729a",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 1608635,
		"hasIntegratedAds": false
	},
	{
		"code": "wIRrQjVa7",
		"url": "https://9786.play.gamezop.com/g/wIRrQjVa7",
		"name": {
			"en": "Hyperdrive Swinger"
		},
		"isPortrait": true,
		"description": {
			"en": "Slingshot your car in the corners and drift like a pro. Avoid crashing into the walls and score perfect turns that reward more points. Become the Drift King in this addictive and engaging take on drifting!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/wIRrQjVa7/cover.jpg",
			"brick": "https://static.gamezop.com/wIRrQjVa7/brick.png",
			"thumb": "https://static.gamezop.com/wIRrQjVa7/thumb.png",
			"wall": "https://static.gamezop.com/wIRrQjVa7/wall.png",
			"square": "https://static.gamezop.com/wIRrQjVa7/square.png",
			"screens": [
				"https://static.gamezop.com/wIRrQjVa7/game-1.png",
				"https://static.gamezop.com/wIRrQjVa7/game-2.png",
				"https://static.gamezop.com/wIRrQjVa7/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/wIRrQjVa7/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/wIRrQjVa7/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": []
		},
		"width": 540,
		"height": 1160,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 498618,
		"hasIntegratedAds": false
	},
	{
		"code": "Bk9ynTQqCB",
		"url": "https://9786.play.gamezop.com/g/Bk9ynTQqCB",
		"name": {
			"en": "Archery Champs"
		},
		"isPortrait": true,
		"description": {
			"en": "Here's the most fun online archery game for you! Play against thousands of online players 1 on 1. Choose from multiple bows, arrows, and sights as you go for the bullseye!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/Bk9ynTQqCB/cover.jpg",
			"brick": "https://static.gamezop.com/Bk9ynTQqCB/brick.png",
			"thumb": "https://static.gamezop.com/Bk9ynTQqCB/thumb.png",
			"wall": "https://static.gamezop.com/Bk9ynTQqCB/wall.png",
			"square": "https://static.gamezop.com/Bk9ynTQqCB/square.png",
			"screens": [
				"https://static.gamezop.com/Bk9ynTQqCB/game-1.png",
				"https://static.gamezop.com/Bk9ynTQqCB/game-2.png",
				"https://static.gamezop.com/Bk9ynTQqCB/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/Bk9ynTQqCB/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/Bk9ynTQqCB/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": []
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": false,
		"rating": 4,
		"numberOfRatings": 1,
		"gamePlays": 7459085,
		"hasIntegratedAds": false
	},
	{
		"code": "r1xZyhTQ50r",
		"url": "https://9786.play.gamezop.com/g/r1xZyhTQ50r",
		"name": {
			"en": "Dunk Draw"
		},
		"isPortrait": true,
		"description": {
			"en": "Draw lines and make sure the balls fall in the right hoops. Be quick, you have to act fast or you lose."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/r1xZyhTQ50r/cover.jpg",
			"brick": "https://static.gamezop.com/r1xZyhTQ50r/brick.png",
			"thumb": "https://static.gamezop.com/r1xZyhTQ50r/thumb.png",
			"wall": "https://static.gamezop.com/r1xZyhTQ50r/wall.png",
			"square": "https://static.gamezop.com/r1xZyhTQ50r/square.png",
			"screens": [
				"https://static.gamezop.com/r1xZyhTQ50r/game-1.png",
				"https://static.gamezop.com/r1xZyhTQ50r/game-2.png",
				"https://static.gamezop.com/r1xZyhTQ50r/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/r1xZyhTQ50r/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/r1xZyhTQ50r/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Arcade"
			]
		},
		"tags": {
			"en": []
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 2,
		"numberOfRatings": 1,
		"gamePlays": 7992955,
		"hasIntegratedAds": true
	},
	{
		"code": "4y6efOyf-5g",
		"url": "https://9786.play.gamezop.com/g/4y6efOyf-5g",
		"name": {
			"en": "Bouncing Beasts"
		},
		"isPortrait": true,
		"description": {
			"en": "Help the animals hop from one twig to the other, without letting the rings touch the wood!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/043jC1nLJ64"
		},
		"assets": {
			"cover": "https://static.gamezop.com/4y6efOyf-5g/cover.jpg",
			"brick": "https://static.gamezop.com/4y6efOyf-5g/brick.png",
			"thumb": "https://static.gamezop.com/4y6efOyf-5g/thumb.png",
			"wall": "https://static.gamezop.com/4y6efOyf-5g/wall.png",
			"square": "https://static.gamezop.com/4y6efOyf-5g/square.png",
			"screens": [
				"https://static.gamezop.com/4y6efOyf-5g/game-1.png",
				"https://static.gamezop.com/4y6efOyf-5g/game-2.png",
				"https://static.gamezop.com/4y6efOyf-5g/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/4y6efOyf-5g/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/4y6efOyf-5g/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Arcade"
			]
		},
		"tags": {
			"en": [
				"Adventure",
				"Endless",
				"Exclusive",
				"Fun",
				"Animal",
				"Kids",
				"Arcade",
				"Cute"
			]
		},
		"width": 400,
		"height": 600,
		"colorMuted": "#5c3c2c",
		"colorVibrant": "#946418",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 42488344,
		"hasIntegratedAds": false
	},
	{
		"code": "xqO4nZ6Kt",
		"url": "https://9786.play.gamezop.com/g/xqO4nZ6Kt",
		"name": {
			"en": "Chef Tycoon"
		},
		"isPortrait": true,
		"description": {
			"en": "Chef Tycoon, a game so fine: Cook, and manage, and endlessly dine! Delight customers with dishes divine. Play now, let your success shine!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/xqO4nZ6Kt/cover.jpg",
			"brick": "https://static.gamezop.com/xqO4nZ6Kt/brick.png",
			"thumb": "https://static.gamezop.com/xqO4nZ6Kt/thumb.png",
			"wall": "https://static.gamezop.com/xqO4nZ6Kt/wall.png",
			"square": "https://static.gamezop.com/xqO4nZ6Kt/square.png",
			"screens": [
				"https://static.gamezop.com/xqO4nZ6Kt/game-1.png",
				"https://static.gamezop.com/xqO4nZ6Kt/game-2.png",
				"https://static.gamezop.com/xqO4nZ6Kt/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/xqO4nZ6Kt/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/xqO4nZ6Kt/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": []
		},
		"width": 768,
		"height": 1360,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 386611,
		"hasIntegratedAds": true
	},
	{
		"code": "SyIZjp3GulZ",
		"url": "https://9786.play.gamezop.com/g/SyIZjp3GulZ",
		"name": {
			"en": "Black Jack Grid"
		},
		"isPortrait": true,
		"description": {
			"en": "Here's Black Jack with a puzzling twist. Arrange cards horizontally and vertically to bring their sum to 21!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/vTBFDmqsglo"
		},
		"assets": {
			"cover": "https://static.gamezop.com/SyIZjp3GulZ/cover.jpg",
			"brick": "https://static.gamezop.com/SyIZjp3GulZ/brick.png",
			"thumb": "https://static.gamezop.com/SyIZjp3GulZ/thumb.png",
			"wall": "https://static.gamezop.com/SyIZjp3GulZ/wall.png",
			"square": "https://static.gamezop.com/SyIZjp3GulZ/square.png",
			"screens": [
				"https://static.gamezop.com/SyIZjp3GulZ/game-1.png",
				"https://static.gamezop.com/SyIZjp3GulZ/game-2.png",
				"https://static.gamezop.com/SyIZjp3GulZ/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SyIZjp3GulZ/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SyIZjp3GulZ/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": [
				"Board",
				"Logic",
				"Cards",
				"Strategy",
				"Puzzle",
				"Casino"
			]
		},
		"width": 640,
		"height": 1136,
		"colorMuted": "#312f50",
		"colorVibrant": "#6b1919",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 1333705,
		"hasIntegratedAds": false
	},
	{
		"code": "ryRWrDaNPF",
		"url": "https://9786.play.gamezop.com/g/ryRWrDaNPF",
		"name": {
			"en": "Dodgy"
		},
		"isPortrait": true,
		"description": {
			"en": "Dodge the incoming fireballs as they come hurling towards you from all four directions!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/AaNBxgRPgPw"
		},
		"assets": {
			"cover": "https://static.gamezop.com/ryRWrDaNPF/cover.jpg",
			"brick": "https://static.gamezop.com/ryRWrDaNPF/brick.png",
			"thumb": "https://static.gamezop.com/ryRWrDaNPF/thumb.png",
			"wall": "https://static.gamezop.com/ryRWrDaNPF/wall.png",
			"square": "https://static.gamezop.com/ryRWrDaNPF/square.png",
			"screens": [
				"https://static.gamezop.com/ryRWrDaNPF/game-1.png",
				"https://static.gamezop.com/ryRWrDaNPF/game-2.png",
				"https://static.gamezop.com/ryRWrDaNPF/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/ryRWrDaNPF/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/ryRWrDaNPF/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Arcade"
			]
		},
		"tags": {
			"en": [
				"Endless",
				"Family",
				"Fun",
				"Arcade",
				"Minimal"
			]
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#3e3c4c",
		"colorVibrant": "#8f446c",
		"privateAllowed": true,
		"rating": 4.75,
		"numberOfRatings": 1,
		"gamePlays": 1990179,
		"hasIntegratedAds": false
	},
	{
		"code": "SkRWoanGOx",
		"url": "https://9786.play.gamezop.com/g/SkRWoanGOx",
		"name": {
			"en": "Catch-a-pult"
		},
		"isPortrait": true,
		"description": {
			"en": "Catapult the balls from one launcher to another. Rebounds bring extra points!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/k5XnP6qa2aU"
		},
		"assets": {
			"cover": "https://static.gamezop.com/SkRWoanGOx/cover.jpg",
			"brick": "https://static.gamezop.com/SkRWoanGOx/brick.png",
			"thumb": "https://static.gamezop.com/SkRWoanGOx/thumb.png",
			"wall": "https://static.gamezop.com/SkRWoanGOx/wall.png",
			"square": "https://static.gamezop.com/SkRWoanGOx/square.png",
			"screens": [
				"https://static.gamezop.com/SkRWoanGOx/game-1.png",
				"https://static.gamezop.com/SkRWoanGOx/game-2.png",
				"https://static.gamezop.com/SkRWoanGOx/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SkRWoanGOx/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SkRWoanGOx/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": [
				"Endless",
				"Shooting",
				"Fun",
				"Physics"
			]
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#5c5c5c",
		"colorVibrant": "#745e0f",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 14942538,
		"hasIntegratedAds": false
	},
	{
		"code": "rkHuVQ-1K",
		"url": "https://9786.play.gamezop.com/g/rkHuVQ-1K",
		"name": {
			"en": "Illuminate"
		},
		"isPortrait": true,
		"description": {
			"en": "Light up your brains and every room with a limited amount of lamps and reflectors in this puzzle game."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/rkHuVQ-1K/cover.jpg",
			"brick": "https://static.gamezop.com/rkHuVQ-1K/brick.png",
			"thumb": "https://static.gamezop.com/rkHuVQ-1K/thumb.png",
			"wall": "https://static.gamezop.com/rkHuVQ-1K/wall.png",
			"square": "https://static.gamezop.com/rkHuVQ-1K/square.png",
			"screens": [
				"https://static.gamezop.com/rkHuVQ-1K/game-1.png",
				"https://static.gamezop.com/rkHuVQ-1K/game-2.png",
				"https://static.gamezop.com/rkHuVQ-1K/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/rkHuVQ-1K/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/rkHuVQ-1K/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": [
				"Logic",
				"Family",
				"Fun",
				"Strategy",
				"Pixel",
				"Level-based",
				"Puzzle"
			]
		},
		"width": 320,
		"height": 480,
		"colorMuted": "#744d34",
		"colorVibrant": "#7c5434",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 355879,
		"hasIntegratedAds": false
	},
	{
		"code": "NyM_JGWcx",
		"url": "https://9786.play.gamezop.com/g/NyM_JGWcx",
		"name": {
			"en": "2048"
		},
		"isPortrait": true,
		"description": {
			"en": "Slide tiles in any direction in this mathematical puzzle game to make identical digits converge."
		},
		"gamePreviews": {
			"en": "https://youtu.be/CWbB_0sVWlY"
		},
		"assets": {
			"cover": "https://static.gamezop.com/NyM_JGWcx/cover.jpg",
			"brick": "https://static.gamezop.com/NyM_JGWcx/brick.png",
			"thumb": "https://static.gamezop.com/NyM_JGWcx/thumb.png",
			"wall": "https://static.gamezop.com/NyM_JGWcx/wall.png",
			"square": "https://static.gamezop.com/NyM_JGWcx/square.png",
			"screens": [
				"https://static.gamezop.com/NyM_JGWcx/game-1.png",
				"https://static.gamezop.com/NyM_JGWcx/game-2.png",
				"https://static.gamezop.com/NyM_JGWcx/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/NyM_JGWcx/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/NyM_JGWcx/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": [
				"Logic",
				"Classics",
				"Educa-tional",
				"Family",
				"Girls",
				"Minimal",
				"Puzzle"
			]
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#967c02",
		"colorVibrant": "#826c02",
		"privateAllowed": true,
		"rating": 3.25,
		"numberOfRatings": 3,
		"gamePlays": 20678003,
		"hasIntegratedAds": false
	},
	{
		"code": "Hy2xAKHb_V",
		"url": "https://9786.play.gamezop.com/g/Hy2xAKHb_V",
		"name": {
			"en": "Troll Boxing"
		},
		"isPortrait": false,
		"description": {
			"en": "Trolls are taking to the ring for a Championship! Jump right into the action in this boxing game."
		},
		"gamePreviews": {
			"en": "https://youtu.be/Zy8wP7AH4Jg"
		},
		"assets": {
			"cover": "https://static.gamezop.com/Hy2xAKHb_V/cover.jpg",
			"brick": "https://static.gamezop.com/Hy2xAKHb_V/brick.png",
			"thumb": "https://static.gamezop.com/Hy2xAKHb_V/thumb.png",
			"wall": "https://static.gamezop.com/Hy2xAKHb_V/wall.png",
			"square": "https://static.gamezop.com/Hy2xAKHb_V/square.png",
			"screens": [
				"https://static.gamezop.com/Hy2xAKHb_V/game-1.png",
				"https://static.gamezop.com/Hy2xAKHb_V/game-2.png",
				"https://static.gamezop.com/Hy2xAKHb_V/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/Hy2xAKHb_V/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/Hy2xAKHb_V/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Action"
			]
		},
		"tags": {
			"en": [
				"Action",
				"Adventure",
				"Boys",
				"Fun",
				"Strategy",
				"Zombie",
				"Level-based",
				"Difficult"
			]
		},
		"width": 800,
		"height": 600,
		"colorMuted": "#4a3922",
		"colorVibrant": "#78291a",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 2825710,
		"hasIntegratedAds": false
	},
	{
		"code": "S1Clo6hMdeb",
		"url": "https://9786.play.gamezop.com/g/S1Clo6hMdeb",
		"name": {
			"en": "Jumpy Ape Joe"
		},
		"isPortrait": false,
		"description": {
			"en": "Help Joe eat up all the bananas! Don't forget to keep an eye out for that ticking timer."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/S1Clo6hMdeb/cover.jpg",
			"brick": "https://static.gamezop.com/S1Clo6hMdeb/brick.png",
			"thumb": "https://static.gamezop.com/S1Clo6hMdeb/thumb.png",
			"wall": "https://static.gamezop.com/S1Clo6hMdeb/wall.png",
			"square": "https://static.gamezop.com/S1Clo6hMdeb/square.png",
			"screens": [
				"https://static.gamezop.com/S1Clo6hMdeb/game-1.png",
				"https://static.gamezop.com/S1Clo6hMdeb/game-2.png",
				"https://static.gamezop.com/S1Clo6hMdeb/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/S1Clo6hMdeb/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/S1Clo6hMdeb/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": [
				"Adventure",
				"Food",
				"Fun",
				"Animal",
				"Kids",
				"Physics",
				"Arcade",
				"Level-based"
			]
		},
		"width": 854,
		"height": 480,
		"colorMuted": "#322840",
		"colorVibrant": "#9a4805",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 3795361,
		"hasIntegratedAds": false
	},
	{
		"code": "HkSWia3f_g-",
		"url": "https://9786.play.gamezop.com/g/HkSWia3f_g-",
		"name": {
			"en": "Coin Grab"
		},
		"isPortrait": true,
		"description": {
			"en": "Little piggy has found himself in Bitcoinland! Help him hoof through the levels by collecting all coins."
		},
		"gamePreviews": {
			"en": "https://youtu.be/l_xwWw8CI0c"
		},
		"assets": {
			"cover": "https://static.gamezop.com/HkSWia3f_g-/cover.jpg",
			"brick": "https://static.gamezop.com/HkSWia3f_g-/brick.png",
			"thumb": "https://static.gamezop.com/HkSWia3f_g-/thumb.png",
			"wall": "https://static.gamezop.com/HkSWia3f_g-/wall.png",
			"square": "https://static.gamezop.com/HkSWia3f_g-/square.png",
			"screens": [
				"https://static.gamezop.com/HkSWia3f_g-/game-1.png",
				"https://static.gamezop.com/HkSWia3f_g-/game-2.png",
				"https://static.gamezop.com/HkSWia3f_g-/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/HkSWia3f_g-/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/HkSWia3f_g-/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": [
				"Logic",
				"Kids",
				"Level-based",
				"Cute",
				"Puzzle"
			]
		},
		"width": 640,
		"height": 1136,
		"colorMuted": "#191115",
		"colorVibrant": "#027c82",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 3354853,
		"hasIntegratedAds": false
	},
	{
		"code": "Hkh7azyv9km",
		"url": "https://9786.play.gamezop.com/g/Hkh7azyv9km",
		"name": {
			"en": "Junior Chess"
		},
		"isPortrait": true,
		"description": {
			"en": "Sit back, relax and enjoy a game of chess with interesting characters! Fight the Red King with the Blue King and show off your chess moves!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/Hkh7azyv9km/cover.jpg",
			"brick": "https://static.gamezop.com/Hkh7azyv9km/brick.png",
			"thumb": "https://static.gamezop.com/Hkh7azyv9km/thumb.png",
			"wall": "https://static.gamezop.com/Hkh7azyv9km/wall.png",
			"square": "https://static.gamezop.com/Hkh7azyv9km/square.png",
			"screens": [
				"https://static.gamezop.com/Hkh7azyv9km/game-1.png",
				"https://static.gamezop.com/Hkh7azyv9km/game-2.png",
				"https://static.gamezop.com/Hkh7azyv9km/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/Hkh7azyv9km/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/Hkh7azyv9km/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": []
		},
		"width": 768,
		"height": 1024,
		"colorMuted": "#355566",
		"colorVibrant": "#2c436c",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 2448375,
		"hasIntegratedAds": false
	},
	{
		"code": "HJP4afkvqJQ",
		"url": "https://9786.play.gamezop.com/g/HJP4afkvqJQ",
		"name": {
			"en": "City Cricket"
		},
		"isPortrait": false,
		"description": {
			"en": "Pick your city, bring out your batting gloves and show your Cricket skills. Let's see you chase that target!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/kb6-B9UObJ4"
		},
		"assets": {
			"cover": "https://static.gamezop.com/HJP4afkvqJQ/cover.jpg",
			"brick": "https://static.gamezop.com/HJP4afkvqJQ/brick.png",
			"thumb": "https://static.gamezop.com/HJP4afkvqJQ/thumb.png",
			"wall": "https://static.gamezop.com/HJP4afkvqJQ/wall.png",
			"square": "https://static.gamezop.com/HJP4afkvqJQ/square.png",
			"screens": [
				"https://static.gamezop.com/HJP4afkvqJQ/game-1.png",
				"https://static.gamezop.com/HJP4afkvqJQ/game-2.png",
				"https://static.gamezop.com/HJP4afkvqJQ/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/HJP4afkvqJQ/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/HJP4afkvqJQ/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": []
		},
		"width": 1280,
		"height": 720,
		"colorMuted": "#395262",
		"colorVibrant": "#1c3c69",
		"privateAllowed": true,
		"rating": 4.02,
		"numberOfRatings": 11,
		"gamePlays": 464824622,
		"hasIntegratedAds": false
	},
	{
		"code": "H1TbVUa8aWe",
		"url": "https://9786.play.gamezop.com/g/H1TbVUa8aWe",
		"name": {
			"en": "Pebble Boy"
		},
		"isPortrait": false,
		"description": {
			"en": "Hungry dragons have caged the birds of the realm. Join Pebble Boy, the Orc, to set them free."
		},
		"gamePreviews": {
			"en": "https://youtu.be/xb6tOOuF8FI"
		},
		"assets": {
			"cover": "https://static.gamezop.com/H1TbVUa8aWe/cover.jpg",
			"brick": "https://static.gamezop.com/H1TbVUa8aWe/brick.png",
			"thumb": "https://static.gamezop.com/H1TbVUa8aWe/thumb.png",
			"wall": "https://static.gamezop.com/H1TbVUa8aWe/wall.png",
			"square": "https://static.gamezop.com/H1TbVUa8aWe/square.png",
			"screens": [
				"https://static.gamezop.com/H1TbVUa8aWe/game-1.png",
				"https://static.gamezop.com/H1TbVUa8aWe/game-2.png",
				"https://static.gamezop.com/H1TbVUa8aWe/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/H1TbVUa8aWe/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/H1TbVUa8aWe/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": [
				"Adventure",
				"Logic",
				"Family",
				"Shooting",
				"Fun",
				"Strategy",
				"Physics",
				"HD",
				"Cute",
				"Puzzle"
			]
		},
		"width": 1008,
		"height": 756,
		"colorMuted": "#585a32",
		"colorVibrant": "#a72a11",
		"privateAllowed": true,
		"rating": 4.75,
		"numberOfRatings": 1,
		"gamePlays": 1906573,
		"hasIntegratedAds": false
	},
	{
		"code": "ry3vtunu",
		"url": "https://9786.play.gamezop.com/g/ry3vtunu",
		"name": {
			"en": "Battle Fish"
		},
		"isPortrait": true,
		"description": {
			"en": "Grow fish to convert monsters into friends! Addictive arcade game with funny sea creatures."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/ry3vtunu/cover.jpg",
			"brick": "https://static.gamezop.com/ry3vtunu/brick.png",
			"thumb": "https://static.gamezop.com/ry3vtunu/thumb.png",
			"wall": "https://static.gamezop.com/ry3vtunu/wall.png",
			"square": "https://static.gamezop.com/ry3vtunu/square.png",
			"screens": [
				"https://static.gamezop.com/ry3vtunu/game-1.png",
				"https://static.gamezop.com/ry3vtunu/game-2.png",
				"https://static.gamezop.com/ry3vtunu/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/ry3vtunu/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/ry3vtunu/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": [
				"Adventure",
				"Logic",
				"Family",
				"Fun",
				"Animal",
				"Girls",
				"Arcade",
				"Level-based",
				"Cute"
			]
		},
		"width": 717,
		"height": 600,
		"colorMuted": "#445c80",
		"colorVibrant": "#048c8c",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 3532610,
		"hasIntegratedAds": false
	},
	{
		"code": "BkXW1a__",
		"url": "https://9786.play.gamezop.com/g/BkXW1a__",
		"name": {
			"en": "Jimbo Jump"
		},
		"isPortrait": true,
		"description": {
			"en": "Jump from floor to floor, avoid the ghosts! How high can you climb in this endless game?"
		},
		"gamePreviews": {
			"en": "https://youtu.be/qGOkhx3zR4I"
		},
		"assets": {
			"cover": "https://static.gamezop.com/BkXW1a__/cover.jpg",
			"brick": "https://static.gamezop.com/BkXW1a__/brick.png",
			"thumb": "https://static.gamezop.com/BkXW1a__/thumb.png",
			"wall": "https://static.gamezop.com/BkXW1a__/wall.png",
			"square": "https://static.gamezop.com/BkXW1a__/square.png",
			"screens": [
				"https://static.gamezop.com/BkXW1a__/game-1.png",
				"https://static.gamezop.com/BkXW1a__/game-2.png",
				"https://static.gamezop.com/BkXW1a__/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/BkXW1a__/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/BkXW1a__/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": [
				"Adventure",
				"Boys",
				"Logic",
				"Endless",
				"Family",
				"Girls",
				"Kids",
				"Arcade",
				"HD",
				"Cute"
			]
		},
		"width": 640,
		"height": 800,
		"colorMuted": "#88513e",
		"colorVibrant": "#075183",
		"privateAllowed": true,
		"rating": 4.25,
		"numberOfRatings": 3,
		"gamePlays": 162980758,
		"hasIntegratedAds": false
	},
	{
		"code": "r1z-eQ8nq",
		"url": "https://9786.play.gamezop.com/g/r1z-eQ8nq",
		"name": {
			"en": "Road Safety"
		},
		"isPortrait": true,
		"description": {
			"en": "Help people across the streets, watch out for gaps in traffic and make sure nobody gets hit by cars."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/r1z-eQ8nq/cover.jpg",
			"brick": "https://static.gamezop.com/r1z-eQ8nq/brick.png",
			"thumb": "https://static.gamezop.com/r1z-eQ8nq/thumb.png",
			"wall": "https://static.gamezop.com/r1z-eQ8nq/wall.png",
			"square": "https://static.gamezop.com/r1z-eQ8nq/square.png",
			"screens": [
				"https://static.gamezop.com/r1z-eQ8nq/game-1.png",
				"https://static.gamezop.com/r1z-eQ8nq/game-2.png",
				"https://static.gamezop.com/r1z-eQ8nq/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/r1z-eQ8nq/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/r1z-eQ8nq/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": [
				"Logic",
				"Strategy",
				"Racing",
				"Arcade",
				"Level-based",
				"Cars"
			]
		},
		"width": 525,
		"height": 600,
		"colorMuted": "#5e392c",
		"colorVibrant": "#0839be",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 2250361,
		"hasIntegratedAds": false
	},
	{
		"code": "H1lZem8hq",
		"url": "https://9786.play.gamezop.com/g/H1lZem8hq",
		"name": {
			"en": "Juicy Dash"
		},
		"isPortrait": true,
		"description": {
			"en": "Juicy, tasty, match-3 madness. Prove your skills and match as many fruits as possible."
		},
		"gamePreviews": {
			"en": "https://youtu.be/i4G5ncMgpJI"
		},
		"assets": {
			"cover": "https://static.gamezop.com/H1lZem8hq/cover.jpg",
			"brick": "https://static.gamezop.com/H1lZem8hq/brick.png",
			"thumb": "https://static.gamezop.com/H1lZem8hq/thumb.png",
			"wall": "https://static.gamezop.com/H1lZem8hq/wall.png",
			"square": "https://static.gamezop.com/H1lZem8hq/square.png",
			"screens": [
				"https://static.gamezop.com/H1lZem8hq/game-1.png",
				"https://static.gamezop.com/H1lZem8hq/game-2.png",
				"https://static.gamezop.com/H1lZem8hq/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/H1lZem8hq/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/H1lZem8hq/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": [
				"Logic",
				"Food",
				"Fun",
				"Strategy",
				"Match-3",
				"Time Mgmt.",
				"Level-based",
				"Cute",
				"Puzzle"
			]
		},
		"width": 466,
		"height": 600,
		"colorMuted": "#689008",
		"colorVibrant": "#7cab0a",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 10875901,
		"hasIntegratedAds": false
	},
	{
		"code": "SkF7yhp7q0B",
		"url": "https://9786.play.gamezop.com/g/SkF7yhp7q0B",
		"name": {
			"en": "Darts"
		},
		"isPortrait": true,
		"description": {
			"en": "It's time to reveal the master of Darts! Focus, Aim, Precision... Bullseye!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/SkF7yhp7q0B/cover.jpg",
			"brick": "https://static.gamezop.com/SkF7yhp7q0B/brick.png",
			"thumb": "https://static.gamezop.com/SkF7yhp7q0B/thumb.png",
			"wall": "https://static.gamezop.com/SkF7yhp7q0B/wall.png",
			"square": "https://static.gamezop.com/SkF7yhp7q0B/square.png",
			"screens": [
				"https://static.gamezop.com/SkF7yhp7q0B/game-1.png",
				"https://static.gamezop.com/SkF7yhp7q0B/game-2.png",
				"https://static.gamezop.com/SkF7yhp7q0B/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SkF7yhp7q0B/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SkF7yhp7q0B/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": []
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": false,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 4699623,
		"hasIntegratedAds": false
	},
	{
		"code": "B1fSpMkP51m",
		"url": "https://9786.play.gamezop.com/g/B1fSpMkP51m",
		"name": {
			"en": "Bottle Shoot"
		},
		"isPortrait": true,
		"description": {
			"en": "Bring out the cowboy in you and keep a level head while you shoot down as many bottles as you can. Keep an eye out for the red ones!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/awXjOHHJc60"
		},
		"assets": {
			"cover": "https://static.gamezop.com/B1fSpMkP51m/cover.jpg",
			"brick": "https://static.gamezop.com/B1fSpMkP51m/brick.png",
			"thumb": "https://static.gamezop.com/B1fSpMkP51m/thumb.png",
			"wall": "https://static.gamezop.com/B1fSpMkP51m/wall.png",
			"square": "https://static.gamezop.com/B1fSpMkP51m/square.png",
			"screens": [
				"https://static.gamezop.com/B1fSpMkP51m/game-1.png",
				"https://static.gamezop.com/B1fSpMkP51m/game-2.png",
				"https://static.gamezop.com/B1fSpMkP51m/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/B1fSpMkP51m/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/B1fSpMkP51m/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Action"
			]
		},
		"tags": {
			"en": []
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#5b843c",
		"colorVibrant": "#5a6c2c",
		"privateAllowed": true,
		"rating": 3.01,
		"numberOfRatings": 64,
		"gamePlays": 271573563,
		"hasIntegratedAds": false
	},
	{
		"code": "Cg8EBuMp7",
		"url": "https://9786.play.gamezop.com/g/Cg8EBuMp7",
		"name": {
			"en": "Hill Top Tanks"
		},
		"isPortrait": false,
		"description": {
			"en": "Conflicts have reached the literal peaks, hill tops are stationed with Tanks so sleek. This war will be won by super fast streak, not by someone weak or meek."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/Cg8EBuMp7/cover.jpg",
			"brick": "https://static.gamezop.com/Cg8EBuMp7/brick.png",
			"thumb": "https://static.gamezop.com/Cg8EBuMp7/thumb.png",
			"wall": "https://static.gamezop.com/Cg8EBuMp7/wall.png",
			"square": "https://static.gamezop.com/Cg8EBuMp7/square.png",
			"screens": [
				"https://static.gamezop.com/Cg8EBuMp7/game-1.png",
				"https://static.gamezop.com/Cg8EBuMp7/game-2.png",
				"https://static.gamezop.com/Cg8EBuMp7/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/Cg8EBuMp7/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/Cg8EBuMp7/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Action"
			]
		},
		"tags": {
			"en": []
		},
		"width": 1400,
		"height": 630,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 351027,
		"hasIntegratedAds": false
	},
	{
		"code": "BJdZ-8iXULl",
		"url": "https://9786.play.gamezop.com/g/BJdZ-8iXULl",
		"name": {
			"en": "Nut Physics"
		},
		"isPortrait": false,
		"description": {
			"en": "It's winter time and a cute squirrel is gathering nuts to combat the cold. Can you help her?"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/BJdZ-8iXULl/cover.jpg",
			"brick": "https://static.gamezop.com/BJdZ-8iXULl/brick.png",
			"thumb": "https://static.gamezop.com/BJdZ-8iXULl/thumb.png",
			"wall": "https://static.gamezop.com/BJdZ-8iXULl/wall.png",
			"square": "https://static.gamezop.com/BJdZ-8iXULl/square.png",
			"screens": [
				"https://static.gamezop.com/BJdZ-8iXULl/game-1.png",
				"https://static.gamezop.com/BJdZ-8iXULl/game-2.png",
				"https://static.gamezop.com/BJdZ-8iXULl/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/BJdZ-8iXULl/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/BJdZ-8iXULl/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": [
				"Food",
				"Animal",
				"Kids",
				"Physics",
				"Level-based",
				"Cute"
			]
		},
		"width": 800,
		"height": 450,
		"colorMuted": "#428e55",
		"colorVibrant": "#4d2b0f",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 846852,
		"hasIntegratedAds": false
	},
	{
		"code": "BkzmafyPqJm",
		"url": "https://9786.play.gamezop.com/g/BkzmafyPqJm",
		"name": {
			"en": "Cricket Gunda"
		},
		"isPortrait": true,
		"description": {
			"en": "You've got 3 wickets and an audience to impress! Go at it! Make as many runs as you can. Be careful of the bombs and eggs?!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/GOJEoqphJqo"
		},
		"assets": {
			"cover": "https://static.gamezop.com/BkzmafyPqJm/cover.jpg",
			"brick": "https://static.gamezop.com/BkzmafyPqJm/brick.png",
			"thumb": "https://static.gamezop.com/BkzmafyPqJm/thumb.png",
			"wall": "https://static.gamezop.com/BkzmafyPqJm/wall.png",
			"square": "https://static.gamezop.com/BkzmafyPqJm/square.png",
			"screens": [
				"https://static.gamezop.com/BkzmafyPqJm/game-1.png",
				"https://static.gamezop.com/BkzmafyPqJm/game-2.png",
				"https://static.gamezop.com/BkzmafyPqJm/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/BkzmafyPqJm/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/BkzmafyPqJm/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": []
		},
		"width": 480,
		"height": 640,
		"colorMuted": "#324a52",
		"colorVibrant": "#095a6e",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 6,
		"gamePlays": 108633354,
		"hasIntegratedAds": false
	},
	{
		"code": "mKZZW9NXW",
		"url": "https://9786.play.gamezop.com/g/mKZZW9NXW",
		"name": {
			"en": "Fruity Fiesta"
		},
		"isPortrait": true,
		"description": {
			"en": "It's time for a juicy, jivy Fiesta of Fruits. Merge the fruits to get the elusive Melons. Collect them all to become the fruit baron!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/mKZZW9NXW/cover.jpg",
			"brick": "https://static.gamezop.com/mKZZW9NXW/brick.png",
			"thumb": "https://static.gamezop.com/mKZZW9NXW/thumb.png",
			"wall": "https://static.gamezop.com/mKZZW9NXW/wall.png",
			"square": "https://static.gamezop.com/mKZZW9NXW/square.png",
			"screens": [
				"https://static.gamezop.com/mKZZW9NXW/game-1.png",
				"https://static.gamezop.com/mKZZW9NXW/game-2.png",
				"https://static.gamezop.com/mKZZW9NXW/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/mKZZW9NXW/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/mKZZW9NXW/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Arcade"
			]
		},
		"tags": {
			"en": []
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 11109110,
		"hasIntegratedAds": false
	},
	{
		"code": "ry8RYrWu4",
		"url": "https://9786.play.gamezop.com/g/ry8RYrWu4",
		"name": {
			"en": "Evil Wyrm"
		},
		"isPortrait": false,
		"description": {
			"en": "Move carefully, find gems, and exit before the fire-spitting Wyrm can obliterate your existence!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/EfFTCJMpAdc"
		},
		"assets": {
			"cover": "https://static.gamezop.com/ry8RYrWu4/cover.jpg",
			"brick": "https://static.gamezop.com/ry8RYrWu4/brick.png",
			"thumb": "https://static.gamezop.com/ry8RYrWu4/thumb.png",
			"wall": "https://static.gamezop.com/ry8RYrWu4/wall.png",
			"square": "https://static.gamezop.com/ry8RYrWu4/square.png",
			"screens": [
				"https://static.gamezop.com/ry8RYrWu4/game-1.png",
				"https://static.gamezop.com/ry8RYrWu4/game-2.png",
				"https://static.gamezop.com/ry8RYrWu4/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/ry8RYrWu4/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/ry8RYrWu4/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Action"
			]
		},
		"tags": {
			"en": [
				"Action",
				"Adventure",
				"Boys",
				"Fun",
				"Strategy",
				"Arcade",
				"Level-based"
			]
		},
		"width": 800,
		"height": 471,
		"colorMuted": "#68584f",
		"colorVibrant": "#463081",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 4605757,
		"hasIntegratedAds": false
	},
	{
		"code": "BkdJhTX50B",
		"url": "https://9786.play.gamezop.com/g/BkdJhTX50B",
		"name": {
			"en": "Bowling Stars"
		},
		"isPortrait": true,
		"description": {
			"en": "Enjoy the best Bowling game online — compete with thousands of players! Let's see how many pins you can knock down!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/BkdJhTX50B/cover.jpg",
			"brick": "https://static.gamezop.com/BkdJhTX50B/brick.png",
			"thumb": "https://static.gamezop.com/BkdJhTX50B/thumb.png",
			"wall": "https://static.gamezop.com/BkdJhTX50B/wall.png",
			"square": "https://static.gamezop.com/BkdJhTX50B/square.png",
			"screens": [
				"https://static.gamezop.com/BkdJhTX50B/game-1.png",
				"https://static.gamezop.com/BkdJhTX50B/game-2.png",
				"https://static.gamezop.com/BkdJhTX50B/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/BkdJhTX50B/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/BkdJhTX50B/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": []
		},
		"width": 540,
		"height": 960,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 2.5,
		"numberOfRatings": 1,
		"gamePlays": 19552279,
		"hasIntegratedAds": false
	},
	{
		"code": "B19EafJP9JX",
		"url": "https://9786.play.gamezop.com/g/B19EafJP9JX",
		"name": {
			"en": "Spinning Shooter"
		},
		"isPortrait": true,
		"description": {
			"en": "Test your marksmanship by shooting down boxes that come your way. Beware of surprises!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/TxazrhxxzhU"
		},
		"assets": {
			"cover": "https://static.gamezop.com/B19EafJP9JX/cover.jpg",
			"brick": "https://static.gamezop.com/B19EafJP9JX/brick.png",
			"thumb": "https://static.gamezop.com/B19EafJP9JX/thumb.png",
			"wall": "https://static.gamezop.com/B19EafJP9JX/wall.png",
			"square": "https://static.gamezop.com/B19EafJP9JX/square.png",
			"screens": [
				"https://static.gamezop.com/B19EafJP9JX/game-1.png",
				"https://static.gamezop.com/B19EafJP9JX/game-2.png",
				"https://static.gamezop.com/B19EafJP9JX/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/B19EafJP9JX/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/B19EafJP9JX/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Arcade"
			]
		},
		"tags": {
			"en": []
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#5f4129",
		"colorVibrant": "#883c0c",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 6149420,
		"hasIntegratedAds": false
	},
	{
		"code": "Hk2yhp7cCH",
		"url": "https://9786.play.gamezop.com/g/Hk2yhp7cCH",
		"name": {
			"en": "Tic Tac Toe 11"
		},
		"isPortrait": true,
		"description": {
			"en": "Here's a Tic Tac Toe game with a twist! Play in a 11x11 grid, and match 5 to win - vertically, horizontally or diagonally! Create your own tricks to beat the opponent!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/Hk2yhp7cCH/cover.jpg",
			"brick": "https://static.gamezop.com/Hk2yhp7cCH/brick.png",
			"thumb": "https://static.gamezop.com/Hk2yhp7cCH/thumb.png",
			"wall": "https://static.gamezop.com/Hk2yhp7cCH/wall.png",
			"square": "https://static.gamezop.com/Hk2yhp7cCH/square.png",
			"screens": [
				"https://static.gamezop.com/Hk2yhp7cCH/game-1.png",
				"https://static.gamezop.com/Hk2yhp7cCH/game-2.png",
				"https://static.gamezop.com/Hk2yhp7cCH/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/Hk2yhp7cCH/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/Hk2yhp7cCH/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": []
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": false,
		"rating": 4,
		"numberOfRatings": 1,
		"gamePlays": 12732360,
		"hasIntegratedAds": false
	},
	{
		"code": "H1Tz6z1Dqym",
		"url": "https://9786.play.gamezop.com/g/H1Tz6z1Dqym",
		"name": {
			"en": "Bouncy"
		},
		"isPortrait": true,
		"description": {
			"en": "Bounce off the platforms and make as many jumps as you can in this amazing 3D game!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/TBqLlrE1MuI"
		},
		"assets": {
			"cover": "https://static.gamezop.com/H1Tz6z1Dqym/cover.jpg",
			"brick": "https://static.gamezop.com/H1Tz6z1Dqym/brick.png",
			"thumb": "https://static.gamezop.com/H1Tz6z1Dqym/thumb.png",
			"wall": "https://static.gamezop.com/H1Tz6z1Dqym/wall.png",
			"square": "https://static.gamezop.com/H1Tz6z1Dqym/square.png",
			"screens": [
				"https://static.gamezop.com/H1Tz6z1Dqym/game-1.png",
				"https://static.gamezop.com/H1Tz6z1Dqym/game-2.png",
				"https://static.gamezop.com/H1Tz6z1Dqym/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/H1Tz6z1Dqym/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/H1Tz6z1Dqym/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Arcade"
			]
		},
		"tags": {
			"en": []
		},
		"width": 640,
		"height": 960,
		"colorMuted": "#446444",
		"colorVibrant": "#0c98d6",
		"privateAllowed": true,
		"rating": 2.75,
		"numberOfRatings": 1,
		"gamePlays": 70950858,
		"hasIntegratedAds": false
	},
	{
		"code": "HJD9VMRQa",
		"url": "https://9786.play.gamezop.com/g/HJD9VMRQa",
		"name": {
			"en": "Astro Knot"
		},
		"isPortrait": true,
		"description": {
			"en": "Poor creature is stranded on unexplored land. Hop along to explore a beautiful galactic setup!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/jdbVR-ssjrA"
		},
		"assets": {
			"cover": "https://static.gamezop.com/HJD9VMRQa/cover.jpg",
			"brick": "https://static.gamezop.com/HJD9VMRQa/brick.png",
			"thumb": "https://static.gamezop.com/HJD9VMRQa/thumb.png",
			"wall": "https://static.gamezop.com/HJD9VMRQa/wall.png",
			"square": "https://static.gamezop.com/HJD9VMRQa/square.png",
			"screens": [
				"https://static.gamezop.com/HJD9VMRQa/game-1.png",
				"https://static.gamezop.com/HJD9VMRQa/game-2.png",
				"https://static.gamezop.com/HJD9VMRQa/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/HJD9VMRQa/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/HJD9VMRQa/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": [
				"Adventure",
				"Endless",
				"Exclusive",
				"Fun",
				"Space",
				"Arcade",
				"HD",
				"Cute"
			]
		},
		"width": 400,
		"height": 600,
		"colorMuted": "#233f4b",
		"colorVibrant": "#176dc1",
		"privateAllowed": true,
		"rating": 2.75,
		"numberOfRatings": 1,
		"gamePlays": 30242436,
		"hasIntegratedAds": false
	},
	{
		"code": "rkb--Io78Ux",
		"url": "https://9786.play.gamezop.com/g/rkb--Io78Ux",
		"name": {
			"en": "Tiny Tripper"
		},
		"isPortrait": true,
		"description": {
			"en": "The little trippers are out on an adventure. Change shapes and colors as you spiral across beautiful planetary landscapes."
		},
		"gamePreviews": {
			"en": "https://youtu.be/17xQIsIadPQ"
		},
		"assets": {
			"cover": "https://static.gamezop.com/rkb--Io78Ux/cover.jpg",
			"brick": "https://static.gamezop.com/rkb--Io78Ux/brick.png",
			"thumb": "https://static.gamezop.com/rkb--Io78Ux/thumb.png",
			"wall": "https://static.gamezop.com/rkb--Io78Ux/wall.png",
			"square": "https://static.gamezop.com/rkb--Io78Ux/square.png",
			"screens": [
				"https://static.gamezop.com/rkb--Io78Ux/game-1.png",
				"https://static.gamezop.com/rkb--Io78Ux/game-2.png",
				"https://static.gamezop.com/rkb--Io78Ux/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/rkb--Io78Ux/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/rkb--Io78Ux/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": [
				"Endless",
				"Family",
				"Fun",
				"Animal",
				"Kids",
				"Arcade",
				"HD",
				"Cute"
			]
		},
		"width": 338,
		"height": 600,
		"colorMuted": "#6f3d45",
		"colorVibrant": "#015a82",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 2139365,
		"hasIntegratedAds": false
	},
	{
		"code": "rkWemI2q",
		"url": "https://9786.play.gamezop.com/g/rkWemI2q",
		"name": {
			"en": "Fancy Diver"
		},
		"isPortrait": true,
		"description": {
			"en": "Swim from the ocean up to the water surface! Make way by removing groups of matching blocks!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/rkWemI2q/cover.jpg",
			"brick": "https://static.gamezop.com/rkWemI2q/brick.png",
			"thumb": "https://static.gamezop.com/rkWemI2q/thumb.png",
			"wall": "https://static.gamezop.com/rkWemI2q/wall.png",
			"square": "https://static.gamezop.com/rkWemI2q/square.png",
			"screens": [
				"https://static.gamezop.com/rkWemI2q/game-1.png",
				"https://static.gamezop.com/rkWemI2q/game-2.png",
				"https://static.gamezop.com/rkWemI2q/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/rkWemI2q/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/rkWemI2q/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": [
				"Logic",
				"Fun",
				"Strategy",
				"Match-3",
				"Level-based",
				"Puzzle"
			]
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#696f39",
		"colorVibrant": "#bc6806",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 1212465,
		"hasIntegratedAds": false
	},
	{
		"code": "r1xZj62MOe-",
		"url": "https://9786.play.gamezop.com/g/r1xZj62MOe-",
		"name": {
			"en": "Aquatic Rescue"
		},
		"isPortrait": false,
		"description": {
			"en": "Tickle your brains as your find the best way to rescue these little water creatures from their bubbles!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/r1xZj62MOe-/cover.jpg",
			"brick": "https://static.gamezop.com/r1xZj62MOe-/brick.png",
			"thumb": "https://static.gamezop.com/r1xZj62MOe-/thumb.png",
			"wall": "https://static.gamezop.com/r1xZj62MOe-/wall.png",
			"square": "https://static.gamezop.com/r1xZj62MOe-/square.png",
			"screens": [
				"https://static.gamezop.com/r1xZj62MOe-/game-1.png",
				"https://static.gamezop.com/r1xZj62MOe-/game-2.png",
				"https://static.gamezop.com/r1xZj62MOe-/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/r1xZj62MOe-/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/r1xZj62MOe-/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": [
				"Logic",
				"Fun",
				"Animal",
				"Kids",
				"Strategy",
				"Physics",
				"Arcade",
				"Level-based"
			]
		},
		"width": 854,
		"height": 480,
		"colorMuted": "#7f6b4a",
		"colorVibrant": "#9c4f16",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 1283118,
		"hasIntegratedAds": false
	},
	{
		"code": "BJlMwGUY_yl",
		"url": "https://9786.play.gamezop.com/g/BJlMwGUY_yl",
		"name": {
			"en": "Sheriff's Wrath"
		},
		"isPortrait": false,
		"description": {
			"en": "How dare these dacoits wreak havoc in your county! Pull out your gun and shoot those goons down."
		},
		"gamePreviews": {
			"en": "https://youtu.be/-I96JeZ_QNk"
		},
		"assets": {
			"cover": "https://static.gamezop.com/BJlMwGUY_yl/cover.jpg",
			"brick": "https://static.gamezop.com/BJlMwGUY_yl/brick.png",
			"thumb": "https://static.gamezop.com/BJlMwGUY_yl/thumb.png",
			"wall": "https://static.gamezop.com/BJlMwGUY_yl/wall.png",
			"square": "https://static.gamezop.com/BJlMwGUY_yl/square.png",
			"screens": [
				"https://static.gamezop.com/BJlMwGUY_yl/game-1.png",
				"https://static.gamezop.com/BJlMwGUY_yl/game-2.png",
				"https://static.gamezop.com/BJlMwGUY_yl/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/BJlMwGUY_yl/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/BJlMwGUY_yl/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Action"
			]
		},
		"tags": {
			"en": [
				"Action",
				"Adventure",
				"Shooting",
				"Level-based"
			]
		},
		"width": 800,
		"height": 600,
		"colorMuted": "#5b582e",
		"colorVibrant": "#714a14",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 2936307,
		"hasIntegratedAds": false
	},
	{
		"code": "4kZgf_1z-9l",
		"url": "https://9786.play.gamezop.com/g/4kZgf_1z-9l",
		"name": {
			"en": "Lane Battles"
		},
		"isPortrait": false,
		"description": {
			"en": "Wrong-way driver on your lane? Be quick with the lane changes for you blink and you miss!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/_ew2gong51o"
		},
		"assets": {
			"cover": "https://static.gamezop.com/4kZgf_1z-9l/cover.jpg",
			"brick": "https://static.gamezop.com/4kZgf_1z-9l/brick.png",
			"thumb": "https://static.gamezop.com/4kZgf_1z-9l/thumb.png",
			"wall": "https://static.gamezop.com/4kZgf_1z-9l/wall.png",
			"square": "https://static.gamezop.com/4kZgf_1z-9l/square.png",
			"screens": [
				"https://static.gamezop.com/4kZgf_1z-9l/game-1.png",
				"https://static.gamezop.com/4kZgf_1z-9l/game-2.png",
				"https://static.gamezop.com/4kZgf_1z-9l/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/4kZgf_1z-9l/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/4kZgf_1z-9l/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": [
				"Boys",
				"Endless",
				"Exclusive",
				"Fun",
				"Racing",
				"Arcade",
				"Cars"
			]
		},
		"width": 800,
		"height": 450,
		"colorMuted": "#603b42",
		"colorVibrant": "#156392",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 3620923,
		"hasIntegratedAds": false
	},
	{
		"code": "hgempP8Sc",
		"url": "https://9786.play.gamezop.com/g/hgempP8Sc",
		"name": {
			"en": "Pool Master"
		},
		"isPortrait": true,
		"description": {
			"en": "Get ready to play the most exciting Pool game ever! With modes like Classic, Time Trial, and Practice Mode, your fun will end never."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/hgempP8Sc/cover.jpg",
			"brick": "https://static.gamezop.com/hgempP8Sc/brick.png",
			"thumb": "https://static.gamezop.com/hgempP8Sc/thumb.png",
			"wall": "https://static.gamezop.com/hgempP8Sc/wall.png",
			"square": "https://static.gamezop.com/hgempP8Sc/square.png",
			"screens": [
				"https://static.gamezop.com/hgempP8Sc/game-1.png",
				"https://static.gamezop.com/hgempP8Sc/game-2.png",
				"https://static.gamezop.com/hgempP8Sc/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/hgempP8Sc/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/hgempP8Sc/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": []
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": false,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 1882362,
		"hasIntegratedAds": true
	},
	{
		"code": "HkO-wf8F_Jx",
		"url": "https://9786.play.gamezop.com/g/HkO-wf8F_Jx",
		"name": {
			"en": "Jumpy: The First Jumper"
		},
		"isPortrait": true,
		"description": {
			"en": "Dodge all the random spikes that get in your way to become the best jumper known to early men!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/gx-tHUHW7wk"
		},
		"assets": {
			"cover": "https://static.gamezop.com/HkO-wf8F_Jx/cover.jpg",
			"brick": "https://static.gamezop.com/HkO-wf8F_Jx/brick.png",
			"thumb": "https://static.gamezop.com/HkO-wf8F_Jx/thumb.png",
			"wall": "https://static.gamezop.com/HkO-wf8F_Jx/wall.png",
			"square": "https://static.gamezop.com/HkO-wf8F_Jx/square.png",
			"screens": [
				"https://static.gamezop.com/HkO-wf8F_Jx/game-1.png",
				"https://static.gamezop.com/HkO-wf8F_Jx/game-2.png",
				"https://static.gamezop.com/HkO-wf8F_Jx/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/HkO-wf8F_Jx/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/HkO-wf8F_Jx/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": [
				"Adventure",
				"Boys",
				"Endless",
				"Fun",
				"Arcade",
				"Pixel",
				"Minimal",
				"Cute"
			]
		},
		"width": 400,
		"height": 600,
		"colorMuted": "#423243",
		"colorVibrant": "#3a061a",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 2528576,
		"hasIntegratedAds": false
	},
	{
		"code": "HJeM-LsQI8x",
		"url": "https://9786.play.gamezop.com/g/HJeM-LsQI8x",
		"name": {
			"en": "Cuby Zap"
		},
		"isPortrait": false,
		"description": {
			"en": "Shoot the red cubes until your lives run out. But be careful: don't shoot the blue ones!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/QFpU-v8MmCk"
		},
		"assets": {
			"cover": "https://static.gamezop.com/HJeM-LsQI8x/cover.jpg",
			"brick": "https://static.gamezop.com/HJeM-LsQI8x/brick.png",
			"thumb": "https://static.gamezop.com/HJeM-LsQI8x/thumb.png",
			"wall": "https://static.gamezop.com/HJeM-LsQI8x/wall.png",
			"square": "https://static.gamezop.com/HJeM-LsQI8x/square.png",
			"screens": [
				"https://static.gamezop.com/HJeM-LsQI8x/game-1.png",
				"https://static.gamezop.com/HJeM-LsQI8x/game-2.png",
				"https://static.gamezop.com/HJeM-LsQI8x/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/HJeM-LsQI8x/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/HJeM-LsQI8x/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Action"
			]
		},
		"tags": {
			"en": [
				"Arcade",
				"Shooter",
				"Fun",
				"Boys",
				"Minimal",
				"Endless"
			]
		},
		"width": 800,
		"height": 450,
		"colorMuted": "#566777",
		"colorVibrant": "#837d33",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 4014610,
		"hasIntegratedAds": true
	},
	{
		"code": "rk7G6Mkvcym",
		"url": "https://9786.play.gamezop.com/g/rk7G6Mkvcym",
		"name": {
			"en": "Street Dunkies"
		},
		"isPortrait": false,
		"description": {
			"en": "Swing your arms and dunk away! Use the ball to bounce yourself. Play short and quick street basketball matches with beautiful characters and backdrops!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/rk7G6Mkvcym/cover.jpg",
			"brick": "https://static.gamezop.com/rk7G6Mkvcym/brick.png",
			"thumb": "https://static.gamezop.com/rk7G6Mkvcym/thumb.png",
			"wall": "https://static.gamezop.com/rk7G6Mkvcym/wall.png",
			"square": "https://static.gamezop.com/rk7G6Mkvcym/square.png",
			"screens": [
				"https://static.gamezop.com/rk7G6Mkvcym/game-1.png",
				"https://static.gamezop.com/rk7G6Mkvcym/game-2.png",
				"https://static.gamezop.com/rk7G6Mkvcym/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/rk7G6Mkvcym/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/rk7G6Mkvcym/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": []
		},
		"width": 1280,
		"height": 720,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 4,
		"numberOfRatings": 1,
		"gamePlays": 355014,
		"hasIntegratedAds": false
	},
	{
		"code": "4JcZiV3XWql",
		"url": "https://9786.play.gamezop.com/g/4JcZiV3XWql",
		"name": {
			"en": "Rafting Adventure"
		},
		"isPortrait": true,
		"description": {
			"en": "Prevent the young man from slamming into the shores of this gorgeous but deadly canyon."
		},
		"gamePreviews": {
			"en": "https://youtu.be/gTwjidPTz0M"
		},
		"assets": {
			"cover": "https://static.gamezop.com/4JcZiV3XWql/cover.jpg",
			"brick": "https://static.gamezop.com/4JcZiV3XWql/brick.png",
			"thumb": "https://static.gamezop.com/4JcZiV3XWql/thumb.png",
			"wall": "https://static.gamezop.com/4JcZiV3XWql/wall.png",
			"square": "https://static.gamezop.com/4JcZiV3XWql/square.png",
			"screens": [
				"https://static.gamezop.com/4JcZiV3XWql/game-1.png",
				"https://static.gamezop.com/4JcZiV3XWql/game-2.png",
				"https://static.gamezop.com/4JcZiV3XWql/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/4JcZiV3XWql/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/4JcZiV3XWql/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": [
				"Adventure",
				"Boys",
				"Endless",
				"Family",
				"Food",
				"Animal",
				"Kids",
				"Sports",
				"Arcade",
				"Difficult"
			]
		},
		"width": 353,
		"height": 600,
		"colorMuted": "#394452",
		"colorVibrant": "#b73910",
		"privateAllowed": true,
		"rating": 2.75,
		"numberOfRatings": 3,
		"gamePlays": 21726248,
		"hasIntegratedAds": false
	},
	{
		"code": "Hkww3v3-F",
		"url": "https://9786.play.gamezop.com/g/Hkww3v3-F",
		"name": {
			"en": "Fly Safe"
		},
		"isPortrait": true,
		"description": {
			"en": "A fast-dodging, easy to play but hard to master bird game. Collect as many coins as possible."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/Hkww3v3-F/cover.jpg",
			"brick": "https://static.gamezop.com/Hkww3v3-F/brick.png",
			"thumb": "https://static.gamezop.com/Hkww3v3-F/thumb.png",
			"wall": "https://static.gamezop.com/Hkww3v3-F/wall.png",
			"square": "https://static.gamezop.com/Hkww3v3-F/square.png",
			"screens": [
				"https://static.gamezop.com/Hkww3v3-F/game-1.png",
				"https://static.gamezop.com/Hkww3v3-F/game-2.png",
				"https://static.gamezop.com/Hkww3v3-F/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/Hkww3v3-F/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/Hkww3v3-F/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Arcade"
			]
		},
		"tags": {
			"en": [
				"Adventure",
				"Endless",
				"Animal",
				"Arcade",
				"Minimal",
				"Cute"
			]
		},
		"width": 338,
		"height": 600,
		"colorMuted": "#604841",
		"colorVibrant": "#806404",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 8751450,
		"hasIntegratedAds": false
	},
	{
		"code": "H1pbZUoXIUl",
		"url": "https://9786.play.gamezop.com/g/H1pbZUoXIUl",
		"name": {
			"en": "Save Your Pinky"
		},
		"isPortrait": true,
		"description": {
			"en": "Aim the knife between your fingers in this game. No margin for error: inaccuracy causes pain."
		},
		"gamePreviews": {
			"en": "https://youtu.be/ise9sV-Ss4k"
		},
		"assets": {
			"cover": "https://static.gamezop.com/H1pbZUoXIUl/cover.jpg",
			"brick": "https://static.gamezop.com/H1pbZUoXIUl/brick.png",
			"thumb": "https://static.gamezop.com/H1pbZUoXIUl/thumb.png",
			"wall": "https://static.gamezop.com/H1pbZUoXIUl/wall.png",
			"square": "https://static.gamezop.com/H1pbZUoXIUl/square.png",
			"screens": [
				"https://static.gamezop.com/H1pbZUoXIUl/game-1.png",
				"https://static.gamezop.com/H1pbZUoXIUl/game-2.png",
				"https://static.gamezop.com/H1pbZUoXIUl/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/H1pbZUoXIUl/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/H1pbZUoXIUl/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": [
				"Arcade",
				"Classics",
				"Fun",
				"Endless"
			]
		},
		"width": 338,
		"height": 600,
		"colorMuted": "#594732",
		"colorVibrant": "#6c5a34",
		"privateAllowed": true,
		"rating": 3.5,
		"numberOfRatings": 2,
		"gamePlays": 11353170,
		"hasIntegratedAds": false
	},
	{
		"code": "SyXuN7W1F",
		"url": "https://9786.play.gamezop.com/g/SyXuN7W1F",
		"name": {
			"en": "Rocket Man"
		},
		"isPortrait": true,
		"description": {
			"en": "Rush through the maze before your fuel runs out. Fly as long as you can in this endless game."
		},
		"gamePreviews": {
			"en": "https://youtu.be/cC_6kAP3yBE"
		},
		"assets": {
			"cover": "https://static.gamezop.com/SyXuN7W1F/cover.jpg",
			"brick": "https://static.gamezop.com/SyXuN7W1F/brick.png",
			"thumb": "https://static.gamezop.com/SyXuN7W1F/thumb.png",
			"wall": "https://static.gamezop.com/SyXuN7W1F/wall.png",
			"square": "https://static.gamezop.com/SyXuN7W1F/square.png",
			"screens": [
				"https://static.gamezop.com/SyXuN7W1F/game-1.png",
				"https://static.gamezop.com/SyXuN7W1F/game-2.png",
				"https://static.gamezop.com/SyXuN7W1F/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SyXuN7W1F/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SyXuN7W1F/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Action"
			]
		},
		"tags": {
			"en": [
				"Adventure",
				"Endless",
				"Arcade",
				"Pixel",
				"Minimal"
			]
		},
		"width": 320,
		"height": 480,
		"colorMuted": "#132424",
		"colorVibrant": "#108484",
		"privateAllowed": true,
		"rating": 4.25,
		"numberOfRatings": 6,
		"gamePlays": 35426761,
		"hasIntegratedAds": false
	},
	{
		"code": "S1A0FBWuE",
		"url": "https://9786.play.gamezop.com/g/S1A0FBWuE",
		"name": {
			"en": "Minigolf Kingdom"
		},
		"isPortrait": false,
		"description": {
			"en": "Make sure the ball gets into the hole as quick as possible. You get limited chances in this golf game."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/S1A0FBWuE/cover.jpg",
			"brick": "https://static.gamezop.com/S1A0FBWuE/brick.png",
			"thumb": "https://static.gamezop.com/S1A0FBWuE/thumb.png",
			"wall": "https://static.gamezop.com/S1A0FBWuE/wall.png",
			"square": "https://static.gamezop.com/S1A0FBWuE/square.png",
			"screens": [
				"https://static.gamezop.com/S1A0FBWuE/game-1.png",
				"https://static.gamezop.com/S1A0FBWuE/game-2.png",
				"https://static.gamezop.com/S1A0FBWuE/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/S1A0FBWuE/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/S1A0FBWuE/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": [
				"Boys",
				"Logic",
				"Family",
				"Fun",
				"Strategy",
				"Physics",
				"Sports",
				"Level-based"
			]
		},
		"width": 800,
		"height": 600,
		"colorMuted": "#2c4844",
		"colorVibrant": "#1c5c06",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 876899,
		"hasIntegratedAds": false
	},
	{
		"code": "p7HOjYF4O",
		"url": "https://9786.play.gamezop.com/g/p7HOjYF4O",
		"name": {
			"en": "Rampage Racer"
		},
		"isPortrait": false,
		"description": {
			"en": "Get on a high speed rush through the traffic. Evade obstacles to break your own record!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/p7HOjYF4O/cover.jpg",
			"brick": "https://static.gamezop.com/p7HOjYF4O/brick.png",
			"thumb": "https://static.gamezop.com/p7HOjYF4O/thumb.png",
			"wall": "https://static.gamezop.com/p7HOjYF4O/wall.png",
			"square": "https://static.gamezop.com/p7HOjYF4O/square.png",
			"screens": [
				"https://static.gamezop.com/p7HOjYF4O/game-1.png",
				"https://static.gamezop.com/p7HOjYF4O/game-2.png",
				"https://static.gamezop.com/p7HOjYF4O/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/p7HOjYF4O/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/p7HOjYF4O/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": []
		},
		"width": 1160,
		"height": 540,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": false,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 9079976,
		"hasIntegratedAds": false
	},
	{
		"code": "N1tgz_kzW5x",
		"url": "https://9786.play.gamezop.com/g/N1tgz_kzW5x",
		"name": {
			"en": "Aliens Attack"
		},
		"isPortrait": false,
		"description": {
			"en": "Blast extraterrestrials out of the sky in this action game! Be careful of the Boss Fights!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/t6Y7EgO5xKk"
		},
		"assets": {
			"cover": "https://static.gamezop.com/N1tgz_kzW5x/cover.jpg",
			"brick": "https://static.gamezop.com/N1tgz_kzW5x/brick.png",
			"thumb": "https://static.gamezop.com/N1tgz_kzW5x/thumb.png",
			"wall": "https://static.gamezop.com/N1tgz_kzW5x/wall.png",
			"square": "https://static.gamezop.com/N1tgz_kzW5x/square.png",
			"screens": [
				"https://static.gamezop.com/N1tgz_kzW5x/game-1.png",
				"https://static.gamezop.com/N1tgz_kzW5x/game-2.png",
				"https://static.gamezop.com/N1tgz_kzW5x/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/N1tgz_kzW5x/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/N1tgz_kzW5x/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Action"
			]
		},
		"tags": {
			"en": [
				"Action",
				"Boys",
				"Shooting",
				"Fun",
				"Strategy",
				"Space",
				"Zombie",
				"Level-based",
				"Story-based"
			]
		},
		"width": 800,
		"height": 600,
		"colorMuted": "#32345c",
		"colorVibrant": "#902b1d",
		"privateAllowed": true,
		"rating": 4.75,
		"numberOfRatings": 1,
		"gamePlays": 6765579,
		"hasIntegratedAds": false
	},
	{
		"code": "SyO94GA7p",
		"url": "https://9786.play.gamezop.com/g/SyO94GA7p",
		"name": {
			"en": "Super Goalie Auditions"
		},
		"isPortrait": false,
		"description": {
			"en": "Ten different levels with increasing difficulty to test your super reflexes as a goalkeeper."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/SyO94GA7p/cover.jpg",
			"brick": "https://static.gamezop.com/SyO94GA7p/brick.png",
			"thumb": "https://static.gamezop.com/SyO94GA7p/thumb.png",
			"wall": "https://static.gamezop.com/SyO94GA7p/wall.png",
			"square": "https://static.gamezop.com/SyO94GA7p/square.png",
			"screens": [
				"https://static.gamezop.com/SyO94GA7p/game-1.png",
				"https://static.gamezop.com/SyO94GA7p/game-2.png",
				"https://static.gamezop.com/SyO94GA7p/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SyO94GA7p/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SyO94GA7p/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": [
				"Boys",
				"Soccer",
				"Kids",
				"Sports",
				"Level-based"
			]
		},
		"width": 1280,
		"height": 768,
		"colorMuted": "#324c5c",
		"colorVibrant": "#3c8814",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 5449905,
		"hasIntegratedAds": false
	},
	{
		"code": "H1IEpMJP917",
		"url": "https://9786.play.gamezop.com/g/H1IEpMJP917",
		"name": {
			"en": "Plane Fight"
		},
		"isPortrait": false,
		"description": {
			"en": "Collide with your enemy and push their blocks on to the bomb before they kill you. Bring out the fighter pilot in you!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/Fw1HlqApZRo"
		},
		"assets": {
			"cover": "https://static.gamezop.com/H1IEpMJP917/cover.jpg",
			"brick": "https://static.gamezop.com/H1IEpMJP917/brick.png",
			"thumb": "https://static.gamezop.com/H1IEpMJP917/thumb.png",
			"wall": "https://static.gamezop.com/H1IEpMJP917/wall.png",
			"square": "https://static.gamezop.com/H1IEpMJP917/square.png",
			"screens": [
				"https://static.gamezop.com/H1IEpMJP917/game-1.png",
				"https://static.gamezop.com/H1IEpMJP917/game-2.png",
				"https://static.gamezop.com/H1IEpMJP917/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/H1IEpMJP917/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/H1IEpMJP917/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Action"
			]
		},
		"tags": {
			"en": []
		},
		"width": 1280,
		"height": 720,
		"colorMuted": "#BEA683",
		"colorVibrant": "#41295A",
		"privateAllowed": false,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 3339994,
		"hasIntegratedAds": false
	},
	{
		"code": "Umfd7yvMd",
		"url": "https://9786.play.gamezop.com/g/Umfd7yvMd",
		"name": {
			"en": "Viking Siege"
		},
		"isPortrait": false,
		"description": {
			"en": "Skol! Skol! Skol! Vikings Roll Roll Roll! Stand by the Odin's word'n punch a Hole Hole Hole... No one's gonna cross your land, let them growl growl growl! Not the Elve, not the Dwarf, not even the Troll Troll Troll!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/Umfd7yvMd/cover.jpg",
			"brick": "https://static.gamezop.com/Umfd7yvMd/brick.png",
			"thumb": "https://static.gamezop.com/Umfd7yvMd/thumb.png",
			"wall": "https://static.gamezop.com/Umfd7yvMd/wall.png",
			"square": "https://static.gamezop.com/Umfd7yvMd/square.png",
			"screens": [
				"https://static.gamezop.com/Umfd7yvMd/game-1.png",
				"https://static.gamezop.com/Umfd7yvMd/game-2.png",
				"https://static.gamezop.com/Umfd7yvMd/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/Umfd7yvMd/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/Umfd7yvMd/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": []
		},
		"width": 1024,
		"height": 768,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 35698,
		"hasIntegratedAds": false
	},
	{
		"code": "H1Hgyn6XqAS",
		"url": "https://9786.play.gamezop.com/g/H1Hgyn6XqAS",
		"name": {
			"en": "Carrom Hero"
		},
		"isPortrait": true,
		"description": {
			"en": "Here's the most fun Carrom game online! Play against thousands of players in 2 unique modes: Freestyle and Professional!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/H1Hgyn6XqAS/cover.jpg",
			"brick": "https://static.gamezop.com/H1Hgyn6XqAS/brick.png",
			"thumb": "https://static.gamezop.com/H1Hgyn6XqAS/thumb.png",
			"wall": "https://static.gamezop.com/H1Hgyn6XqAS/wall.png",
			"square": "https://static.gamezop.com/H1Hgyn6XqAS/square.png",
			"screens": [
				"https://static.gamezop.com/H1Hgyn6XqAS/game-1.png",
				"https://static.gamezop.com/H1Hgyn6XqAS/game-2.png",
				"https://static.gamezop.com/H1Hgyn6XqAS/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/H1Hgyn6XqAS/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/H1Hgyn6XqAS/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": []
		},
		"width": 768,
		"height": 1024,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": false,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 139835744,
		"hasIntegratedAds": false
	},
	{
		"code": "on1jVCbBn",
		"url": "https://9786.play.gamezop.com/g/on1jVCbBn",
		"name": {
			"en": "Animal Connection"
		},
		"isPortrait": false,
		"description": {
			"en": "Scattered in the crowd, far from their family: deep in the jungle, the animals look jittery. Help them to find their connection, and they'll go home happily!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/on1jVCbBn/cover.jpg",
			"brick": "https://static.gamezop.com/on1jVCbBn/brick.png",
			"thumb": "https://static.gamezop.com/on1jVCbBn/thumb.png",
			"wall": "https://static.gamezop.com/on1jVCbBn/wall.png",
			"square": "https://static.gamezop.com/on1jVCbBn/square.png",
			"screens": [
				"https://static.gamezop.com/on1jVCbBn/game-1.png",
				"https://static.gamezop.com/on1jVCbBn/game-2.png",
				"https://static.gamezop.com/on1jVCbBn/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/on1jVCbBn/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/on1jVCbBn/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": []
		},
		"width": 1280,
		"height": 768,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 49363,
		"hasIntegratedAds": false
	},
	{
		"code": "HJskh679Cr",
		"url": "https://9786.play.gamezop.com/g/HJskh679Cr",
		"name": {
			"en": "Enchanted Waters"
		},
		"isPortrait": true,
		"description": {
			"en": "Time is of the essence in this riveting maze runner where one wrong step can make you fall into the endless lake! Time your jumps perfectly to get through the maze without plummeting into the endless lake!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/9ErV13O79ck\r"
		},
		"assets": {
			"cover": "https://static.gamezop.com/HJskh679Cr/cover.jpg",
			"brick": "https://static.gamezop.com/HJskh679Cr/brick.png",
			"thumb": "https://static.gamezop.com/HJskh679Cr/thumb.png",
			"wall": "https://static.gamezop.com/HJskh679Cr/wall.png",
			"square": "https://static.gamezop.com/HJskh679Cr/square.png",
			"screens": [
				"https://static.gamezop.com/HJskh679Cr/game-1.png",
				"https://static.gamezop.com/HJskh679Cr/game-2.png",
				"https://static.gamezop.com/HJskh679Cr/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/HJskh679Cr/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/HJskh679Cr/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": []
		},
		"width": 506,
		"height": 900,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 43246200,
		"hasIntegratedAds": false
	},
	{
		"code": "zMxz8LNrp",
		"url": "https://9786.play.gamezop.com/g/zMxz8LNrp",
		"name": {
			"en": "Spell Wizard"
		},
		"isPortrait": true,
		"description": {
			"en": "Pitch your vocabulary and see how many words can you reveal with your spelling wizardry! No time limit, but don't look around."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/zMxz8LNrp/cover.jpg",
			"brick": "https://static.gamezop.com/zMxz8LNrp/brick.png",
			"thumb": "https://static.gamezop.com/zMxz8LNrp/thumb.png",
			"wall": "https://static.gamezop.com/zMxz8LNrp/wall.png",
			"square": "https://static.gamezop.com/zMxz8LNrp/square.png",
			"screens": [
				"https://static.gamezop.com/zMxz8LNrp/game-1.png",
				"https://static.gamezop.com/zMxz8LNrp/game-2.png",
				"https://static.gamezop.com/zMxz8LNrp/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/zMxz8LNrp/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/zMxz8LNrp/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": []
		},
		"width": 1080,
		"height": 1920,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 2,
		"numberOfRatings": 1,
		"gamePlays": 809730,
		"hasIntegratedAds": false
	},
	{
		"code": "PdIZyZNAe",
		"url": "https://9786.play.gamezop.com/g/PdIZyZNAe",
		"name": {
			"en": "Dragon Annihilation"
		},
		"isPortrait": true,
		"description": {
			"en": "These dragons from hell, under the witch's spell, are going to destroy the village you dwell! The only way to repel, is to show them the power of your shell!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/PdIZyZNAe/cover.jpg",
			"brick": "https://static.gamezop.com/PdIZyZNAe/brick.png",
			"thumb": "https://static.gamezop.com/PdIZyZNAe/thumb.png",
			"wall": "https://static.gamezop.com/PdIZyZNAe/wall.png",
			"square": "https://static.gamezop.com/PdIZyZNAe/square.png",
			"screens": [
				"https://static.gamezop.com/PdIZyZNAe/game-1.png",
				"https://static.gamezop.com/PdIZyZNAe/game-2.png",
				"https://static.gamezop.com/PdIZyZNAe/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/PdIZyZNAe/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/PdIZyZNAe/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": []
		},
		"width": 576,
		"height": 1024,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 1538582,
		"hasIntegratedAds": false
	},
	{
		"code": "ByQxJnp7qRB",
		"url": "https://9786.play.gamezop.com/g/ByQxJnp7qRB",
		"name": {
			"en": "ZUNO"
		},
		"isPortrait": false,
		"description": {
			"en": "Just Skip, Reverse, Draw and go Wild to get rid of your last card, And don't wait to jab ZUNO, or else your opponents will make your life hard!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/ByQxJnp7qRB/cover.jpg",
			"brick": "https://static.gamezop.com/ByQxJnp7qRB/brick.png",
			"thumb": "https://static.gamezop.com/ByQxJnp7qRB/thumb.png",
			"wall": "https://static.gamezop.com/ByQxJnp7qRB/wall.png",
			"square": "https://static.gamezop.com/ByQxJnp7qRB/square.png",
			"screens": [
				"https://static.gamezop.com/ByQxJnp7qRB/game-1.png",
				"https://static.gamezop.com/ByQxJnp7qRB/game-2.png",
				"https://static.gamezop.com/ByQxJnp7qRB/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/ByQxJnp7qRB/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/ByQxJnp7qRB/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": []
		},
		"width": 1920,
		"height": 1080,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": false,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 1887929,
		"hasIntegratedAds": false
	},
	{
		"code": "Sk728YXJx",
		"url": "https://9786.play.gamezop.com/g/Sk728YXJx",
		"name": {
			"en": "Pixel Slime"
		},
		"isPortrait": false,
		"description": {
			"en": "Help this slimy green blob to jump over spikes and gaps to reach the exit in each level!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/Sk728YXJx/cover.jpg",
			"brick": "https://static.gamezop.com/Sk728YXJx/brick.png",
			"thumb": "https://static.gamezop.com/Sk728YXJx/thumb.png",
			"wall": "https://static.gamezop.com/Sk728YXJx/wall.png",
			"square": "https://static.gamezop.com/Sk728YXJx/square.png",
			"screens": [
				"https://static.gamezop.com/Sk728YXJx/game-1.png",
				"https://static.gamezop.com/Sk728YXJx/game-2.png",
				"https://static.gamezop.com/Sk728YXJx/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/Sk728YXJx/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/Sk728YXJx/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": [
				"Adventure",
				"Fun",
				"Arcade",
				"Pixel",
				"Minimal",
				"Level-based",
				"Difficult"
			]
		},
		"width": 800,
		"height": 450,
		"colorMuted": "#51582f",
		"colorVibrant": "#5ca404",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 1088746,
		"hasIntegratedAds": false
	},
	{
		"code": "JVhRZNwly",
		"url": "https://9786.play.gamezop.com/g/JVhRZNwly",
		"name": {
			"en": "Mahjong At Home: Scandinavian Edition"
		},
		"isPortrait": false,
		"description": {
			"en": "Enjoy the calming beauty of Mahjong set in a Scandinavian landscape, with relaxing puzzles, serene Nordic backdrops, and a peaceful atmosphere for every match."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/JVhRZNwly/cover.jpg",
			"brick": "https://static.gamezop.com/JVhRZNwly/brick.png",
			"thumb": "https://static.gamezop.com/JVhRZNwly/thumb.png",
			"wall": "https://static.gamezop.com/JVhRZNwly/wall.png",
			"square": "https://static.gamezop.com/JVhRZNwly/square.png",
			"screens": [
				"https://static.gamezop.com/JVhRZNwly/game-1.png",
				"https://static.gamezop.com/JVhRZNwly/game-2.png",
				"https://static.gamezop.com/JVhRZNwly/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/JVhRZNwly/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/JVhRZNwly/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": [
				"New Games"
			]
		},
		"width": 1500,
		"height": 900,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 5673,
		"hasIntegratedAds": false
	},
	{
		"code": "H13-Z8sQILx",
		"url": "https://9786.play.gamezop.com/g/H13-Z8sQILx",
		"name": {
			"en": "Blackjack 21 Pro"
		},
		"isPortrait": false,
		"description": {
			"en": "The best Blackjack game online! Score more than your opponent but keep under 21 to win!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/H13-Z8sQILx/cover.jpg",
			"brick": "https://static.gamezop.com/H13-Z8sQILx/brick.png",
			"thumb": "https://static.gamezop.com/H13-Z8sQILx/thumb.png",
			"wall": "https://static.gamezop.com/H13-Z8sQILx/wall.png",
			"square": "https://static.gamezop.com/H13-Z8sQILx/square.png",
			"screens": [
				"https://static.gamezop.com/H13-Z8sQILx/game-1.png",
				"https://static.gamezop.com/H13-Z8sQILx/game-2.png",
				"https://static.gamezop.com/H13-Z8sQILx/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/H13-Z8sQILx/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/H13-Z8sQILx/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": [
				"Logic",
				"Cards",
				"Classics",
				"Fun",
				"Strategy",
				"Arcade",
				"Casino"
			]
		},
		"width": 800,
		"height": 450,
		"colorMuted": "#304558",
		"colorVibrant": "#144464",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 503167,
		"hasIntegratedAds": false
	},
	{
		"code": "S14VrK8B",
		"url": "https://9786.play.gamezop.com/g/S14VrK8B",
		"name": {
			"en": "Pixel Zombies"
		},
		"isPortrait": true,
		"description": {
			"en": "The zombie invasion just hit London. Smash every zombie but don't kill civilians in this zombie game."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/S14VrK8B/cover.jpg",
			"brick": "https://static.gamezop.com/S14VrK8B/brick.png",
			"thumb": "https://static.gamezop.com/S14VrK8B/thumb.png",
			"wall": "https://static.gamezop.com/S14VrK8B/wall.png",
			"square": "https://static.gamezop.com/S14VrK8B/square.png",
			"screens": [
				"https://static.gamezop.com/S14VrK8B/game-1.png",
				"https://static.gamezop.com/S14VrK8B/game-2.png",
				"https://static.gamezop.com/S14VrK8B/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/S14VrK8B/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/S14VrK8B/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Action"
			]
		},
		"tags": {
			"en": [
				"Action",
				"Boys",
				"Shooting",
				"Strategy",
				"Pixel",
				"Zombie",
				"Level-based"
			]
		},
		"width": 338,
		"height": 600,
		"colorMuted": "#534431",
		"colorVibrant": "#6e2214",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 3262476,
		"hasIntegratedAds": false
	},
	{
		"code": "rJyWCKHbON",
		"url": "https://9786.play.gamezop.com/g/rJyWCKHbON",
		"name": {
			"en": "Yummy Taco"
		},
		"isPortrait": true,
		"description": {
			"en": "Nobody said that running a taco shop would be easy. Can you keep all of your customers happy?"
		},
		"gamePreviews": {
			"en": "https://youtu.be/Y60VLFW5pKA"
		},
		"assets": {
			"cover": "https://static.gamezop.com/rJyWCKHbON/cover.jpg",
			"brick": "https://static.gamezop.com/rJyWCKHbON/brick.png",
			"thumb": "https://static.gamezop.com/rJyWCKHbON/thumb.png",
			"wall": "https://static.gamezop.com/rJyWCKHbON/wall.png",
			"square": "https://static.gamezop.com/rJyWCKHbON/square.png",
			"screens": [
				"https://static.gamezop.com/rJyWCKHbON/game-1.png",
				"https://static.gamezop.com/rJyWCKHbON/game-2.png",
				"https://static.gamezop.com/rJyWCKHbON/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/rJyWCKHbON/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/rJyWCKHbON/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": [
				"Educa-tional",
				"Endless",
				"Food",
				"Girls",
				"Kids",
				"Strategy",
				"Time Mgmt."
			]
		},
		"width": 353,
		"height": 600,
		"colorMuted": "#3f2c30",
		"colorVibrant": "#754a0f",
		"privateAllowed": true,
		"rating": 4.75,
		"numberOfRatings": 1,
		"gamePlays": 24571603,
		"hasIntegratedAds": false
	},
	{
		"code": "B1PfyhpQ5Ar",
		"url": "https://9786.play.gamezop.com/g/B1PfyhpQ5Ar",
		"name": {
			"en": "Shape Smash"
		},
		"isPortrait": true,
		"description": {
			"en": "A stream of orbs, a trail of destruction. Smash those blocks to unleash the resurrection!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/B1PfyhpQ5Ar/cover.jpg",
			"brick": "https://static.gamezop.com/B1PfyhpQ5Ar/brick.png",
			"thumb": "https://static.gamezop.com/B1PfyhpQ5Ar/thumb.png",
			"wall": "https://static.gamezop.com/B1PfyhpQ5Ar/wall.png",
			"square": "https://static.gamezop.com/B1PfyhpQ5Ar/square.png",
			"screens": [
				"https://static.gamezop.com/B1PfyhpQ5Ar/game-1.png",
				"https://static.gamezop.com/B1PfyhpQ5Ar/game-2.png",
				"https://static.gamezop.com/B1PfyhpQ5Ar/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/B1PfyhpQ5Ar/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/B1PfyhpQ5Ar/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": []
		},
		"width": 768,
		"height": 1024,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 2629572,
		"hasIntegratedAds": false
	},
	{
		"code": "Sy64_WbU",
		"url": "https://9786.play.gamezop.com/g/Sy64_WbU",
		"name": {
			"en": "Punch Heroes"
		},
		"isPortrait": true,
		"description": {
			"en": "Karate out the enemies of our lone warrior fighting in the middle. But one miss and it's all over!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/AcsYShR9-Oc"
		},
		"assets": {
			"cover": "https://static.gamezop.com/Sy64_WbU/cover.jpg",
			"brick": "https://static.gamezop.com/Sy64_WbU/brick.png",
			"thumb": "https://static.gamezop.com/Sy64_WbU/thumb.png",
			"wall": "https://static.gamezop.com/Sy64_WbU/wall.png",
			"square": "https://static.gamezop.com/Sy64_WbU/square.png",
			"screens": [
				"https://static.gamezop.com/Sy64_WbU/game-1.png",
				"https://static.gamezop.com/Sy64_WbU/game-2.png",
				"https://static.gamezop.com/Sy64_WbU/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/Sy64_WbU/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/Sy64_WbU/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Action"
			]
		},
		"tags": {
			"en": [
				"Action",
				"Boys",
				"Endless",
				"Exclusive",
				"Family",
				"Fun",
				"Strategy",
				"Arcade",
				"Pixel",
				"Cute"
			]
		},
		"width": 864,
		"height": 1536,
		"colorMuted": "#3b5e36",
		"colorVibrant": "#a4a40c",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 11511562,
		"hasIntegratedAds": false
	},
	{
		"code": "S1JfKuB9nR",
		"url": "https://9786.play.gamezop.com/g/S1JfKuB9nR",
		"name": {
			"en": "Foot Chinko"
		},
		"isPortrait": true,
		"description": {
			"en": "This blend of soccer and physics is an absolute delight that features world's top tournaments."
		},
		"gamePreviews": {
			"en": "https://youtu.be/oXd7V1z05o8"
		},
		"assets": {
			"cover": "https://static.gamezop.com/S1JfKuB9nR/cover.jpg",
			"brick": "https://static.gamezop.com/S1JfKuB9nR/brick.png",
			"thumb": "https://static.gamezop.com/S1JfKuB9nR/thumb.png",
			"wall": "https://static.gamezop.com/S1JfKuB9nR/wall.png",
			"square": "https://static.gamezop.com/S1JfKuB9nR/square.png",
			"screens": [
				"https://static.gamezop.com/S1JfKuB9nR/game-1.png",
				"https://static.gamezop.com/S1JfKuB9nR/game-2.png",
				"https://static.gamezop.com/S1JfKuB9nR/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/S1JfKuB9nR/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/S1JfKuB9nR/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": [
				"Boys",
				"Soccer",
				"Fun",
				"Sports",
				"Level-based",
				"HD",
				"Cute"
			]
		},
		"width": 768,
		"height": 1024,
		"colorMuted": "#576432",
		"colorVibrant": "#226719",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 10221295,
		"hasIntegratedAds": false
	},
	{
		"code": "Sy6RYB-u4",
		"url": "https://9786.play.gamezop.com/g/Sy6RYB-u4",
		"name": {
			"en": "Little Bouncing Guys"
		},
		"isPortrait": false,
		"description": {
			"en": "Hop, jump, and bounce over obstacles and collect the purple star boxes in each level of this game."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/Sy6RYB-u4/cover.jpg",
			"brick": "https://static.gamezop.com/Sy6RYB-u4/brick.png",
			"thumb": "https://static.gamezop.com/Sy6RYB-u4/thumb.png",
			"wall": "https://static.gamezop.com/Sy6RYB-u4/wall.png",
			"square": "https://static.gamezop.com/Sy6RYB-u4/square.png",
			"screens": [
				"https://static.gamezop.com/Sy6RYB-u4/game-1.png",
				"https://static.gamezop.com/Sy6RYB-u4/game-2.png",
				"https://static.gamezop.com/Sy6RYB-u4/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/Sy6RYB-u4/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/Sy6RYB-u4/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": [
				"Adventure",
				"Boys",
				"Logic",
				"Family",
				"Fun",
				"Kids",
				"Arcade",
				"Level-based",
				"Cute"
			]
		},
		"width": 800,
		"height": 600,
		"colorMuted": "#29325a",
		"colorVibrant": "#9e8515",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 3149979,
		"hasIntegratedAds": false
	},
	{
		"code": "SyTeia3fOeZ",
		"url": "https://9786.play.gamezop.com/g/SyTeia3fOeZ",
		"name": {
			"en": "Cowboy vs. Martians"
		},
		"isPortrait": false,
		"description": {
			"en": "Here's what a typical day in Texas would look like if the Martians landed on Earth! Shoot 'em all!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/SyTeia3fOeZ/cover.jpg",
			"brick": "https://static.gamezop.com/SyTeia3fOeZ/brick.png",
			"thumb": "https://static.gamezop.com/SyTeia3fOeZ/thumb.png",
			"wall": "https://static.gamezop.com/SyTeia3fOeZ/wall.png",
			"square": "https://static.gamezop.com/SyTeia3fOeZ/square.png",
			"screens": [
				"https://static.gamezop.com/SyTeia3fOeZ/game-1.png",
				"https://static.gamezop.com/SyTeia3fOeZ/game-2.png",
				"https://static.gamezop.com/SyTeia3fOeZ/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SyTeia3fOeZ/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SyTeia3fOeZ/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": [
				"Action",
				"Adventure",
				"Boys",
				"Shooting",
				"Strategy",
				"Space",
				"Level-based"
			]
		},
		"width": 854,
		"height": 480,
		"colorMuted": "#4a6c80",
		"colorVibrant": "#ccb106",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 3192945,
		"hasIntegratedAds": false
	},
	{
		"code": "BkqTS_1b",
		"url": "https://9786.play.gamezop.com/g/BkqTS_1b",
		"name": {
			"en": "Oh No"
		},
		"isPortrait": true,
		"description": {
			"en": "Fill red and blue dots to solve puzzles! The challenge is to determine the color of every piece."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/BkqTS_1b/cover.jpg",
			"brick": "https://static.gamezop.com/BkqTS_1b/brick.png",
			"thumb": "https://static.gamezop.com/BkqTS_1b/thumb.png",
			"wall": "https://static.gamezop.com/BkqTS_1b/wall.png",
			"square": "https://static.gamezop.com/BkqTS_1b/square.png",
			"screens": [
				"https://static.gamezop.com/BkqTS_1b/game-1.png",
				"https://static.gamezop.com/BkqTS_1b/game-2.png",
				"https://static.gamezop.com/BkqTS_1b/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/BkqTS_1b/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/BkqTS_1b/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": [
				"Boys",
				"Logic",
				"Strategy",
				"Level-based",
				"Puzzle"
			]
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#057f93",
		"colorVibrant": "#046e80",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 546627,
		"hasIntegratedAds": false
	},
	{
		"code": "SJ3-ELT8p-x",
		"url": "https://9786.play.gamezop.com/g/SJ3-ELT8p-x",
		"name": {
			"en": "Jelly Slice"
		},
		"isPortrait": true,
		"description": {
			"en": "Slice the Jelly so that each slice contains only one star! Get 3 stars for maximum rewards."
		},
		"gamePreviews": {
			"en": "https://youtu.be/9qRmRJAbj_Y"
		},
		"assets": {
			"cover": "https://static.gamezop.com/SJ3-ELT8p-x/cover.jpg",
			"brick": "https://static.gamezop.com/SJ3-ELT8p-x/brick.png",
			"thumb": "https://static.gamezop.com/SJ3-ELT8p-x/thumb.png",
			"wall": "https://static.gamezop.com/SJ3-ELT8p-x/wall.png",
			"square": "https://static.gamezop.com/SJ3-ELT8p-x/square.png",
			"screens": [
				"https://static.gamezop.com/SJ3-ELT8p-x/game-1.png",
				"https://static.gamezop.com/SJ3-ELT8p-x/game-2.png",
				"https://static.gamezop.com/SJ3-ELT8p-x/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SJ3-ELT8p-x/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SJ3-ELT8p-x/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": [
				"Logic",
				"Family",
				"Food",
				"Fun",
				"Level-based",
				"HD",
				"Puzzle"
			]
		},
		"width": 1008,
		"height": 756,
		"colorMuted": "#910707",
		"colorVibrant": "#ac0909",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 10812477,
		"hasIntegratedAds": false
	},
	{
		"code": "r1ozpMkD5Jm",
		"url": "https://9786.play.gamezop.com/g/r1ozpMkD5Jm",
		"name": {
			"en": "Kickin It"
		},
		"isPortrait": true,
		"description": {
			"en": "Kick it left, kick it right. Kick where you want, just don't let the ball hit the ground, alright?"
		},
		"gamePreviews": {
			"en": "https://youtu.be/Nq4atBJOWo4"
		},
		"assets": {
			"cover": "https://static.gamezop.com/r1ozpMkD5Jm/cover.jpg",
			"brick": "https://static.gamezop.com/r1ozpMkD5Jm/brick.png",
			"thumb": "https://static.gamezop.com/r1ozpMkD5Jm/thumb.png",
			"wall": "https://static.gamezop.com/r1ozpMkD5Jm/wall.png",
			"square": "https://static.gamezop.com/r1ozpMkD5Jm/square.png",
			"screens": [
				"https://static.gamezop.com/r1ozpMkD5Jm/game-1.png",
				"https://static.gamezop.com/r1ozpMkD5Jm/game-2.png",
				"https://static.gamezop.com/r1ozpMkD5Jm/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/r1ozpMkD5Jm/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/r1ozpMkD5Jm/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": []
		},
		"width": 480,
		"height": 720,
		"colorMuted": "#5c4131",
		"colorVibrant": "#045c74",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 7388423,
		"hasIntegratedAds": false
	},
	{
		"code": "HJT46GkPcy7",
		"url": "https://9786.play.gamezop.com/g/HJT46GkPcy7",
		"name": {
			"en": "Tower Twist"
		},
		"isPortrait": true,
		"description": {
			"en": "Navigate the gaps as your fall through this helix tower labyrinth - time's limited, let's see how much you can score!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/l99_95cB2fo"
		},
		"assets": {
			"cover": "https://static.gamezop.com/HJT46GkPcy7/cover.jpg",
			"brick": "https://static.gamezop.com/HJT46GkPcy7/brick.png",
			"thumb": "https://static.gamezop.com/HJT46GkPcy7/thumb.png",
			"wall": "https://static.gamezop.com/HJT46GkPcy7/wall.png",
			"square": "https://static.gamezop.com/HJT46GkPcy7/square.png",
			"screens": [
				"https://static.gamezop.com/HJT46GkPcy7/game-1.png",
				"https://static.gamezop.com/HJT46GkPcy7/game-2.png",
				"https://static.gamezop.com/HJT46GkPcy7/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/HJT46GkPcy7/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/HJT46GkPcy7/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Arcade"
			]
		},
		"tags": {
			"en": []
		},
		"width": 540,
		"height": 960,
		"colorMuted": "#8c74b0",
		"colorVibrant": "#21eae8",
		"privateAllowed": true,
		"rating": 2.7,
		"numberOfRatings": 5,
		"gamePlays": 86478761,
		"hasIntegratedAds": false
	},
	{
		"code": "REwFeKcoN",
		"url": "https://9786.play.gamezop.com/g/REwFeKcoN",
		"name": {
			"en": "Gun Master"
		},
		"isPortrait": true,
		"description": {
			"en": "Wipe clean the Gangster infested Central Tower! One Shot, One Kill, that's how you make them cower!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/REwFeKcoN/cover.jpg",
			"brick": "https://static.gamezop.com/REwFeKcoN/brick.png",
			"thumb": "https://static.gamezop.com/REwFeKcoN/thumb.png",
			"wall": "https://static.gamezop.com/REwFeKcoN/wall.png",
			"square": "https://static.gamezop.com/REwFeKcoN/square.png",
			"screens": [
				"https://static.gamezop.com/REwFeKcoN/game-1.png",
				"https://static.gamezop.com/REwFeKcoN/game-2.png",
				"https://static.gamezop.com/REwFeKcoN/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/REwFeKcoN/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/REwFeKcoN/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Action"
			]
		},
		"tags": {
			"en": []
		},
		"width": 1080,
		"height": 1920,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 50727519,
		"hasIntegratedAds": false
	},
	{
		"code": "SyjAFr-dE",
		"url": "https://9786.play.gamezop.com/g/SyjAFr-dE",
		"name": {
			"en": "Jom Jom Jump"
		},
		"isPortrait": false,
		"description": {
			"en": "Help the tiny monster jump higher from platform to platform. Try to eat all apples in this endless game."
		},
		"gamePreviews": {
			"en": "https://youtu.be/mLZfiwKyA2M"
		},
		"assets": {
			"cover": "https://static.gamezop.com/SyjAFr-dE/cover.jpg",
			"brick": "https://static.gamezop.com/SyjAFr-dE/brick.png",
			"thumb": "https://static.gamezop.com/SyjAFr-dE/thumb.png",
			"wall": "https://static.gamezop.com/SyjAFr-dE/wall.png",
			"square": "https://static.gamezop.com/SyjAFr-dE/square.png",
			"screens": [
				"https://static.gamezop.com/SyjAFr-dE/game-1.png",
				"https://static.gamezop.com/SyjAFr-dE/game-2.png",
				"https://static.gamezop.com/SyjAFr-dE/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SyjAFr-dE/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SyjAFr-dE/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Arcade"
			]
		},
		"tags": {
			"en": [
				"Adventure",
				"Endless",
				"Family",
				"Fun",
				"Animal",
				"Girls",
				"Kids",
				"Physics",
				"Arcade"
			]
		},
		"width": 800,
		"height": 600,
		"colorMuted": "#5c4b46",
		"colorVibrant": "#9c6434",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 6431692,
		"hasIntegratedAds": false
	},
	{
		"code": "Sy8y2aQ9CB",
		"url": "https://9786.play.gamezop.com/g/Sy8y2aQ9CB",
		"name": {
			"en": "Quiz Champions"
		},
		"isPortrait": true,
		"description": {
			"en": "Compete with thousands of players across cricket, history, Bollywood and more categories in Gamezop's Quiz Champions and win real money!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/Sy8y2aQ9CB/cover.jpg",
			"brick": "https://static.gamezop.com/Sy8y2aQ9CB/brick.png",
			"thumb": "https://static.gamezop.com/Sy8y2aQ9CB/thumb.png",
			"wall": "https://static.gamezop.com/Sy8y2aQ9CB/wall.png",
			"square": "https://static.gamezop.com/Sy8y2aQ9CB/square.png",
			"screens": [
				"https://static.gamezop.com/Sy8y2aQ9CB/game-1.png",
				"https://static.gamezop.com/Sy8y2aQ9CB/game-2.png",
				"https://static.gamezop.com/Sy8y2aQ9CB/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/Sy8y2aQ9CB/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/Sy8y2aQ9CB/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": []
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": false,
		"rating": 4,
		"numberOfRatings": 1,
		"gamePlays": 3027048,
		"hasIntegratedAds": false
	},
	{
		"code": "SJ8X6zyPcyX",
		"url": "https://9786.play.gamezop.com/g/SJ8X6zyPcyX",
		"name": {
			"en": "Saloon Robbery"
		},
		"isPortrait": true,
		"description": {
			"en": "Stop the saloon robbery by dropping the wild outlaws one by one, but beware of the hostage situation and lookout for cool bonuses!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/1eRwkutkwSc"
		},
		"assets": {
			"cover": "https://static.gamezop.com/SJ8X6zyPcyX/cover.jpg",
			"brick": "https://static.gamezop.com/SJ8X6zyPcyX/brick.png",
			"thumb": "https://static.gamezop.com/SJ8X6zyPcyX/thumb.png",
			"wall": "https://static.gamezop.com/SJ8X6zyPcyX/wall.png",
			"square": "https://static.gamezop.com/SJ8X6zyPcyX/square.png",
			"screens": [
				"https://static.gamezop.com/SJ8X6zyPcyX/game-1.png",
				"https://static.gamezop.com/SJ8X6zyPcyX/game-2.png",
				"https://static.gamezop.com/SJ8X6zyPcyX/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SJ8X6zyPcyX/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SJ8X6zyPcyX/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Action"
			]
		},
		"tags": {
			"en": []
		},
		"width": 804,
		"height": 452,
		"colorMuted": "#d0c061",
		"colorVibrant": "#9e642b",
		"privateAllowed": true,
		"rating": 3.79,
		"numberOfRatings": 7,
		"gamePlays": 24479975,
		"hasIntegratedAds": false
	},
	{
		"code": "SJX7TGkDq1X",
		"url": "https://9786.play.gamezop.com/g/SJX7TGkDq1X",
		"name": {
			"en": "Pop Soap"
		},
		"isPortrait": true,
		"description": {
			"en": "Classic Match-3 game in Endless Mode and an Achievements mode! Remember, if there's 2 or more of the same kind, you can burst them!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/Z1PT6M-E-6w"
		},
		"assets": {
			"cover": "https://static.gamezop.com/SJX7TGkDq1X/cover.jpg",
			"brick": "https://static.gamezop.com/SJX7TGkDq1X/brick.png",
			"thumb": "https://static.gamezop.com/SJX7TGkDq1X/thumb.png",
			"wall": "https://static.gamezop.com/SJX7TGkDq1X/wall.png",
			"square": "https://static.gamezop.com/SJX7TGkDq1X/square.png",
			"screens": [
				"https://static.gamezop.com/SJX7TGkDq1X/game-1.png",
				"https://static.gamezop.com/SJX7TGkDq1X/game-2.png",
				"https://static.gamezop.com/SJX7TGkDq1X/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SJX7TGkDq1X/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SJX7TGkDq1X/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": []
		},
		"width": 720,
		"height": 1080,
		"colorMuted": "#937e05",
		"colorVibrant": "#806d04",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 11340007,
		"hasIntegratedAds": false
	},
	{
		"code": "H1abja2M_eb",
		"url": "https://9786.play.gamezop.com/g/H1abja2M_eb",
		"name": {
			"en": "Hex Burst"
		},
		"isPortrait": true,
		"description": {
			"en": "Burst as many hexagons as you can - just don't kill the snake."
		},
		"gamePreviews": {
			"en": "https://youtu.be/HUyK6bLQzKU"
		},
		"assets": {
			"cover": "https://static.gamezop.com/H1abja2M_eb/cover.jpg",
			"brick": "https://static.gamezop.com/H1abja2M_eb/brick.png",
			"thumb": "https://static.gamezop.com/H1abja2M_eb/thumb.png",
			"wall": "https://static.gamezop.com/H1abja2M_eb/wall.png",
			"square": "https://static.gamezop.com/H1abja2M_eb/square.png",
			"screens": [
				"https://static.gamezop.com/H1abja2M_eb/game-1.png",
				"https://static.gamezop.com/H1abja2M_eb/game-2.png",
				"https://static.gamezop.com/H1abja2M_eb/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/H1abja2M_eb/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/H1abja2M_eb/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": [
				"Logic",
				"Endless",
				"Strategy",
				"Arcade"
			]
		},
		"width": 640,
		"height": 1136,
		"colorMuted": "#947004",
		"colorVibrant": "#816103",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 12805446,
		"hasIntegratedAds": false
	},
	{
		"code": "S1Wrpf1v5ym",
		"url": "https://9786.play.gamezop.com/g/S1Wrpf1v5ym",
		"name": {
			"en": "Box Crush"
		},
		"isPortrait": true,
		"description": {
			"en": "Clear rows and columns before the numbers get to 0. Keep an eye on the progress bar to unlock special power ups!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/qKU-0Csknb4"
		},
		"assets": {
			"cover": "https://static.gamezop.com/S1Wrpf1v5ym/cover.jpg",
			"brick": "https://static.gamezop.com/S1Wrpf1v5ym/brick.png",
			"thumb": "https://static.gamezop.com/S1Wrpf1v5ym/thumb.png",
			"wall": "https://static.gamezop.com/S1Wrpf1v5ym/wall.png",
			"square": "https://static.gamezop.com/S1Wrpf1v5ym/square.png",
			"screens": [
				"https://static.gamezop.com/S1Wrpf1v5ym/game-1.png",
				"https://static.gamezop.com/S1Wrpf1v5ym/game-2.png",
				"https://static.gamezop.com/S1Wrpf1v5ym/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/S1Wrpf1v5ym/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/S1Wrpf1v5ym/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": []
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#5563f4",
		"colorVibrant": "#08127c",
		"privateAllowed": true,
		"rating": 2,
		"numberOfRatings": 1,
		"gamePlays": 10045477,
		"hasIntegratedAds": false
	},
	{
		"code": "HyV_Nm-kK",
		"url": "https://9786.play.gamezop.com/g/HyV_Nm-kK",
		"name": {
			"en": "Super Sprint"
		},
		"isPortrait": true,
		"description": {
			"en": "Sprint and jump over spikes, obstacles, springs, and lasers. Run as long as you can in this HTML5 game."
		},
		"gamePreviews": {
			"en": "https://youtu.be/tSgKGNqbBes"
		},
		"assets": {
			"cover": "https://static.gamezop.com/HyV_Nm-kK/cover.jpg",
			"brick": "https://static.gamezop.com/HyV_Nm-kK/brick.png",
			"thumb": "https://static.gamezop.com/HyV_Nm-kK/thumb.png",
			"wall": "https://static.gamezop.com/HyV_Nm-kK/wall.png",
			"square": "https://static.gamezop.com/HyV_Nm-kK/square.png",
			"screens": [
				"https://static.gamezop.com/HyV_Nm-kK/game-1.png",
				"https://static.gamezop.com/HyV_Nm-kK/game-2.png",
				"https://static.gamezop.com/HyV_Nm-kK/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/HyV_Nm-kK/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/HyV_Nm-kK/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Arcade"
			]
		},
		"tags": {
			"en": [
				"Adventure",
				"Endless",
				"Arcade",
				"Pixel",
				"Minimal",
				"Difficult"
			]
		},
		"width": 320,
		"height": 480,
		"colorMuted": "#443434",
		"colorVibrant": "#771d1d",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 6524828,
		"hasIntegratedAds": false
	},
	{
		"code": "SyFcNzAX6",
		"url": "https://9786.play.gamezop.com/g/SyFcNzAX6",
		"name": {
			"en": "Shade Shuffle"
		},
		"isPortrait": true,
		"description": {
			"en": "Balance between the right and the left wheels so that their colours match with the balls."
		},
		"gamePreviews": {
			"en": "https://youtu.be/AI442ktnj8U"
		},
		"assets": {
			"cover": "https://static.gamezop.com/SyFcNzAX6/cover.jpg",
			"brick": "https://static.gamezop.com/SyFcNzAX6/brick.png",
			"thumb": "https://static.gamezop.com/SyFcNzAX6/thumb.png",
			"wall": "https://static.gamezop.com/SyFcNzAX6/wall.png",
			"square": "https://static.gamezop.com/SyFcNzAX6/square.png",
			"screens": [
				"https://static.gamezop.com/SyFcNzAX6/game-1.png",
				"https://static.gamezop.com/SyFcNzAX6/game-2.png",
				"https://static.gamezop.com/SyFcNzAX6/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SyFcNzAX6/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SyFcNzAX6/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Arcade"
			]
		},
		"tags": {
			"en": [
				"Endless",
				"Arcade",
				"Minimal",
				"Difficult"
			]
		},
		"width": 338,
		"height": 600,
		"colorMuted": "#2f3458",
		"colorVibrant": "#0c1c4c",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 6259573,
		"hasIntegratedAds": false
	},
	{
		"code": "wMm3YDfJC",
		"url": "https://9786.play.gamezop.com/g/wMm3YDfJC",
		"name": {
			"en": "Pizza Dash"
		},
		"isPortrait": true,
		"description": {
			"en": "Pizza parties all around, dash through the traffic and deliver them time bound!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/wMm3YDfJC/cover.jpg",
			"brick": "https://static.gamezop.com/wMm3YDfJC/brick.png",
			"thumb": "https://static.gamezop.com/wMm3YDfJC/thumb.png",
			"wall": "https://static.gamezop.com/wMm3YDfJC/wall.png",
			"square": "https://static.gamezop.com/wMm3YDfJC/square.png",
			"screens": [
				"https://static.gamezop.com/wMm3YDfJC/game-1.png",
				"https://static.gamezop.com/wMm3YDfJC/game-2.png",
				"https://static.gamezop.com/wMm3YDfJC/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/wMm3YDfJC/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/wMm3YDfJC/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Arcade"
			]
		},
		"tags": {
			"en": []
		},
		"width": 1080,
		"height": 1920,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": false,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 3629482,
		"hasIntegratedAds": true
	},
	{
		"code": "Ske-CtBbdV",
		"url": "https://9786.play.gamezop.com/g/Ske-CtBbdV",
		"name": {
			"en": "Zoo Pinball"
		},
		"isPortrait": true,
		"description": {
			"en": "Here's how they play pinball in the jungle. How long can you prevent your silver balls past the flippers?"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/Ske-CtBbdV/cover.jpg",
			"brick": "https://static.gamezop.com/Ske-CtBbdV/brick.png",
			"thumb": "https://static.gamezop.com/Ske-CtBbdV/thumb.png",
			"wall": "https://static.gamezop.com/Ske-CtBbdV/wall.png",
			"square": "https://static.gamezop.com/Ske-CtBbdV/square.png",
			"screens": [
				"https://static.gamezop.com/Ske-CtBbdV/game-1.png",
				"https://static.gamezop.com/Ske-CtBbdV/game-2.png",
				"https://static.gamezop.com/Ske-CtBbdV/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/Ske-CtBbdV/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/Ske-CtBbdV/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Arcade"
			]
		},
		"tags": {
			"en": [
				"Adventure",
				"Board",
				"Boys",
				"Family",
				"Fun",
				"Animal",
				"Girls",
				"Kids",
				"Physics",
				"Arcade"
			]
		},
		"width": 353,
		"height": 600,
		"colorMuted": "#34345c",
		"colorVibrant": "#5f4e10",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 2334634,
		"hasIntegratedAds": false
	},
	{
		"code": "H15Qk3pQ5CH",
		"url": "https://9786.play.gamezop.com/g/H15Qk3pQ5CH",
		"name": {
			"en": "Hoopball Legends"
		},
		"isPortrait": true,
		"description": {
			"en": "Get the ball through the hoops, get the max score in your group or keep trying in a loop!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/H15Qk3pQ5CH/cover.jpg",
			"brick": "https://static.gamezop.com/H15Qk3pQ5CH/brick.png",
			"thumb": "https://static.gamezop.com/H15Qk3pQ5CH/thumb.png",
			"wall": "https://static.gamezop.com/H15Qk3pQ5CH/wall.png",
			"square": "https://static.gamezop.com/H15Qk3pQ5CH/square.png",
			"screens": [
				"https://static.gamezop.com/H15Qk3pQ5CH/game-1.png",
				"https://static.gamezop.com/H15Qk3pQ5CH/game-2.png",
				"https://static.gamezop.com/H15Qk3pQ5CH/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/H15Qk3pQ5CH/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/H15Qk3pQ5CH/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Arcade"
			]
		},
		"tags": {
			"en": []
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 1440159,
		"hasIntegratedAds": true
	},
	{
		"code": "SkJf58Ouf0",
		"url": "https://9786.play.gamezop.com/g/SkJf58Ouf0",
		"name": {
			"en": "Dribble Kings"
		},
		"isPortrait": true,
		"description": {
			"en": "Run and find the best trajectory to dodge obstacles. Don't let those quarterbacks take the ball!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/SsHi7StO0m8"
		},
		"assets": {
			"cover": "https://static.gamezop.com/SkJf58Ouf0/cover.jpg",
			"brick": "https://static.gamezop.com/SkJf58Ouf0/brick.png",
			"thumb": "https://static.gamezop.com/SkJf58Ouf0/thumb.png",
			"wall": "https://static.gamezop.com/SkJf58Ouf0/wall.png",
			"square": "https://static.gamezop.com/SkJf58Ouf0/square.png",
			"screens": [
				"https://static.gamezop.com/SkJf58Ouf0/game-1.png",
				"https://static.gamezop.com/SkJf58Ouf0/game-2.png",
				"https://static.gamezop.com/SkJf58Ouf0/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SkJf58Ouf0/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SkJf58Ouf0/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": [
				"Boys",
				"Soccer",
				"Endless",
				"Fun",
				"Racing"
			]
		},
		"width": 800,
		"height": 600,
		"colorMuted": "#445c2c",
		"colorVibrant": "#0e1dd2",
		"privateAllowed": true,
		"rating": 4.75,
		"numberOfRatings": 2,
		"gamePlays": 26835869,
		"hasIntegratedAds": false
	},
	{
		"code": "BJ8Wb8j7ILx",
		"url": "https://9786.play.gamezop.com/g/BJ8Wb8j7ILx",
		"name": {
			"en": "Soccer Jerks"
		},
		"isPortrait": false,
		"description": {
			"en": "Here's the dumbest soccer game ever! How well can you play without turning around?"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/BJ8Wb8j7ILx/cover.jpg",
			"brick": "https://static.gamezop.com/BJ8Wb8j7ILx/brick.png",
			"thumb": "https://static.gamezop.com/BJ8Wb8j7ILx/thumb.png",
			"wall": "https://static.gamezop.com/BJ8Wb8j7ILx/wall.png",
			"square": "https://static.gamezop.com/BJ8Wb8j7ILx/square.png",
			"screens": [
				"https://static.gamezop.com/BJ8Wb8j7ILx/game-1.png",
				"https://static.gamezop.com/BJ8Wb8j7ILx/game-2.png",
				"https://static.gamezop.com/BJ8Wb8j7ILx/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/BJ8Wb8j7ILx/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/BJ8Wb8j7ILx/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": [
				"Boys",
				"Soccer",
				"Classics",
				"Fun",
				"Kids",
				"Sports"
			]
		},
		"width": 1360,
		"height": 840,
		"colorMuted": "#514532",
		"colorVibrant": "#064c1d",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 1198916,
		"hasIntegratedAds": false
	},
	{
		"code": "hfPOimYqY",
		"url": "https://9786.play.gamezop.com/g/hfPOimYqY",
		"name": {
			"en": "Merge Mania"
		},
		"isPortrait": true,
		"description": {
			"en": "Zap those numbers by pitting them against one another! Let's see how much you score in this race against time!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/hfPOimYqY/cover.jpg",
			"brick": "https://static.gamezop.com/hfPOimYqY/brick.png",
			"thumb": "https://static.gamezop.com/hfPOimYqY/thumb.png",
			"wall": "https://static.gamezop.com/hfPOimYqY/wall.png",
			"square": "https://static.gamezop.com/hfPOimYqY/square.png",
			"screens": [
				"https://static.gamezop.com/hfPOimYqY/game-1.png",
				"https://static.gamezop.com/hfPOimYqY/game-2.png",
				"https://static.gamezop.com/hfPOimYqY/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/hfPOimYqY/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/hfPOimYqY/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": []
		},
		"width": 1080,
		"height": 1920,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 3744052,
		"hasIntegratedAds": true
	},
	{
		"code": "H1WmafkP9JQ",
		"url": "https://9786.play.gamezop.com/g/H1WmafkP9JQ",
		"name": {
			"en": "Tic Tac Toe"
		},
		"isPortrait": true,
		"description": {
			"en": "Play the classic Tic Tac Toe online! Play in 3 difficulty modes or challenge thousands of other players online!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/1RAmpf5qc54"
		},
		"assets": {
			"cover": "https://static.gamezop.com/H1WmafkP9JQ/cover.jpg",
			"brick": "https://static.gamezop.com/H1WmafkP9JQ/brick.png",
			"thumb": "https://static.gamezop.com/H1WmafkP9JQ/thumb.png",
			"wall": "https://static.gamezop.com/H1WmafkP9JQ/wall.png",
			"square": "https://static.gamezop.com/H1WmafkP9JQ/square.png",
			"screens": [
				"https://static.gamezop.com/H1WmafkP9JQ/game-1.png",
				"https://static.gamezop.com/H1WmafkP9JQ/game-2.png",
				"https://static.gamezop.com/H1WmafkP9JQ/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/H1WmafkP9JQ/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/H1WmafkP9JQ/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": []
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#4c3c5c",
		"colorVibrant": "#342464",
		"privateAllowed": false,
		"rating": 3.85,
		"numberOfRatings": 5,
		"gamePlays": 173893259,
		"hasIntegratedAds": false
	},
	{
		"code": "BJm9VfCmp",
		"url": "https://9786.play.gamezop.com/g/BJm9VfCmp",
		"name": {
			"en": "Watch The Walls"
		},
		"isPortrait": true,
		"description": {
			"en": "Little bee needs your help in avoiding the spikes as she makes her way inside a massive beehive."
		},
		"gamePreviews": {
			"en": "https://youtu.be/KX5mVZj3Nrs"
		},
		"assets": {
			"cover": "https://static.gamezop.com/BJm9VfCmp/cover.jpg",
			"brick": "https://static.gamezop.com/BJm9VfCmp/brick.png",
			"thumb": "https://static.gamezop.com/BJm9VfCmp/thumb.png",
			"wall": "https://static.gamezop.com/BJm9VfCmp/wall.png",
			"square": "https://static.gamezop.com/BJm9VfCmp/square.png",
			"screens": [
				"https://static.gamezop.com/BJm9VfCmp/game-1.png",
				"https://static.gamezop.com/BJm9VfCmp/game-2.png",
				"https://static.gamezop.com/BJm9VfCmp/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/BJm9VfCmp/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/BJm9VfCmp/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Arcade"
			]
		},
		"tags": {
			"en": [
				"Endless",
				"Animal",
				"Arcade",
				"Minimal",
				"HD"
			]
		},
		"width": 640,
		"height": 1136,
		"colorMuted": "#50442d",
		"colorVibrant": "#9e742f",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 4743334,
		"hasIntegratedAds": false
	},
	{
		"code": "rJu76zkD917",
		"url": "https://9786.play.gamezop.com/g/rJu76zkD917",
		"name": {
			"en": "Algerian Solitaire"
		},
		"isPortrait": false,
		"description": {
			"en": "Play the timeless Solitaire game in an Algerian desert setting! This version of Solitaire has 2 decks for double the challenge and double the punch!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/rJu76zkD917/cover.jpg",
			"brick": "https://static.gamezop.com/rJu76zkD917/brick.png",
			"thumb": "https://static.gamezop.com/rJu76zkD917/thumb.png",
			"wall": "https://static.gamezop.com/rJu76zkD917/wall.png",
			"square": "https://static.gamezop.com/rJu76zkD917/square.png",
			"screens": [
				"https://static.gamezop.com/rJu76zkD917/game-1.png",
				"https://static.gamezop.com/rJu76zkD917/game-2.png",
				"https://static.gamezop.com/rJu76zkD917/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/rJu76zkD917/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/rJu76zkD917/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": []
		},
		"width": 960,
		"height": 640,
		"colorMuted": "#775871",
		"colorVibrant": "#861908",
		"privateAllowed": false,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 880569,
		"hasIntegratedAds": false
	},
	{
		"code": "Sk1Wyn6XqRH",
		"url": "https://9786.play.gamezop.com/g/Sk1Wyn6XqRH",
		"name": {
			"en": "Foosball Kick"
		},
		"isPortrait": true,
		"description": {
			"en": "Foosball with a twist: use the red player when the ball is red and the yellow player when the ball is yellow. Sounds simple? Let's see you score 20 in the game!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/Sk1Wyn6XqRH/cover.jpg",
			"brick": "https://static.gamezop.com/Sk1Wyn6XqRH/brick.png",
			"thumb": "https://static.gamezop.com/Sk1Wyn6XqRH/thumb.png",
			"wall": "https://static.gamezop.com/Sk1Wyn6XqRH/wall.png",
			"square": "https://static.gamezop.com/Sk1Wyn6XqRH/square.png",
			"screens": [
				"https://static.gamezop.com/Sk1Wyn6XqRH/game-1.png",
				"https://static.gamezop.com/Sk1Wyn6XqRH/game-2.png",
				"https://static.gamezop.com/Sk1Wyn6XqRH/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/Sk1Wyn6XqRH/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/Sk1Wyn6XqRH/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": []
		},
		"width": 640,
		"height": 1136,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 6297477,
		"hasIntegratedAds": false
	},
	{
		"code": "H1Wzaf1wqyQ",
		"url": "https://9786.play.gamezop.com/g/H1Wzaf1wqyQ",
		"name": {
			"en": "Hipster Tennis"
		},
		"isPortrait": true,
		"description": {
			"en": "With rackets in hand and a grin on your face, Hipster Tennis is the perfect place."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/H1Wzaf1wqyQ/cover.jpg",
			"brick": "https://static.gamezop.com/H1Wzaf1wqyQ/brick.png",
			"thumb": "https://static.gamezop.com/H1Wzaf1wqyQ/thumb.png",
			"wall": "https://static.gamezop.com/H1Wzaf1wqyQ/wall.png",
			"square": "https://static.gamezop.com/H1Wzaf1wqyQ/square.png",
			"screens": [
				"https://static.gamezop.com/H1Wzaf1wqyQ/game-1.png",
				"https://static.gamezop.com/H1Wzaf1wqyQ/game-2.png",
				"https://static.gamezop.com/H1Wzaf1wqyQ/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/H1Wzaf1wqyQ/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/H1Wzaf1wqyQ/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": []
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 1099373,
		"hasIntegratedAds": false
	},
	{
		"code": "B1MfIa4QCg",
		"url": "https://9786.play.gamezop.com/g/B1MfIa4QCg",
		"name": {
			"en": "Spider Solitaire"
		},
		"isPortrait": false,
		"description": {
			"en": "Get bitten by the solitaire bug and see if you can master this classic card game."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/B1MfIa4QCg/cover.jpg",
			"brick": "https://static.gamezop.com/B1MfIa4QCg/brick.png",
			"thumb": "https://static.gamezop.com/B1MfIa4QCg/thumb.png",
			"wall": "https://static.gamezop.com/B1MfIa4QCg/wall.png",
			"square": "https://static.gamezop.com/B1MfIa4QCg/square.png",
			"screens": [
				"https://static.gamezop.com/B1MfIa4QCg/game-1.png",
				"https://static.gamezop.com/B1MfIa4QCg/game-2.png",
				"https://static.gamezop.com/B1MfIa4QCg/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/B1MfIa4QCg/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/B1MfIa4QCg/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": [
				"Boys",
				"Cards",
				"Classics",
				"Casino"
			]
		},
		"width": 1600,
		"height": 768,
		"colorMuted": "#346749",
		"colorVibrant": "#0c6c34",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 4081455,
		"hasIntegratedAds": false
	},
	{
		"code": "NkxfOJM-qg",
		"url": "https://9786.play.gamezop.com/g/NkxfOJM-qg",
		"name": {
			"en": "Fidgety Frog"
		},
		"isPortrait": true,
		"description": {
			"en": "The frog breaks wind to rise above bars. Help him go higher without getting smashed to smithereens!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/o32xO4wQyPk"
		},
		"assets": {
			"cover": "https://static.gamezop.com/NkxfOJM-qg/cover.jpg",
			"brick": "https://static.gamezop.com/NkxfOJM-qg/brick.png",
			"thumb": "https://static.gamezop.com/NkxfOJM-qg/thumb.png",
			"wall": "https://static.gamezop.com/NkxfOJM-qg/wall.png",
			"square": "https://static.gamezop.com/NkxfOJM-qg/square.png",
			"screens": [
				"https://static.gamezop.com/NkxfOJM-qg/game-1.png",
				"https://static.gamezop.com/NkxfOJM-qg/game-2.png",
				"https://static.gamezop.com/NkxfOJM-qg/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/NkxfOJM-qg/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/NkxfOJM-qg/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Arcade"
			]
		},
		"tags": {
			"en": [
				"Action",
				"Boys",
				"Endless",
				"Exclusive",
				"Fun",
				"Animal",
				"Arcade"
			]
		},
		"width": 338,
		"height": 600,
		"colorMuted": "#435759",
		"colorVibrant": "#044c0c",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 8311718,
		"hasIntegratedAds": false
	},
	{
		"code": "6tEYzgxz2",
		"url": "https://9786.play.gamezop.com/g/6tEYzgxz2",
		"name": {
			"en": "Soccer Wizard"
		},
		"isPortrait": false,
		"description": {
			"en": "Bring out the soccer pro, play it like a wizard. Unleash a volley of goals, rain it like a blizzard!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/6tEYzgxz2/cover.jpg",
			"brick": "https://static.gamezop.com/6tEYzgxz2/brick.png",
			"thumb": "https://static.gamezop.com/6tEYzgxz2/thumb.png",
			"wall": "https://static.gamezop.com/6tEYzgxz2/wall.png",
			"square": "https://static.gamezop.com/6tEYzgxz2/square.png",
			"screens": [
				"https://static.gamezop.com/6tEYzgxz2/game-1.png",
				"https://static.gamezop.com/6tEYzgxz2/game-2.png",
				"https://static.gamezop.com/6tEYzgxz2/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/6tEYzgxz2/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/6tEYzgxz2/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": []
		},
		"width": 960,
		"height": 600,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 37762,
		"hasIntegratedAds": false
	},
	{
		"code": "Bk25EzR7T",
		"url": "https://9786.play.gamezop.com/g/Bk25EzR7T",
		"name": {
			"en": "Slit Sight"
		},
		"isPortrait": true,
		"description": {
			"en": "Fun precision game where you have to shoot a ball without touching the spinning obstacles."
		},
		"gamePreviews": {
			"en": "https://youtu.be/c8ZSaazDFlQ"
		},
		"assets": {
			"cover": "https://static.gamezop.com/Bk25EzR7T/cover.jpg",
			"brick": "https://static.gamezop.com/Bk25EzR7T/brick.png",
			"thumb": "https://static.gamezop.com/Bk25EzR7T/thumb.png",
			"wall": "https://static.gamezop.com/Bk25EzR7T/wall.png",
			"square": "https://static.gamezop.com/Bk25EzR7T/square.png",
			"screens": [
				"https://static.gamezop.com/Bk25EzR7T/game-1.png",
				"https://static.gamezop.com/Bk25EzR7T/game-2.png",
				"https://static.gamezop.com/Bk25EzR7T/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/Bk25EzR7T/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/Bk25EzR7T/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": [
				"Boys",
				"Endless",
				"Fun",
				"Arcade",
				"Minimal"
			]
		},
		"width": 338,
		"height": 600,
		"colorMuted": "#087090",
		"colorVibrant": "#0ca4d4",
		"privateAllowed": true,
		"rating": 4.75,
		"numberOfRatings": 1,
		"gamePlays": 129297343,
		"hasIntegratedAds": false
	},
	{
		"code": "SkyRBO1b",
		"url": "https://9786.play.gamezop.com/g/SkyRBO1b",
		"name": {
			"en": "Oh Yes"
		},
		"isPortrait": true,
		"description": {
			"en": "It is a little logic game where you have to fill the grid with either red or blue tiles."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/SkyRBO1b/cover.jpg",
			"brick": "https://static.gamezop.com/SkyRBO1b/brick.png",
			"thumb": "https://static.gamezop.com/SkyRBO1b/thumb.png",
			"wall": "https://static.gamezop.com/SkyRBO1b/wall.png",
			"square": "https://static.gamezop.com/SkyRBO1b/square.png",
			"screens": [
				"https://static.gamezop.com/SkyRBO1b/game-1.png",
				"https://static.gamezop.com/SkyRBO1b/game-2.png",
				"https://static.gamezop.com/SkyRBO1b/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SkyRBO1b/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SkyRBO1b/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": [
				"Board",
				"Boys",
				"Logic",
				"Family",
				"Fun",
				"Strategy",
				"Minimal",
				"Puzzle",
				"Difficult"
			]
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#432b24",
		"colorVibrant": "#1c6474",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 1027011,
		"hasIntegratedAds": false
	},
	{
		"code": "rJWyhp79RS",
		"url": "https://9786.play.gamezop.com/g/rJWyhp79RS",
		"name": {
			"en": "Snakes & Ladders"
		},
		"isPortrait": false,
		"description": {
			"en": "Ladders take you up, and snakes bring you down. Be the first to get to 100 to win!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/_HhP0XRk3Z4\r"
		},
		"assets": {
			"cover": "https://static.gamezop.com/rJWyhp79RS/cover.jpg",
			"brick": "https://static.gamezop.com/rJWyhp79RS/brick.png",
			"thumb": "https://static.gamezop.com/rJWyhp79RS/thumb.png",
			"wall": "https://static.gamezop.com/rJWyhp79RS/wall.png",
			"square": "https://static.gamezop.com/rJWyhp79RS/square.png",
			"screens": [
				"https://static.gamezop.com/rJWyhp79RS/game-1.png",
				"https://static.gamezop.com/rJWyhp79RS/game-2.png",
				"https://static.gamezop.com/rJWyhp79RS/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/rJWyhp79RS/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/rJWyhp79RS/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": []
		},
		"width": 1000,
		"height": 800,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": false,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 2323418,
		"hasIntegratedAds": false
	},
	{
		"code": "rybx12amqCB",
		"url": "https://9786.play.gamezop.com/g/rybx12amqCB",
		"name": {
			"en": "Don't Touch the Walls"
		},
		"isPortrait": true,
		"description": {
			"en": "Be quick with your moves and navigate the maze without touching the walls! The longer you play without touching any of the walls, the more you score. Watch out for the turns!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/KmNYWJ09d3k"
		},
		"assets": {
			"cover": "https://static.gamezop.com/rybx12amqCB/cover.jpg",
			"brick": "https://static.gamezop.com/rybx12amqCB/brick.png",
			"thumb": "https://static.gamezop.com/rybx12amqCB/thumb.png",
			"wall": "https://static.gamezop.com/rybx12amqCB/wall.png",
			"square": "https://static.gamezop.com/rybx12amqCB/square.png",
			"screens": [
				"https://static.gamezop.com/rybx12amqCB/game-1.png",
				"https://static.gamezop.com/rybx12amqCB/game-2.png",
				"https://static.gamezop.com/rybx12amqCB/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/rybx12amqCB/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/rybx12amqCB/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": []
		},
		"width": 1080,
		"height": 1920,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 2669044,
		"hasIntegratedAds": false
	},
	{
		"code": "HyIM86VXAe",
		"url": "https://9786.play.gamezop.com/g/HyIM86VXAe",
		"name": {
			"en": "Hats Off"
		},
		"isPortrait": true,
		"description": {
			"en": "Flip the players' hats and land them back on their heads. Hat throw shots are fun!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/YUE_AbKtpB0"
		},
		"assets": {
			"cover": "https://static.gamezop.com/HyIM86VXAe/cover.jpg",
			"brick": "https://static.gamezop.com/HyIM86VXAe/brick.png",
			"thumb": "https://static.gamezop.com/HyIM86VXAe/thumb.png",
			"wall": "https://static.gamezop.com/HyIM86VXAe/wall.png",
			"square": "https://static.gamezop.com/HyIM86VXAe/square.png",
			"screens": [
				"https://static.gamezop.com/HyIM86VXAe/game-1.png",
				"https://static.gamezop.com/HyIM86VXAe/game-2.png",
				"https://static.gamezop.com/HyIM86VXAe/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/HyIM86VXAe/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/HyIM86VXAe/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": [
				"Boys",
				"Endless",
				"Fun",
				"Kids",
				"Physics",
				"Cute"
			]
		},
		"width": 338,
		"height": 600,
		"colorMuted": "#64473c",
		"colorVibrant": "#04c4dc",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 6072897,
		"hasIntegratedAds": false
	},
	{
		"code": "BJrMI6E7Rl",
		"url": "https://9786.play.gamezop.com/g/BJrMI6E7Rl",
		"name": {
			"en": "Twin Hop"
		},
		"isPortrait": true,
		"description": {
			"en": "This Jumper must always be the same color as the pillar it wants to jump on. Can you keep up?"
		},
		"gamePreviews": {
			"en": "https://youtu.be/UqG7Hjh6_oU"
		},
		"assets": {
			"cover": "https://static.gamezop.com/BJrMI6E7Rl/cover.jpg",
			"brick": "https://static.gamezop.com/BJrMI6E7Rl/brick.png",
			"thumb": "https://static.gamezop.com/BJrMI6E7Rl/thumb.png",
			"wall": "https://static.gamezop.com/BJrMI6E7Rl/wall.png",
			"square": "https://static.gamezop.com/BJrMI6E7Rl/square.png",
			"screens": [
				"https://static.gamezop.com/BJrMI6E7Rl/game-1.png",
				"https://static.gamezop.com/BJrMI6E7Rl/game-2.png",
				"https://static.gamezop.com/BJrMI6E7Rl/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/BJrMI6E7Rl/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/BJrMI6E7Rl/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": [
				"Logic",
				"Endless",
				"Family",
				"Kids",
				"Arcade",
				"Cute"
			]
		},
		"width": 338,
		"height": 600,
		"colorMuted": "#754e8f",
		"colorVibrant": "#4d2265",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 3117047,
		"hasIntegratedAds": false
	},
	{
		"code": "XuSI73Wi5",
		"url": "https://9786.play.gamezop.com/g/XuSI73Wi5",
		"name": {
			"en": "From Nerd to School Popular"
		},
		"isPortrait": false,
		"description": {
			"en": "Dress up and style: from nerd to cool! In this game, you set the rules. Transform your look, be all the rage, from school outcast to center stage!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/XuSI73Wi5/cover.jpg",
			"brick": "https://static.gamezop.com/XuSI73Wi5/brick.png",
			"thumb": "https://static.gamezop.com/XuSI73Wi5/thumb.png",
			"wall": "https://static.gamezop.com/XuSI73Wi5/wall.png",
			"square": "https://static.gamezop.com/XuSI73Wi5/square.png",
			"screens": [
				"https://static.gamezop.com/XuSI73Wi5/game-1.png",
				"https://static.gamezop.com/XuSI73Wi5/game-2.png",
				"https://static.gamezop.com/XuSI73Wi5/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/XuSI73Wi5/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/XuSI73Wi5/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": [
				"New Games"
			]
		},
		"width": 1400,
		"height": 600,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 13197,
		"hasIntegratedAds": false
	},
	{
		"code": "HkTQJhTXqRS",
		"url": "https://9786.play.gamezop.com/g/HkTQJhTXqRS",
		"name": {
			"en": "Boulder Blast"
		},
		"isPortrait": true,
		"description": {
			"en": "Keep shooting the boulders that fall from the skies. Use coins to upgrade your cannons as you level up. How many levels can you survive?"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/HkTQJhTXqRS/cover.jpg",
			"brick": "https://static.gamezop.com/HkTQJhTXqRS/brick.png",
			"thumb": "https://static.gamezop.com/HkTQJhTXqRS/thumb.png",
			"wall": "https://static.gamezop.com/HkTQJhTXqRS/wall.png",
			"square": "https://static.gamezop.com/HkTQJhTXqRS/square.png",
			"screens": [
				"https://static.gamezop.com/HkTQJhTXqRS/game-1.png",
				"https://static.gamezop.com/HkTQJhTXqRS/game-2.png",
				"https://static.gamezop.com/HkTQJhTXqRS/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/HkTQJhTXqRS/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/HkTQJhTXqRS/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Action"
			]
		},
		"tags": {
			"en": []
		},
		"width": 540,
		"height": 960,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 2.8,
		"numberOfRatings": 5,
		"gamePlays": 20792867,
		"hasIntegratedAds": true
	},
	{
		"code": "ByAWPfLYdJx",
		"url": "https://9786.play.gamezop.com/g/ByAWPfLYdJx",
		"name": {
			"en": "Trap & Kill Virus"
		},
		"isPortrait": true,
		"description": {
			"en": "Kill the virus by capturing areas of the screen. Beware, they multiply fast. Don’t go too close or you die."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/ByAWPfLYdJx/cover.jpg",
			"brick": "https://static.gamezop.com/ByAWPfLYdJx/brick.png",
			"thumb": "https://static.gamezop.com/ByAWPfLYdJx/thumb.png",
			"wall": "https://static.gamezop.com/ByAWPfLYdJx/wall.png",
			"square": "https://static.gamezop.com/ByAWPfLYdJx/square.png",
			"screens": [
				"https://static.gamezop.com/ByAWPfLYdJx/game-1.png",
				"https://static.gamezop.com/ByAWPfLYdJx/game-2.png",
				"https://static.gamezop.com/ByAWPfLYdJx/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/ByAWPfLYdJx/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/ByAWPfLYdJx/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": [
				"Logic",
				"Family",
				"Girls",
				"Kids",
				"Level-based",
				"Puzzle"
			]
		},
		"width": 375,
		"height": 600,
		"colorMuted": "#4c3c69",
		"colorVibrant": "#871e3e",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 8389295,
		"hasIntegratedAds": false
	},
	{
		"code": "H1CWk36mq0S",
		"url": "https://9786.play.gamezop.com/g/H1CWk36mq0S",
		"name": {
			"en": "Crossbar Shots"
		},
		"isPortrait": false,
		"description": {
			"en": "Aim the football at the crossbar - how hard can it be, right? Try scoring 100 in this game to find out!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/H1CWk36mq0S/cover.jpg",
			"brick": "https://static.gamezop.com/H1CWk36mq0S/brick.png",
			"thumb": "https://static.gamezop.com/H1CWk36mq0S/thumb.png",
			"wall": "https://static.gamezop.com/H1CWk36mq0S/wall.png",
			"square": "https://static.gamezop.com/H1CWk36mq0S/square.png",
			"screens": [
				"https://static.gamezop.com/H1CWk36mq0S/game-1.png",
				"https://static.gamezop.com/H1CWk36mq0S/game-2.png",
				"https://static.gamezop.com/H1CWk36mq0S/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/H1CWk36mq0S/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/H1CWk36mq0S/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": []
		},
		"width": 1136,
		"height": 640,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 3.33,
		"numberOfRatings": 3,
		"gamePlays": 1143964,
		"hasIntegratedAds": false
	},
	{
		"code": "SkGIa4X0l",
		"url": "https://9786.play.gamezop.com/g/SkGIa4X0l",
		"name": {
			"en": "Pai Gow Poker"
		},
		"isPortrait": false,
		"description": {
			"en": "The best Pai Gow Poker online! Bring out your high hands and low hands, and beat the dealer."
		},
		"gamePreviews": {
			"en": "https://youtu.be/KsjB4QHTB4Q"
		},
		"assets": {
			"cover": "https://static.gamezop.com/SkGIa4X0l/cover.jpg",
			"brick": "https://static.gamezop.com/SkGIa4X0l/brick.png",
			"thumb": "https://static.gamezop.com/SkGIa4X0l/thumb.png",
			"wall": "https://static.gamezop.com/SkGIa4X0l/wall.png",
			"square": "https://static.gamezop.com/SkGIa4X0l/square.png",
			"screens": [
				"https://static.gamezop.com/SkGIa4X0l/game-1.png",
				"https://static.gamezop.com/SkGIa4X0l/game-2.png",
				"https://static.gamezop.com/SkGIa4X0l/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SkGIa4X0l/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SkGIa4X0l/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": [
				"Cards",
				"Endless",
				"Strategy",
				"Casino"
			]
		},
		"width": 1133,
		"height": 512,
		"colorMuted": "#437945",
		"colorVibrant": "#1c6c3d",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 799613,
		"hasIntegratedAds": false
	},
	{
		"code": "rJDlAKHbdV",
		"url": "https://9786.play.gamezop.com/g/rJDlAKHbdV",
		"name": {
			"en": "Sir Bottomtight"
		},
		"isPortrait": false,
		"description": {
			"en": "Run through the jungle, jump over bottomless pits, and fight with evil cannibals in this action game."
		},
		"gamePreviews": {
			"en": "https://youtu.be/Ogn1cb7gQ-0"
		},
		"assets": {
			"cover": "https://static.gamezop.com/rJDlAKHbdV/cover.jpg",
			"brick": "https://static.gamezop.com/rJDlAKHbdV/brick.png",
			"thumb": "https://static.gamezop.com/rJDlAKHbdV/thumb.png",
			"wall": "https://static.gamezop.com/rJDlAKHbdV/wall.png",
			"square": "https://static.gamezop.com/rJDlAKHbdV/square.png",
			"screens": [
				"https://static.gamezop.com/rJDlAKHbdV/game-1.png",
				"https://static.gamezop.com/rJDlAKHbdV/game-2.png",
				"https://static.gamezop.com/rJDlAKHbdV/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/rJDlAKHbdV/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/rJDlAKHbdV/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": [
				"Action",
				"Adventure",
				"Endless",
				"Shooting",
				"Kids"
			]
		},
		"width": 800,
		"height": 600,
		"colorMuted": "#4d4822",
		"colorVibrant": "#5e2b12",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 2278189,
		"hasIntegratedAds": false
	},
	{
		"code": "Bk9MJhpX5Ar",
		"url": "https://9786.play.gamezop.com/g/Bk9MJhpX5Ar",
		"name": {
			"en": "Witch Flight"
		},
		"isPortrait": true,
		"description": {
			"en": "The night is dark and it's raining on Halloween night, let's bust some pumpkins to get our Witch a swishing Flight!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/Bk9MJhpX5Ar/cover.jpg",
			"brick": "https://static.gamezop.com/Bk9MJhpX5Ar/brick.png",
			"thumb": "https://static.gamezop.com/Bk9MJhpX5Ar/thumb.png",
			"wall": "https://static.gamezop.com/Bk9MJhpX5Ar/wall.png",
			"square": "https://static.gamezop.com/Bk9MJhpX5Ar/square.png",
			"screens": [
				"https://static.gamezop.com/Bk9MJhpX5Ar/game-1.png",
				"https://static.gamezop.com/Bk9MJhpX5Ar/game-2.png",
				"https://static.gamezop.com/Bk9MJhpX5Ar/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/Bk9MJhpX5Ar/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/Bk9MJhpX5Ar/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": []
		},
		"width": 640,
		"height": 1140,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 620976,
		"hasIntegratedAds": false
	},
	{
		"code": "rJXlRtBWd4",
		"url": "https://9786.play.gamezop.com/g/rJXlRtBWd4",
		"name": {
			"en": "Pumpkin Smasher"
		},
		"isPortrait": false,
		"description": {
			"en": "Your object is simple: tap on flying pumpkins to smash them up into pieces but avoid bombs."
		},
		"gamePreviews": {
			"en": "https://youtu.be/5X8b0eQ40So"
		},
		"assets": {
			"cover": "https://static.gamezop.com/rJXlRtBWd4/cover.jpg",
			"brick": "https://static.gamezop.com/rJXlRtBWd4/brick.png",
			"thumb": "https://static.gamezop.com/rJXlRtBWd4/thumb.png",
			"wall": "https://static.gamezop.com/rJXlRtBWd4/wall.png",
			"square": "https://static.gamezop.com/rJXlRtBWd4/square.png",
			"screens": [
				"https://static.gamezop.com/rJXlRtBWd4/game-1.png",
				"https://static.gamezop.com/rJXlRtBWd4/game-2.png",
				"https://static.gamezop.com/rJXlRtBWd4/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/rJXlRtBWd4/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/rJXlRtBWd4/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Action"
			]
		},
		"tags": {
			"en": [
				"Boys",
				"Endless",
				"Food",
				"Kids",
				"Arcade"
			]
		},
		"width": 800,
		"height": 600,
		"colorMuted": "#5a3430",
		"colorVibrant": "#b3350e",
		"privateAllowed": true,
		"rating": 3.78,
		"numberOfRatings": 17,
		"gamePlays": 24513645,
		"hasIntegratedAds": false
	},
	{
		"code": "SJz7-kTud",
		"url": "https://9786.play.gamezop.com/g/SJz7-kTud",
		"name": {
			"en": "Submarine Dash"
		},
		"isPortrait": false,
		"description": {
			"en": "Dive into an underwater world full of beauty where you can collect coins too... just a little bit of danger."
		},
		"gamePreviews": {
			"en": "https://youtu.be/KsepRmMqHXI"
		},
		"assets": {
			"cover": "https://static.gamezop.com/SJz7-kTud/cover.jpg",
			"brick": "https://static.gamezop.com/SJz7-kTud/brick.png",
			"thumb": "https://static.gamezop.com/SJz7-kTud/thumb.png",
			"wall": "https://static.gamezop.com/SJz7-kTud/wall.png",
			"square": "https://static.gamezop.com/SJz7-kTud/square.png",
			"screens": [
				"https://static.gamezop.com/SJz7-kTud/game-1.png",
				"https://static.gamezop.com/SJz7-kTud/game-2.png",
				"https://static.gamezop.com/SJz7-kTud/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SJz7-kTud/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SJz7-kTud/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": [
				"Adventure",
				"Boys",
				"Endless",
				"Family",
				"Girls",
				"Kids",
				"Arcade"
			]
		},
		"width": 960,
		"height": 640,
		"colorMuted": "#1b7d31",
		"colorVibrant": "#24a842",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 2398629,
		"hasIntegratedAds": false
	},
	{
		"code": "B1hCYSbdN",
		"url": "https://9786.play.gamezop.com/g/B1hCYSbdN",
		"name": {
			"en": "Let's Go Fishing"
		},
		"isPortrait": false,
		"description": {
			"en": "Become a fishing master by capturing maximum number of yummy fish in this adventure game."
		},
		"gamePreviews": {
			"en": "https://youtu.be/yupVdl1tduI"
		},
		"assets": {
			"cover": "https://static.gamezop.com/B1hCYSbdN/cover.jpg",
			"brick": "https://static.gamezop.com/B1hCYSbdN/brick.png",
			"thumb": "https://static.gamezop.com/B1hCYSbdN/thumb.png",
			"wall": "https://static.gamezop.com/B1hCYSbdN/wall.png",
			"square": "https://static.gamezop.com/B1hCYSbdN/square.png",
			"screens": [
				"https://static.gamezop.com/B1hCYSbdN/game-1.png",
				"https://static.gamezop.com/B1hCYSbdN/game-2.png",
				"https://static.gamezop.com/B1hCYSbdN/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/B1hCYSbdN/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/B1hCYSbdN/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": [
				"Adventure",
				"Boys",
				"Family",
				"Food",
				"Fun",
				"Animal",
				"Girls",
				"Kids",
				"Sports",
				"Cute"
			]
		},
		"width": 800,
		"height": 600,
		"colorMuted": "#8c7953",
		"colorVibrant": "#24348c",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 9975870,
		"hasIntegratedAds": false
	},
	{
		"code": "S1-bxXI39",
		"url": "https://9786.play.gamezop.com/g/S1-bxXI39",
		"name": {
			"en": "Monsterjong"
		},
		"isPortrait": true,
		"description": {
			"en": "Eliminate all pieces of monsters from the board in this solitaire game, Monsterjong."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/S1-bxXI39/cover.jpg",
			"brick": "https://static.gamezop.com/S1-bxXI39/brick.png",
			"thumb": "https://static.gamezop.com/S1-bxXI39/thumb.png",
			"wall": "https://static.gamezop.com/S1-bxXI39/wall.png",
			"square": "https://static.gamezop.com/S1-bxXI39/square.png",
			"screens": [
				"https://static.gamezop.com/S1-bxXI39/game-1.png",
				"https://static.gamezop.com/S1-bxXI39/game-2.png",
				"https://static.gamezop.com/S1-bxXI39/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/S1-bxXI39/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/S1-bxXI39/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": [
				"Board",
				"Logic",
				"Cards",
				"Classics",
				"Family",
				"Strategy",
				"Time Mgmt.",
				"Zombie",
				"Level-based",
				"Puzzle"
			]
		},
		"width": 525,
		"height": 600,
		"colorMuted": "#70463a",
		"colorVibrant": "#698315",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 1899494,
		"hasIntegratedAds": false
	},
	{
		"code": "UYiznUAya",
		"url": "https://9786.play.gamezop.com/g/UYiznUAya",
		"name": {
			"en": "Blazing Blades"
		},
		"isPortrait": true,
		"description": {
			"en": "It's time to set the stage on fire with the blaze of your Blades! Let's see how many boards you can smash without a miss?!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/UYiznUAya/cover.jpg",
			"brick": "https://static.gamezop.com/UYiznUAya/brick.png",
			"thumb": "https://static.gamezop.com/UYiznUAya/thumb.png",
			"wall": "https://static.gamezop.com/UYiznUAya/wall.png",
			"square": "https://static.gamezop.com/UYiznUAya/square.png",
			"screens": [
				"https://static.gamezop.com/UYiznUAya/game-1.png",
				"https://static.gamezop.com/UYiznUAya/game-2.png",
				"https://static.gamezop.com/UYiznUAya/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/UYiznUAya/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/UYiznUAya/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Action"
			]
		},
		"tags": {
			"en": []
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 2.17,
		"numberOfRatings": 3,
		"gamePlays": 181834044,
		"hasIntegratedAds": false
	},
	{
		"code": "rkmJ2aXcCS",
		"url": "https://9786.play.gamezop.com/g/rkmJ2aXcCS",
		"name": {
			"en": "Minesweeper Classic"
		},
		"isPortrait": true,
		"description": {
			"en": "The good old Minesweeper is here! The rule of the game is simple, the number on a block shows the number of mines adjacent to it and you have to flag all the mines. Can you do it?"
		},
		"gamePreviews": {
			"en": "https://youtu.be/cAuTE2WVC6I"
		},
		"assets": {
			"cover": "https://static.gamezop.com/rkmJ2aXcCS/cover.jpg",
			"brick": "https://static.gamezop.com/rkmJ2aXcCS/brick.png",
			"thumb": "https://static.gamezop.com/rkmJ2aXcCS/thumb.png",
			"wall": "https://static.gamezop.com/rkmJ2aXcCS/wall.png",
			"square": "https://static.gamezop.com/rkmJ2aXcCS/square.png",
			"screens": [
				"https://static.gamezop.com/rkmJ2aXcCS/game-1.png",
				"https://static.gamezop.com/rkmJ2aXcCS/game-2.png",
				"https://static.gamezop.com/rkmJ2aXcCS/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/rkmJ2aXcCS/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/rkmJ2aXcCS/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": []
		},
		"width": 768,
		"height": 1024,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": false,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 2406100,
		"hasIntegratedAds": false
	},
	{
		"code": "r1fl9VzRX6",
		"url": "https://9786.play.gamezop.com/g/r1fl9VzRX6",
		"name": {
			"en": "Pirate's Pillage! Aye! Aye!"
		},
		"isPortrait": true,
		"description": {
			"en": "A notorious pirate is out for his pot of gold. Help him outsmart his enemies and take the riches!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/r1fl9VzRX6/cover.jpg",
			"brick": "https://static.gamezop.com/r1fl9VzRX6/brick.png",
			"thumb": "https://static.gamezop.com/r1fl9VzRX6/thumb.png",
			"wall": "https://static.gamezop.com/r1fl9VzRX6/wall.png",
			"square": "https://static.gamezop.com/r1fl9VzRX6/square.png",
			"screens": [
				"https://static.gamezop.com/r1fl9VzRX6/game-1.png",
				"https://static.gamezop.com/r1fl9VzRX6/game-2.png",
				"https://static.gamezop.com/r1fl9VzRX6/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/r1fl9VzRX6/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/r1fl9VzRX6/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": [
				"Adventure",
				"Strategy",
				"Arcade",
				"Level-based",
				"HD"
			]
		},
		"width": 960,
		"height": 1440,
		"colorMuted": "#523825",
		"colorVibrant": "#0ea024",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 3498777,
		"hasIntegratedAds": false
	},
	{
		"code": "SJMB7qTb",
		"url": "https://9786.play.gamezop.com/g/SJMB7qTb",
		"name": {
			"en": "Ooltaa"
		},
		"isPortrait": true,
		"description": {
			"en": "Defend your base against the incoming enemy horde. Be sure to tap right to kill the filth!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/4u1qb6o85vQ"
		},
		"assets": {
			"cover": "https://static.gamezop.com/SJMB7qTb/cover.jpg",
			"brick": "https://static.gamezop.com/SJMB7qTb/brick.png",
			"thumb": "https://static.gamezop.com/SJMB7qTb/thumb.png",
			"wall": "https://static.gamezop.com/SJMB7qTb/wall.png",
			"square": "https://static.gamezop.com/SJMB7qTb/square.png",
			"screens": [
				"https://static.gamezop.com/SJMB7qTb/game-1.png",
				"https://static.gamezop.com/SJMB7qTb/game-2.png",
				"https://static.gamezop.com/SJMB7qTb/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SJMB7qTb/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SJMB7qTb/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Action"
			]
		},
		"tags": {
			"en": [
				"Action",
				"Adventure",
				"Boys",
				"Endless",
				"Exclusive",
				"Shooting",
				"Space"
			]
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#3b2c54",
		"colorVibrant": "#872c29",
		"privateAllowed": true,
		"rating": 4.75,
		"numberOfRatings": 1,
		"gamePlays": 3039953,
		"hasIntegratedAds": false
	},
	{
		"code": "SkRZZUoXI8g",
		"url": "https://9786.play.gamezop.com/g/SkRZZUoXI8g",
		"name": {
			"en": "Jello Go Round"
		},
		"isPortrait": true,
		"description": {
			"en": "Change shapes and colors as Mr. Jello goes around the world eating little jelly cubes!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/zU6YwS4HB58"
		},
		"assets": {
			"cover": "https://static.gamezop.com/SkRZZUoXI8g/cover.jpg",
			"brick": "https://static.gamezop.com/SkRZZUoXI8g/brick.png",
			"thumb": "https://static.gamezop.com/SkRZZUoXI8g/thumb.png",
			"wall": "https://static.gamezop.com/SkRZZUoXI8g/wall.png",
			"square": "https://static.gamezop.com/SkRZZUoXI8g/square.png",
			"screens": [
				"https://static.gamezop.com/SkRZZUoXI8g/game-1.png",
				"https://static.gamezop.com/SkRZZUoXI8g/game-2.png",
				"https://static.gamezop.com/SkRZZUoXI8g/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SkRZZUoXI8g/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SkRZZUoXI8g/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": [
				"Arcade",
				"Endless",
				"Food",
				"Boys",
				"Kids"
			]
		},
		"width": 338,
		"height": 600,
		"colorMuted": "#8d744d",
		"colorVibrant": "#5c346c",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 6318126,
		"hasIntegratedAds": false
	},
	{
		"code": "HJY4pfJP9JQ",
		"url": "https://9786.play.gamezop.com/g/HJY4pfJP9JQ",
		"name": {
			"en": "Table Tennis Shots"
		},
		"isPortrait": true,
		"description": {
			"en": "Try your best to keep the ball on the paddle for as long as you can and look out for surprises that will help you on the way to achieve the highest score!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/m9NtUT9m1pM"
		},
		"assets": {
			"cover": "https://static.gamezop.com/HJY4pfJP9JQ/cover.jpg",
			"brick": "https://static.gamezop.com/HJY4pfJP9JQ/brick.png",
			"thumb": "https://static.gamezop.com/HJY4pfJP9JQ/thumb.png",
			"wall": "https://static.gamezop.com/HJY4pfJP9JQ/wall.png",
			"square": "https://static.gamezop.com/HJY4pfJP9JQ/square.png",
			"screens": [
				"https://static.gamezop.com/HJY4pfJP9JQ/game-1.png",
				"https://static.gamezop.com/HJY4pfJP9JQ/game-2.png",
				"https://static.gamezop.com/HJY4pfJP9JQ/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/HJY4pfJP9JQ/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/HJY4pfJP9JQ/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": []
		},
		"width": 640,
		"height": 1136,
		"colorMuted": "#416f48",
		"colorVibrant": "#b04b31",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 21045474,
		"hasIntegratedAds": false
	},
	{
		"code": "r1z13aXqAB",
		"url": "https://9786.play.gamezop.com/g/r1z13aXqAB",
		"name": {
			"en": "Flappy Foot Chinko"
		},
		"isPortrait": true,
		"description": {
			"en": "Dribble the football through the adventures of this game: through fielders and defenders, through pigs and electric poles! Just don't lose!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/5Ldu_N925v0"
		},
		"assets": {
			"cover": "https://static.gamezop.com/r1z13aXqAB/cover.jpg",
			"brick": "https://static.gamezop.com/r1z13aXqAB/brick.png",
			"thumb": "https://static.gamezop.com/r1z13aXqAB/thumb.png",
			"wall": "https://static.gamezop.com/r1z13aXqAB/wall.png",
			"square": "https://static.gamezop.com/r1z13aXqAB/square.png",
			"screens": [
				"https://static.gamezop.com/r1z13aXqAB/game-1.png",
				"https://static.gamezop.com/r1z13aXqAB/game-2.png",
				"https://static.gamezop.com/r1z13aXqAB/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/r1z13aXqAB/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/r1z13aXqAB/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": []
		},
		"width": 600,
		"height": 800,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 7573010,
		"hasIntegratedAds": false
	},
	{
		"code": "H1PJn6mqAr",
		"url": "https://9786.play.gamezop.com/g/H1PJn6mqAr",
		"name": {
			"en": "Knife Flip"
		},
		"isPortrait": true,
		"description": {
			"en": "You have to make the Knife flip from pillar to post! The objective of the game is simple: don't fall down."
		},
		"gamePreviews": {
			"en": "https://youtu.be/w1t-5Ef4SF4"
		},
		"assets": {
			"cover": "https://static.gamezop.com/H1PJn6mqAr/cover.jpg",
			"brick": "https://static.gamezop.com/H1PJn6mqAr/brick.png",
			"thumb": "https://static.gamezop.com/H1PJn6mqAr/thumb.png",
			"wall": "https://static.gamezop.com/H1PJn6mqAr/wall.png",
			"square": "https://static.gamezop.com/H1PJn6mqAr/square.png",
			"screens": [
				"https://static.gamezop.com/H1PJn6mqAr/game-1.png",
				"https://static.gamezop.com/H1PJn6mqAr/game-2.png",
				"https://static.gamezop.com/H1PJn6mqAr/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/H1PJn6mqAr/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/H1PJn6mqAr/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": []
		},
		"width": 540,
		"height": 960,
		"colorMuted": "#58A193",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 51791757,
		"hasIntegratedAds": false
	},
	{
		"code": "r1u7J3TmqCS",
		"url": "https://9786.play.gamezop.com/g/r1u7J3TmqCS",
		"name": {
			"en": "Hero Archer"
		},
		"isPortrait": true,
		"description": {
			"en": "How good are you with a bow and arrows? Strike down fruits from over people's heads to find out in this beautiful game!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/r1u7J3TmqCS/cover.jpg",
			"brick": "https://static.gamezop.com/r1u7J3TmqCS/brick.png",
			"thumb": "https://static.gamezop.com/r1u7J3TmqCS/thumb.png",
			"wall": "https://static.gamezop.com/r1u7J3TmqCS/wall.png",
			"square": "https://static.gamezop.com/r1u7J3TmqCS/square.png",
			"screens": [
				"https://static.gamezop.com/r1u7J3TmqCS/game-1.png",
				"https://static.gamezop.com/r1u7J3TmqCS/game-2.png",
				"https://static.gamezop.com/r1u7J3TmqCS/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/r1u7J3TmqCS/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/r1u7J3TmqCS/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": []
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 2,
		"numberOfRatings": 1,
		"gamePlays": 2692208,
		"hasIntegratedAds": false
	},
	{
		"code": "rJ57aMJDcJm",
		"url": "https://9786.play.gamezop.com/g/rJ57aMJDcJm",
		"name": {
			"en": "Go Chicken Go"
		},
		"isPortrait": false,
		"description": {
			"en": "There's a group of chickens that need to cross the road, and they need to do that quick. Just try and avoid blood!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/fsqtxZnVEHI"
		},
		"assets": {
			"cover": "https://static.gamezop.com/rJ57aMJDcJm/cover.jpg",
			"brick": "https://static.gamezop.com/rJ57aMJDcJm/brick.png",
			"thumb": "https://static.gamezop.com/rJ57aMJDcJm/thumb.png",
			"wall": "https://static.gamezop.com/rJ57aMJDcJm/wall.png",
			"square": "https://static.gamezop.com/rJ57aMJDcJm/square.png",
			"screens": [
				"https://static.gamezop.com/rJ57aMJDcJm/game-1.png",
				"https://static.gamezop.com/rJ57aMJDcJm/game-2.png",
				"https://static.gamezop.com/rJ57aMJDcJm/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/rJ57aMJDcJm/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/rJ57aMJDcJm/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": []
		},
		"width": 800,
		"height": 450,
		"colorMuted": "#50444c",
		"colorVibrant": "#913207",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 5661209,
		"hasIntegratedAds": false
	},
	{
		"code": "H1eGU64XRg",
		"url": "https://9786.play.gamezop.com/g/H1eGU64XRg",
		"name": {
			"en": "High or Low"
		},
		"isPortrait": false,
		"description": {
			"en": "It's a game of luck! What do you instincts say - will it be a high card, or a low card? "
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/H1eGU64XRg/cover.jpg",
			"brick": "https://static.gamezop.com/H1eGU64XRg/brick.png",
			"thumb": "https://static.gamezop.com/H1eGU64XRg/thumb.png",
			"wall": "https://static.gamezop.com/H1eGU64XRg/wall.png",
			"square": "https://static.gamezop.com/H1eGU64XRg/square.png",
			"screens": [
				"https://static.gamezop.com/H1eGU64XRg/game-1.png",
				"https://static.gamezop.com/H1eGU64XRg/game-2.png",
				"https://static.gamezop.com/H1eGU64XRg/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/H1eGU64XRg/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/H1eGU64XRg/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": [
				"Cards",
				"Classics",
				"Endless",
				"Strategy",
				"Casino"
			]
		},
		"width": 800,
		"height": 450,
		"colorMuted": "#844444",
		"colorVibrant": "#800404",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 1044096,
		"hasIntegratedAds": false
	},
	{
		"code": "S1Ne12TQqCH",
		"url": "https://9786.play.gamezop.com/g/S1Ne12TQqCH",
		"name": {
			"en": "Dunk Shot"
		},
		"isPortrait": true,
		"description": {
			"en": "Pull, aim, shoot! Jump from hoop to hoop and make a high score. Unlock new balls from the stars you collect!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/S1Ne12TQqCH/cover.jpg",
			"brick": "https://static.gamezop.com/S1Ne12TQqCH/brick.png",
			"thumb": "https://static.gamezop.com/S1Ne12TQqCH/thumb.png",
			"wall": "https://static.gamezop.com/S1Ne12TQqCH/wall.png",
			"square": "https://static.gamezop.com/S1Ne12TQqCH/square.png",
			"screens": [
				"https://static.gamezop.com/S1Ne12TQqCH/game-1.png",
				"https://static.gamezop.com/S1Ne12TQqCH/game-2.png",
				"https://static.gamezop.com/S1Ne12TQqCH/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/S1Ne12TQqCH/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/S1Ne12TQqCH/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": []
		},
		"width": 1080,
		"height": 1920,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 3.5,
		"numberOfRatings": 1,
		"gamePlays": 6035139,
		"hasIntegratedAds": true
	},
	{
		"code": "HJKWbUj788l",
		"url": "https://9786.play.gamezop.com/g/HJKWbUj788l",
		"name": {
			"en": "Clay Pigeon: Tap and Shoot"
		},
		"isPortrait": false,
		"description": {
			"en": "Here's your chance to control a professional sniper and aim skeets in a shooting challenge."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/HJKWbUj788l/cover.jpg",
			"brick": "https://static.gamezop.com/HJKWbUj788l/brick.png",
			"thumb": "https://static.gamezop.com/HJKWbUj788l/thumb.png",
			"wall": "https://static.gamezop.com/HJKWbUj788l/wall.png",
			"square": "https://static.gamezop.com/HJKWbUj788l/square.png",
			"screens": [
				"https://static.gamezop.com/HJKWbUj788l/game-1.png",
				"https://static.gamezop.com/HJKWbUj788l/game-2.png",
				"https://static.gamezop.com/HJKWbUj788l/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/HJKWbUj788l/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/HJKWbUj788l/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": [
				"3D",
				"Boys",
				"Shooting",
				"Physics",
				"Sports",
				"Difficult"
			]
		},
		"width": 800,
		"height": 480,
		"colorMuted": "#3c4d32",
		"colorVibrant": "#880c0a",
		"privateAllowed": false,
		"rating": 4.25,
		"numberOfRatings": 2,
		"gamePlays": 2424577,
		"hasIntegratedAds": false
	},
	{
		"code": "S1kGWUim8Ux",
		"url": "https://9786.play.gamezop.com/g/S1kGWUim8Ux",
		"name": {
			"en": "Shadow Run"
		},
		"isPortrait": true,
		"description": {
			"en": "Guide the ninja to move swiftly between pointed obstacles and climb reach great heights!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/jNI6lqwpDZU"
		},
		"assets": {
			"cover": "https://static.gamezop.com/S1kGWUim8Ux/cover.jpg",
			"brick": "https://static.gamezop.com/S1kGWUim8Ux/brick.png",
			"thumb": "https://static.gamezop.com/S1kGWUim8Ux/thumb.png",
			"wall": "https://static.gamezop.com/S1kGWUim8Ux/wall.png",
			"square": "https://static.gamezop.com/S1kGWUim8Ux/square.png",
			"screens": [
				"https://static.gamezop.com/S1kGWUim8Ux/game-1.png",
				"https://static.gamezop.com/S1kGWUim8Ux/game-2.png",
				"https://static.gamezop.com/S1kGWUim8Ux/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/S1kGWUim8Ux/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/S1kGWUim8Ux/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Action"
			]
		},
		"tags": {
			"en": [
				"Arcade",
				"Endless",
				"Fun",
				"Boys"
			]
		},
		"width": 338,
		"height": 600,
		"colorMuted": "#432b55",
		"colorVibrant": "#710a13",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 6632064,
		"hasIntegratedAds": false
	},
	{
		"code": "ryJGkhT7qAB",
		"url": "https://9786.play.gamezop.com/g/ryJGkhT7qAB",
		"name": {
			"en": "Bubble Smash"
		},
		"isPortrait": true,
		"description": {
			"en": "Aim and Shoot to Merge and Fuse! Don't let the Bubbles touch ground, or you'll lose!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/ryJGkhT7qAB/cover.jpg",
			"brick": "https://static.gamezop.com/ryJGkhT7qAB/brick.png",
			"thumb": "https://static.gamezop.com/ryJGkhT7qAB/thumb.png",
			"wall": "https://static.gamezop.com/ryJGkhT7qAB/wall.png",
			"square": "https://static.gamezop.com/ryJGkhT7qAB/square.png",
			"screens": [
				"https://static.gamezop.com/ryJGkhT7qAB/game-1.png",
				"https://static.gamezop.com/ryJGkhT7qAB/game-2.png",
				"https://static.gamezop.com/ryJGkhT7qAB/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/ryJGkhT7qAB/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/ryJGkhT7qAB/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": []
		},
		"width": 1080,
		"height": 1920,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": false,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 4811263,
		"hasIntegratedAds": true
	},
	{
		"code": "rk-Rtrb_V",
		"url": "https://9786.play.gamezop.com/g/rk-Rtrb_V",
		"name": {
			"en": "Blackbeard's Island"
		},
		"isPortrait": false,
		"description": {
			"en": "Help Blackbeard collect gold but beware of the enemies on the way in this logic game."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/rk-Rtrb_V/cover.jpg",
			"brick": "https://static.gamezop.com/rk-Rtrb_V/brick.png",
			"thumb": "https://static.gamezop.com/rk-Rtrb_V/thumb.png",
			"wall": "https://static.gamezop.com/rk-Rtrb_V/wall.png",
			"square": "https://static.gamezop.com/rk-Rtrb_V/square.png",
			"screens": [
				"https://static.gamezop.com/rk-Rtrb_V/game-1.png",
				"https://static.gamezop.com/rk-Rtrb_V/game-2.png",
				"https://static.gamezop.com/rk-Rtrb_V/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/rk-Rtrb_V/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/rk-Rtrb_V/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": [
				"Adventure",
				"Logic",
				"Family",
				"Animal",
				"Strategy",
				"Arcade",
				"Level-based",
				"Story-based",
				"Puzzle"
			]
		},
		"width": 800,
		"height": 600,
		"colorMuted": "#343157",
		"colorVibrant": "#18590a",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 1252280,
		"hasIntegratedAds": false
	},
	{
		"code": "S1JXaMJDqJX",
		"url": "https://9786.play.gamezop.com/g/S1JXaMJDqJX",
		"name": {
			"en": "Cubes Got Moves"
		},
		"isPortrait": true,
		"description": {
			"en": "Roll over the cubes to their right spots. Cubes have different faces - put the correct faces on the correct spots to win."
		},
		"gamePreviews": {
			"en": "https://youtu.be/ns9lvrVo7R4"
		},
		"assets": {
			"cover": "https://static.gamezop.com/S1JXaMJDqJX/cover.jpg",
			"brick": "https://static.gamezop.com/S1JXaMJDqJX/brick.png",
			"thumb": "https://static.gamezop.com/S1JXaMJDqJX/thumb.png",
			"wall": "https://static.gamezop.com/S1JXaMJDqJX/wall.png",
			"square": "https://static.gamezop.com/S1JXaMJDqJX/square.png",
			"screens": [
				"https://static.gamezop.com/S1JXaMJDqJX/game-1.png",
				"https://static.gamezop.com/S1JXaMJDqJX/game-2.png",
				"https://static.gamezop.com/S1JXaMJDqJX/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/S1JXaMJDqJX/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/S1JXaMJDqJX/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": []
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#443e28",
		"colorVibrant": "#a7962d",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 1836013,
		"hasIntegratedAds": false
	},
	{
		"code": "PLQTtp9Ei",
		"url": "https://9786.play.gamezop.com/g/PLQTtp9Ei",
		"name": {
			"en": "Slide And Divide"
		},
		"isPortrait": true,
		"description": {
			"en": "Place it up, place it down, place it on the side. If you've found the number right, just Slide And Divide!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/PLQTtp9Ei/cover.jpg",
			"brick": "https://static.gamezop.com/PLQTtp9Ei/brick.png",
			"thumb": "https://static.gamezop.com/PLQTtp9Ei/thumb.png",
			"wall": "https://static.gamezop.com/PLQTtp9Ei/wall.png",
			"square": "https://static.gamezop.com/PLQTtp9Ei/square.png",
			"screens": [
				"https://static.gamezop.com/PLQTtp9Ei/game-1.png",
				"https://static.gamezop.com/PLQTtp9Ei/game-2.png",
				"https://static.gamezop.com/PLQTtp9Ei/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/PLQTtp9Ei/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/PLQTtp9Ei/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": []
		},
		"width": 750,
		"height": 1334,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 263511,
		"hasIntegratedAds": false
	},
	{
		"code": "B1SlRFrWuN",
		"url": "https://9786.play.gamezop.com/g/B1SlRFrWuN",
		"name": {
			"en": "Robotion"
		},
		"isPortrait": false,
		"description": {
			"en": "Rusty robots work in sets of two and are too old to move. Connect the right pair across 100s of levels!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/B1SlRFrWuN/cover.jpg",
			"brick": "https://static.gamezop.com/B1SlRFrWuN/brick.png",
			"thumb": "https://static.gamezop.com/B1SlRFrWuN/thumb.png",
			"wall": "https://static.gamezop.com/B1SlRFrWuN/wall.png",
			"square": "https://static.gamezop.com/B1SlRFrWuN/square.png",
			"screens": [
				"https://static.gamezop.com/B1SlRFrWuN/game-1.png",
				"https://static.gamezop.com/B1SlRFrWuN/game-2.png",
				"https://static.gamezop.com/B1SlRFrWuN/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/B1SlRFrWuN/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/B1SlRFrWuN/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": [
				"Logic",
				"Strategy",
				"Level-based",
				"Puzzle"
			]
		},
		"width": 800,
		"height": 600,
		"colorMuted": "#534c30",
		"colorVibrant": "#8c6814",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 376208,
		"hasIntegratedAds": false
	},
	{
		"code": "ryN9EGAQa",
		"url": "https://9786.play.gamezop.com/g/ryN9EGAQa",
		"name": {
			"en": "Slap Fest"
		},
		"isPortrait": true,
		"description": {
			"en": "Attack! Retreat! Slap! Be quick and make your opponent scream in pain."
		},
		"gamePreviews": {
			"en": "https://youtu.be/vZo4pfsPiA8"
		},
		"assets": {
			"cover": "https://static.gamezop.com/ryN9EGAQa/cover.jpg",
			"brick": "https://static.gamezop.com/ryN9EGAQa/brick.png",
			"thumb": "https://static.gamezop.com/ryN9EGAQa/thumb.png",
			"wall": "https://static.gamezop.com/ryN9EGAQa/wall.png",
			"square": "https://static.gamezop.com/ryN9EGAQa/square.png",
			"screens": [
				"https://static.gamezop.com/ryN9EGAQa/game-1.png",
				"https://static.gamezop.com/ryN9EGAQa/game-2.png",
				"https://static.gamezop.com/ryN9EGAQa/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/ryN9EGAQa/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/ryN9EGAQa/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Action"
			]
		},
		"tags": {
			"en": [
				"Endless",
				"Family",
				"Fun",
				"Kids"
			]
		},
		"width": 640,
		"height": 1136,
		"colorMuted": "#5c342c",
		"colorVibrant": "#691f1f",
		"privateAllowed": false,
		"rating": 4.12,
		"numberOfRatings": 23,
		"gamePlays": 28339048,
		"hasIntegratedAds": false
	},
	{
		"code": "QPcVkaHi1",
		"url": "https://9786.play.gamezop.com/g/QPcVkaHi1",
		"name": {
			"en": "Ninja Speed Runner"
		},
		"isPortrait": false,
		"description": {
			"en": "It's time to test your Ninja Running Skills! Dash through enemy territory as far as you can... ohh and don't get hit by their Shurikens!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/QPcVkaHi1/cover.jpg",
			"brick": "https://static.gamezop.com/QPcVkaHi1/brick.png",
			"thumb": "https://static.gamezop.com/QPcVkaHi1/thumb.png",
			"wall": "https://static.gamezop.com/QPcVkaHi1/wall.png",
			"square": "https://static.gamezop.com/QPcVkaHi1/square.png",
			"screens": [
				"https://static.gamezop.com/QPcVkaHi1/game-1.png",
				"https://static.gamezop.com/QPcVkaHi1/game-2.png",
				"https://static.gamezop.com/QPcVkaHi1/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/QPcVkaHi1/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/QPcVkaHi1/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Action"
			]
		},
		"tags": {
			"en": []
		},
		"width": 1920,
		"height": 1080,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 3,
		"numberOfRatings": 2,
		"gamePlays": 5804219,
		"hasIntegratedAds": false
	},
	{
		"code": "ry6bwfUt_Jg",
		"url": "https://9786.play.gamezop.com/g/ry6bwfUt_Jg",
		"name": {
			"en": "Savage Revenge"
		},
		"isPortrait": true,
		"description": {
			"en": "Help the savage run away from the castle dungeon! But be careful of the many lurking dangers!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/_MLLmgLzvvU"
		},
		"assets": {
			"cover": "https://static.gamezop.com/ry6bwfUt_Jg/cover.jpg",
			"brick": "https://static.gamezop.com/ry6bwfUt_Jg/brick.png",
			"thumb": "https://static.gamezop.com/ry6bwfUt_Jg/thumb.png",
			"wall": "https://static.gamezop.com/ry6bwfUt_Jg/wall.png",
			"square": "https://static.gamezop.com/ry6bwfUt_Jg/square.png",
			"screens": [
				"https://static.gamezop.com/ry6bwfUt_Jg/game-1.png",
				"https://static.gamezop.com/ry6bwfUt_Jg/game-2.png",
				"https://static.gamezop.com/ry6bwfUt_Jg/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/ry6bwfUt_Jg/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/ry6bwfUt_Jg/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Action"
			]
		},
		"tags": {
			"en": [
				"Action",
				"Boys",
				"Endless",
				"Fun"
			]
		},
		"width": 498,
		"height": 748,
		"colorMuted": "#483e2c",
		"colorVibrant": "#8c5009",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 9,
		"gamePlays": 23572440,
		"hasIntegratedAds": false
	},
	{
		"code": "SJcRYSbu4",
		"url": "https://9786.play.gamezop.com/g/SJcRYSbu4",
		"name": {
			"en": "Jelly Bears"
		},
		"isPortrait": false,
		"description": {
			"en": "Match bears of the same color to clear the level. P.S. Don't play this game when you are hungry."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/SJcRYSbu4/cover.jpg",
			"brick": "https://static.gamezop.com/SJcRYSbu4/brick.png",
			"thumb": "https://static.gamezop.com/SJcRYSbu4/thumb.png",
			"wall": "https://static.gamezop.com/SJcRYSbu4/wall.png",
			"square": "https://static.gamezop.com/SJcRYSbu4/square.png",
			"screens": [
				"https://static.gamezop.com/SJcRYSbu4/game-1.png",
				"https://static.gamezop.com/SJcRYSbu4/game-2.png",
				"https://static.gamezop.com/SJcRYSbu4/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SJcRYSbu4/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SJcRYSbu4/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": [
				"Family",
				"Fun",
				"Girls",
				"Kids",
				"Match-3",
				"Arcade",
				"Level-based"
			]
		},
		"width": 800,
		"height": 600,
		"colorMuted": "#663664",
		"colorVibrant": "#157511",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 1526899,
		"hasIntegratedAds": false
	},
	{
		"code": "ryTknTX5AS",
		"url": "https://9786.play.gamezop.com/g/ryTknTX5AS",
		"name": {
			"en": "Snake King"
		},
		"isPortrait": false,
		"description": {
			"en": "Snake King is a fun and easy game with a simple objective: take control of more and more territory by beating other snakes!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/ryTknTX5AS/cover.jpg",
			"brick": "https://static.gamezop.com/ryTknTX5AS/brick.png",
			"thumb": "https://static.gamezop.com/ryTknTX5AS/thumb.png",
			"wall": "https://static.gamezop.com/ryTknTX5AS/wall.png",
			"square": "https://static.gamezop.com/ryTknTX5AS/square.png",
			"screens": [
				"https://static.gamezop.com/ryTknTX5AS/game-1.png",
				"https://static.gamezop.com/ryTknTX5AS/game-2.png",
				"https://static.gamezop.com/ryTknTX5AS/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/ryTknTX5AS/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/ryTknTX5AS/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Arcade"
			]
		},
		"tags": {
			"en": []
		},
		"width": 1080,
		"height": 1920,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 11548010,
		"hasIntegratedAds": false
	},
	{
		"code": "SkkV6MJD51Q",
		"url": "https://9786.play.gamezop.com/g/SkkV6MJD51Q",
		"name": {
			"en": "Mafia Billiard Tricks"
		},
		"isPortrait": false,
		"description": {
			"en": "Face off against a mafia boss after each challenge in this 8 ball pool game. Beat all 8 bosses to complete the game! From a street rookie to a mafia lord - here's your chance!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/SkkV6MJD51Q/cover.jpg",
			"brick": "https://static.gamezop.com/SkkV6MJD51Q/brick.png",
			"thumb": "https://static.gamezop.com/SkkV6MJD51Q/thumb.png",
			"wall": "https://static.gamezop.com/SkkV6MJD51Q/wall.png",
			"square": "https://static.gamezop.com/SkkV6MJD51Q/square.png",
			"screens": [
				"https://static.gamezop.com/SkkV6MJD51Q/game-1.png",
				"https://static.gamezop.com/SkkV6MJD51Q/game-2.png",
				"https://static.gamezop.com/SkkV6MJD51Q/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SkkV6MJD51Q/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SkkV6MJD51Q/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": []
		},
		"width": 1024,
		"height": 640,
		"colorMuted": "#131717",
		"colorVibrant": "#047c6c",
		"privateAllowed": false,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 2741471,
		"hasIntegratedAds": false
	},
	{
		"code": "SkhljT2fdgb",
		"url": "https://9786.play.gamezop.com/g/SkhljT2fdgb",
		"name": {
			"en": "Ludo With Friends"
		},
		"isPortrait": true,
		"description": {
			"en": "Here's the best multiplayer Ludo game! Play with your friends or with thousands of other players online."
		},
		"gamePreviews": {
			"en": "https://youtu.be/hb9v8W75x4k"
		},
		"assets": {
			"cover": "https://static.gamezop.com/SkhljT2fdgb/cover.jpg",
			"brick": "https://static.gamezop.com/SkhljT2fdgb/brick.png",
			"thumb": "https://static.gamezop.com/SkhljT2fdgb/thumb.png",
			"wall": "https://static.gamezop.com/SkhljT2fdgb/wall.png",
			"square": "https://static.gamezop.com/SkhljT2fdgb/square.png",
			"screens": [
				"https://static.gamezop.com/SkhljT2fdgb/game-1.png",
				"https://static.gamezop.com/SkhljT2fdgb/game-2.png",
				"https://static.gamezop.com/SkhljT2fdgb/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SkhljT2fdgb/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SkhljT2fdgb/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": []
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#3b446e",
		"colorVibrant": "#6f110b",
		"privateAllowed": false,
		"rating": 3.58,
		"numberOfRatings": 12,
		"gamePlays": 71171621,
		"hasIntegratedAds": false
	},
	{
		"code": "rkPlk2T7qAr",
		"url": "https://9786.play.gamezop.com/g/rkPlk2T7qAr",
		"name": {
			"en": "Solitaire Gold"
		},
		"isPortrait": true,
		"description": {
			"en": "Solitaire Gold follows classic Solitaire rules: the catch is you only get 5 mins to play. The sooner you finish, the bigger the bonus you receive! Come, give it a try!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/rkPlk2T7qAr/cover.jpg",
			"brick": "https://static.gamezop.com/rkPlk2T7qAr/brick.png",
			"thumb": "https://static.gamezop.com/rkPlk2T7qAr/thumb.png",
			"wall": "https://static.gamezop.com/rkPlk2T7qAr/wall.png",
			"square": "https://static.gamezop.com/rkPlk2T7qAr/square.png",
			"screens": [
				"https://static.gamezop.com/rkPlk2T7qAr/game-1.png",
				"https://static.gamezop.com/rkPlk2T7qAr/game-2.png",
				"https://static.gamezop.com/rkPlk2T7qAr/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/rkPlk2T7qAr/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/rkPlk2T7qAr/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": []
		},
		"width": 768,
		"height": 1024,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 18616906,
		"hasIntegratedAds": false
	},
	{
		"code": "B1MXhUFQke",
		"url": "https://9786.play.gamezop.com/g/B1MXhUFQke",
		"name": {
			"en": "Tower Loot"
		},
		"isPortrait": false,
		"description": {
			"en": "Remove wooden objects off the game board to get a treasure chest next to the magician."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/B1MXhUFQke/cover.jpg",
			"brick": "https://static.gamezop.com/B1MXhUFQke/brick.png",
			"thumb": "https://static.gamezop.com/B1MXhUFQke/thumb.png",
			"wall": "https://static.gamezop.com/B1MXhUFQke/wall.png",
			"square": "https://static.gamezop.com/B1MXhUFQke/square.png",
			"screens": [
				"https://static.gamezop.com/B1MXhUFQke/game-1.png",
				"https://static.gamezop.com/B1MXhUFQke/game-2.png",
				"https://static.gamezop.com/B1MXhUFQke/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/B1MXhUFQke/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/B1MXhUFQke/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": [
				"Logic",
				"Family",
				"Fun",
				"Strategy",
				"Pixel",
				"Level-based",
				"HD",
				"Puzzle"
			]
		},
		"width": 800,
		"height": 600,
		"colorMuted": "#522b4b",
		"colorVibrant": "#793346",
		"privateAllowed": false,
		"rating": 4.75,
		"numberOfRatings": 1,
		"gamePlays": 409862,
		"hasIntegratedAds": false
	},
	{
		"code": "SJXVafJP51Q",
		"url": "https://9786.play.gamezop.com/g/SJXVafJP51Q",
		"name": {
			"en": "Nosedive"
		},
		"isPortrait": true,
		"description": {
			"en": "They say death is inevitable. But isn't it all about how long you can survive? You are in a plane crashing towards land - survive as long as you can."
		},
		"gamePreviews": {
			"en": "https://youtu.be/CkPjEy8HHek"
		},
		"assets": {
			"cover": "https://static.gamezop.com/SJXVafJP51Q/cover.jpg",
			"brick": "https://static.gamezop.com/SJXVafJP51Q/brick.png",
			"thumb": "https://static.gamezop.com/SJXVafJP51Q/thumb.png",
			"wall": "https://static.gamezop.com/SJXVafJP51Q/wall.png",
			"square": "https://static.gamezop.com/SJXVafJP51Q/square.png",
			"screens": [
				"https://static.gamezop.com/SJXVafJP51Q/game-1.png",
				"https://static.gamezop.com/SJXVafJP51Q/game-2.png",
				"https://static.gamezop.com/SJXVafJP51Q/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SJXVafJP51Q/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SJXVafJP51Q/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": []
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#51306e",
		"colorVibrant": "#141c5c",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 8401671,
		"hasIntegratedAds": false
	},
	{
		"code": "SyN0KSWuV",
		"url": "https://9786.play.gamezop.com/g/SyN0KSWuV",
		"name": {
			"en": "Crazy Pizza"
		},
		"isPortrait": false,
		"description": {
			"en": "It's another busy night at the pizzeria. Match 3 or more pizzas to prosper in this strategy game."
		},
		"gamePreviews": {
			"en": "https://youtu.be/oQyemW1y6xg"
		},
		"assets": {
			"cover": "https://static.gamezop.com/SyN0KSWuV/cover.jpg",
			"brick": "https://static.gamezop.com/SyN0KSWuV/brick.png",
			"thumb": "https://static.gamezop.com/SyN0KSWuV/thumb.png",
			"wall": "https://static.gamezop.com/SyN0KSWuV/wall.png",
			"square": "https://static.gamezop.com/SyN0KSWuV/square.png",
			"screens": [
				"https://static.gamezop.com/SyN0KSWuV/game-1.png",
				"https://static.gamezop.com/SyN0KSWuV/game-2.png",
				"https://static.gamezop.com/SyN0KSWuV/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SyN0KSWuV/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SyN0KSWuV/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": [
				"Endless",
				"Family",
				"Food",
				"Fun",
				"Kids",
				"Strategy",
				"Match-3",
				"Time Mgmt.",
				"Arcade"
			]
		},
		"width": 800,
		"height": 600,
		"colorMuted": "#534137",
		"colorVibrant": "#8f2909",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 903861,
		"hasIntegratedAds": false
	},
	{
		"code": "BJsmaGJw91m",
		"url": "https://9786.play.gamezop.com/g/BJsmaGJw91m",
		"name": {
			"en": "Happy Kittens Puzzle"
		},
		"isPortrait": true,
		"description": {
			"en": "All you have to do is keep the kittens happy. Be mindful, tapping on one cat changes the mood of all surrounding cats!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/rWdm_8uNQNw"
		},
		"assets": {
			"cover": "https://static.gamezop.com/BJsmaGJw91m/cover.jpg",
			"brick": "https://static.gamezop.com/BJsmaGJw91m/brick.png",
			"thumb": "https://static.gamezop.com/BJsmaGJw91m/thumb.png",
			"wall": "https://static.gamezop.com/BJsmaGJw91m/wall.png",
			"square": "https://static.gamezop.com/BJsmaGJw91m/square.png",
			"screens": [
				"https://static.gamezop.com/BJsmaGJw91m/game-1.png",
				"https://static.gamezop.com/BJsmaGJw91m/game-2.png",
				"https://static.gamezop.com/BJsmaGJw91m/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/BJsmaGJw91m/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/BJsmaGJw91m/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": []
		},
		"width": 768,
		"height": 1024,
		"colorMuted": "#606435",
		"colorVibrant": "#951829",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 1677247,
		"hasIntegratedAds": false
	},
	{
		"code": "VJOGOyGb9l",
		"url": "https://9786.play.gamezop.com/g/VJOGOyGb9l",
		"name": {
			"en": "Flying School"
		},
		"isPortrait": false,
		"description": {
			"en": "Help cute birds learn to fly. Drag and aim to make them fly from one nest to the other."
		},
		"gamePreviews": {
			"en": "https://youtu.be/TJb2aW6dUGw"
		},
		"assets": {
			"cover": "https://static.gamezop.com/VJOGOyGb9l/cover.jpg",
			"brick": "https://static.gamezop.com/VJOGOyGb9l/brick.png",
			"thumb": "https://static.gamezop.com/VJOGOyGb9l/thumb.png",
			"wall": "https://static.gamezop.com/VJOGOyGb9l/wall.png",
			"square": "https://static.gamezop.com/VJOGOyGb9l/square.png",
			"screens": [
				"https://static.gamezop.com/VJOGOyGb9l/game-1.png",
				"https://static.gamezop.com/VJOGOyGb9l/game-2.png",
				"https://static.gamezop.com/VJOGOyGb9l/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/VJOGOyGb9l/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/VJOGOyGb9l/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": [
				"Adventure",
				"Logic",
				"Family",
				"Fun",
				"Animal",
				"Girls",
				"Kids",
				"Level-based",
				"HD",
				"Cute"
			]
		},
		"width": 800,
		"height": 600,
		"colorMuted": "#371d1d",
		"colorVibrant": "#481b5f",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 8058155,
		"hasIntegratedAds": false
	},
	{
		"code": "r1K-J3TQ5Ar",
		"url": "https://9786.play.gamezop.com/g/r1K-J3TQ5Ar",
		"name": {
			"en": "Word Finder"
		},
		"isPortrait": true,
		"description": {
			"en": "This is a classic word-finder game where you have to find as many words as you can in a grid of letters. Use your brains and start finding! You get points for every word you find."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/r1K-J3TQ5Ar/cover.jpg",
			"brick": "https://static.gamezop.com/r1K-J3TQ5Ar/brick.png",
			"thumb": "https://static.gamezop.com/r1K-J3TQ5Ar/thumb.png",
			"wall": "https://static.gamezop.com/r1K-J3TQ5Ar/wall.png",
			"square": "https://static.gamezop.com/r1K-J3TQ5Ar/square.png",
			"screens": [
				"https://static.gamezop.com/r1K-J3TQ5Ar/game-1.png",
				"https://static.gamezop.com/r1K-J3TQ5Ar/game-2.png",
				"https://static.gamezop.com/r1K-J3TQ5Ar/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/r1K-J3TQ5Ar/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/r1K-J3TQ5Ar/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": []
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 4,
		"numberOfRatings": 4,
		"gamePlays": 2929456,
		"hasIntegratedAds": false
	},
	{
		"code": "EJnzu1fb9g",
		"url": "https://9786.play.gamezop.com/g/EJnzu1fb9g",
		"name": {
			"en": "Crunching Ninjas"
		},
		"isPortrait": false,
		"description": {
			"en": "Choose your ninja and collect and munch on the delicious crunchy apples in this endless game."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/EJnzu1fb9g/cover.jpg",
			"brick": "https://static.gamezop.com/EJnzu1fb9g/brick.png",
			"thumb": "https://static.gamezop.com/EJnzu1fb9g/thumb.png",
			"wall": "https://static.gamezop.com/EJnzu1fb9g/wall.png",
			"square": "https://static.gamezop.com/EJnzu1fb9g/square.png",
			"screens": [
				"https://static.gamezop.com/EJnzu1fb9g/game-1.png",
				"https://static.gamezop.com/EJnzu1fb9g/game-2.png",
				"https://static.gamezop.com/EJnzu1fb9g/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/EJnzu1fb9g/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/EJnzu1fb9g/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Action"
			]
		},
		"tags": {
			"en": [
				"Action",
				"Adventure",
				"Boys",
				"Endless",
				"Family",
				"Food",
				"Arcade"
			]
		},
		"width": 800,
		"height": 600,
		"colorMuted": "#314568",
		"colorVibrant": "#c23009",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 2241694,
		"hasIntegratedAds": false
	},
	{
		"code": "SyEQTzyw91X",
		"url": "https://9786.play.gamezop.com/g/SyEQTzyw91X",
		"name": {
			"en": "Exoplanet Express"
		},
		"isPortrait": false,
		"description": {
			"en": "How difficult can carrying cargo be? Find out in this surprisingly challenging space game! Keep in mind: fuel is limited and damages unaffordable."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/SyEQTzyw91X/cover.jpg",
			"brick": "https://static.gamezop.com/SyEQTzyw91X/brick.png",
			"thumb": "https://static.gamezop.com/SyEQTzyw91X/thumb.png",
			"wall": "https://static.gamezop.com/SyEQTzyw91X/wall.png",
			"square": "https://static.gamezop.com/SyEQTzyw91X/square.png",
			"screens": [
				"https://static.gamezop.com/SyEQTzyw91X/game-1.png",
				"https://static.gamezop.com/SyEQTzyw91X/game-2.png",
				"https://static.gamezop.com/SyEQTzyw91X/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SyEQTzyw91X/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SyEQTzyw91X/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Arcade"
			]
		},
		"tags": {
			"en": []
		},
		"width": 1080,
		"height": 720,
		"colorMuted": "#5c3c3c",
		"colorVibrant": "#5d682c",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 1530792,
		"hasIntegratedAds": false
	},
	{
		"code": "SJghvtd2_",
		"url": "https://9786.play.gamezop.com/g/SJghvtd2_",
		"name": {
			"en": "Drop Me"
		},
		"isPortrait": true,
		"description": {
			"en": "Help cute creatures to climb into their tubes in this colourfully cute puzzle game for young and old."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/SJghvtd2_/cover.jpg",
			"brick": "https://static.gamezop.com/SJghvtd2_/brick.png",
			"thumb": "https://static.gamezop.com/SJghvtd2_/thumb.png",
			"wall": "https://static.gamezop.com/SJghvtd2_/wall.png",
			"square": "https://static.gamezop.com/SJghvtd2_/square.png",
			"screens": [
				"https://static.gamezop.com/SJghvtd2_/game-1.png",
				"https://static.gamezop.com/SJghvtd2_/game-2.png",
				"https://static.gamezop.com/SJghvtd2_/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SJghvtd2_/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SJghvtd2_/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": [
				"Adventure",
				"Logic",
				"Fun",
				"Girls",
				"Kids",
				"Strategy",
				"Level-based",
				"HD",
				"Cute",
				"Puzzle"
			]
		},
		"width": 640,
		"height": 712,
		"colorMuted": "#4a8c5c",
		"colorVibrant": "#480834",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 5296099,
		"hasIntegratedAds": false
	},
	{
		"code": "SJ2OGpIn",
		"url": "https://9786.play.gamezop.com/g/SJ2OGpIn",
		"name": {
			"en": "Dodge Bot"
		},
		"isPortrait": true,
		"description": {
			"en": "Run along the surface dodging the attack of the bots; hovering over them brings no laurels!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/7dFyhp5ZopU"
		},
		"assets": {
			"cover": "https://static.gamezop.com/SJ2OGpIn/cover.jpg",
			"brick": "https://static.gamezop.com/SJ2OGpIn/brick.png",
			"thumb": "https://static.gamezop.com/SJ2OGpIn/thumb.png",
			"wall": "https://static.gamezop.com/SJ2OGpIn/wall.png",
			"square": "https://static.gamezop.com/SJ2OGpIn/square.png",
			"screens": [
				"https://static.gamezop.com/SJ2OGpIn/game-1.png",
				"https://static.gamezop.com/SJ2OGpIn/game-2.png",
				"https://static.gamezop.com/SJ2OGpIn/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SJ2OGpIn/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SJ2OGpIn/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": [
				"Boys",
				"Logic",
				"Endless",
				"Exclusive",
				"Family",
				"Fun",
				"Girls",
				"Kids",
				"Arcade",
				"Minimal",
				"Cute"
			]
		},
		"width": 338,
		"height": 600,
		"colorMuted": "#4d2e64",
		"colorVibrant": "#3c1c4c",
		"privateAllowed": true,
		"rating": 4.75,
		"numberOfRatings": 1,
		"gamePlays": 139472132,
		"hasIntegratedAds": false
	},
	{
		"code": "r10-NLT86bx",
		"url": "https://9786.play.gamezop.com/g/r10-NLT86bx",
		"name": {
			"en": "Rope Ninja"
		},
		"isPortrait": false,
		"description": {
			"en": "Time to show your ninja skills and catch as many birds as you can. Mind the coins you can collect!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/vm2aQJN7o4Y"
		},
		"assets": {
			"cover": "https://static.gamezop.com/r10-NLT86bx/cover.jpg",
			"brick": "https://static.gamezop.com/r10-NLT86bx/brick.png",
			"thumb": "https://static.gamezop.com/r10-NLT86bx/thumb.png",
			"wall": "https://static.gamezop.com/r10-NLT86bx/wall.png",
			"square": "https://static.gamezop.com/r10-NLT86bx/square.png",
			"screens": [
				"https://static.gamezop.com/r10-NLT86bx/game-1.png",
				"https://static.gamezop.com/r10-NLT86bx/game-2.png",
				"https://static.gamezop.com/r10-NLT86bx/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/r10-NLT86bx/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/r10-NLT86bx/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": [
				"Adventure",
				"Endless",
				"Family",
				"Shooting",
				"Fun",
				"Animal",
				"Kids",
				"HD"
			]
		},
		"width": 1008,
		"height": 756,
		"colorMuted": "#5b3b27",
		"colorVibrant": "#0c406d",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 29548788,
		"hasIntegratedAds": false
	},
	{
		"code": "HyZMUTVQRe",
		"url": "https://9786.play.gamezop.com/g/HyZMUTVQRe",
		"name": {
			"en": "Where's the Ace?"
		},
		"isPortrait": false,
		"description": {
			"en": "Don't let the lady out of sight, or you'll lose the game. How attentive are you?"
		},
		"gamePreviews": {
			"en": "https://youtu.be/2HoA_Quf1Uc"
		},
		"assets": {
			"cover": "https://static.gamezop.com/HyZMUTVQRe/cover.jpg",
			"brick": "https://static.gamezop.com/HyZMUTVQRe/brick.png",
			"thumb": "https://static.gamezop.com/HyZMUTVQRe/thumb.png",
			"wall": "https://static.gamezop.com/HyZMUTVQRe/wall.png",
			"square": "https://static.gamezop.com/HyZMUTVQRe/square.png",
			"screens": [
				"https://static.gamezop.com/HyZMUTVQRe/game-1.png",
				"https://static.gamezop.com/HyZMUTVQRe/game-2.png",
				"https://static.gamezop.com/HyZMUTVQRe/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/HyZMUTVQRe/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/HyZMUTVQRe/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": [
				"Boys",
				"Cards",
				"Classics",
				"Endless",
				"Fun",
				"Hidden Object",
				"Casino"
			]
		},
		"width": 1371,
		"height": 548,
		"colorMuted": "#474a48",
		"colorVibrant": "#045c34",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 2491857,
		"hasIntegratedAds": false
	},
	{
		"code": "SykGDfUKOkg",
		"url": "https://9786.play.gamezop.com/g/SykGDfUKOkg",
		"name": {
			"en": "Traffic Command"
		},
		"isPortrait": true,
		"description": {
			"en": "The city crossing sees some insane traffic. Navigate the cars carefully without letting any crash."
		},
		"gamePreviews": {
			"en": "https://youtu.be/oE50QlNR4iM"
		},
		"assets": {
			"cover": "https://static.gamezop.com/SykGDfUKOkg/cover.jpg",
			"brick": "https://static.gamezop.com/SykGDfUKOkg/brick.png",
			"thumb": "https://static.gamezop.com/SykGDfUKOkg/thumb.png",
			"wall": "https://static.gamezop.com/SykGDfUKOkg/wall.png",
			"square": "https://static.gamezop.com/SykGDfUKOkg/square.png",
			"screens": [
				"https://static.gamezop.com/SykGDfUKOkg/game-1.png",
				"https://static.gamezop.com/SykGDfUKOkg/game-2.png",
				"https://static.gamezop.com/SykGDfUKOkg/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SykGDfUKOkg/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SykGDfUKOkg/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": [
				"Boys",
				"Endless",
				"Kids",
				"Physics",
				"Arcade",
				"Cars"
			]
		},
		"width": 338,
		"height": 600,
		"colorMuted": "#545463",
		"colorVibrant": "#7c1709",
		"privateAllowed": true,
		"rating": 4.08,
		"numberOfRatings": 3,
		"gamePlays": 16837829,
		"hasIntegratedAds": false
	},
	{
		"code": "HyCKrWd4",
		"url": "https://9786.play.gamezop.com/g/HyCKrWd4",
		"name": {
			"en": "Basketball Master"
		},
		"isPortrait": false,
		"description": {
			"en": "In this sports skill game, you can see the trajectory of each shot. Aim for the center of the hoop."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/HyCKrWd4/cover.jpg",
			"brick": "https://static.gamezop.com/HyCKrWd4/brick.png",
			"thumb": "https://static.gamezop.com/HyCKrWd4/thumb.png",
			"wall": "https://static.gamezop.com/HyCKrWd4/wall.png",
			"square": "https://static.gamezop.com/HyCKrWd4/square.png",
			"screens": [
				"https://static.gamezop.com/HyCKrWd4/game-1.png",
				"https://static.gamezop.com/HyCKrWd4/game-2.png",
				"https://static.gamezop.com/HyCKrWd4/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/HyCKrWd4/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/HyCKrWd4/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": [
				"Boys",
				"Logic",
				"Fun",
				"Girls",
				"Kids",
				"Sports",
				"Level-based",
				"HD",
				"Cute"
			]
		},
		"width": 800,
		"height": 600,
		"colorMuted": "#2e5e6a",
		"colorVibrant": "#326774",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 10346495,
		"hasIntegratedAds": false
	},
	{
		"code": "N1sZfO1fWqg",
		"url": "https://9786.play.gamezop.com/g/N1sZfO1fWqg",
		"name": {
			"en": "Grumpy Gorilla"
		},
		"isPortrait": true,
		"description": {
			"en": "This beast is addicted to chopping trees. Ensure he's on the right side else he'd bang his head!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/eQozH2tIwP4"
		},
		"assets": {
			"cover": "https://static.gamezop.com/N1sZfO1fWqg/cover.jpg",
			"brick": "https://static.gamezop.com/N1sZfO1fWqg/brick.png",
			"thumb": "https://static.gamezop.com/N1sZfO1fWqg/thumb.png",
			"wall": "https://static.gamezop.com/N1sZfO1fWqg/wall.png",
			"square": "https://static.gamezop.com/N1sZfO1fWqg/square.png",
			"screens": [
				"https://static.gamezop.com/N1sZfO1fWqg/game-1.png",
				"https://static.gamezop.com/N1sZfO1fWqg/game-2.png",
				"https://static.gamezop.com/N1sZfO1fWqg/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/N1sZfO1fWqg/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/N1sZfO1fWqg/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Arcade"
			]
		},
		"tags": {
			"en": [
				"Adventure",
				"Boys",
				"Endless",
				"Exclusive",
				"Fun",
				"Animal",
				"Kids",
				"Time Mgmt.",
				"Arcade",
				"HD"
			]
		},
		"width": 338,
		"height": 600,
		"colorMuted": "#2c533b",
		"colorVibrant": "#045c34",
		"privateAllowed": true,
		"rating": 4.75,
		"numberOfRatings": 1,
		"gamePlays": 74636035,
		"hasIntegratedAds": false
	},
	{
		"code": "rkAXTzkD5kX",
		"url": "https://9786.play.gamezop.com/g/rkAXTzkD5kX",
		"name": {
			"en": "Chess Grandmaster"
		},
		"isPortrait": true,
		"description": {
			"en": "A chess game for everyone: from beginners to experts! Choose between 3 difficulty modes, or directly pick from over 1100+ challenges to solve within a limited set of moves!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/BUoXagcZiWA\r"
		},
		"assets": {
			"cover": "https://static.gamezop.com/rkAXTzkD5kX/cover.jpg",
			"brick": "https://static.gamezop.com/rkAXTzkD5kX/brick.png",
			"thumb": "https://static.gamezop.com/rkAXTzkD5kX/thumb.png",
			"wall": "https://static.gamezop.com/rkAXTzkD5kX/wall.png",
			"square": "https://static.gamezop.com/rkAXTzkD5kX/square.png",
			"screens": [
				"https://static.gamezop.com/rkAXTzkD5kX/game-1.png",
				"https://static.gamezop.com/rkAXTzkD5kX/game-2.png",
				"https://static.gamezop.com/rkAXTzkD5kX/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/rkAXTzkD5kX/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/rkAXTzkD5kX/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": []
		},
		"width": 768,
		"height": 1024,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": false,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 6014400,
		"hasIntegratedAds": false
	},
	{
		"code": "SysZvGUt_ye",
		"url": "https://9786.play.gamezop.com/g/SysZvGUt_ye",
		"name": {
			"en": "Snappy Spy"
		},
		"isPortrait": false,
		"description": {
			"en": "Switch gravity with a touch and avoid obstacles. Remember to get some sushi for extra points!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/SUnO0POcSos"
		},
		"assets": {
			"cover": "https://static.gamezop.com/SysZvGUt_ye/cover.jpg",
			"brick": "https://static.gamezop.com/SysZvGUt_ye/brick.png",
			"thumb": "https://static.gamezop.com/SysZvGUt_ye/thumb.png",
			"wall": "https://static.gamezop.com/SysZvGUt_ye/wall.png",
			"square": "https://static.gamezop.com/SysZvGUt_ye/square.png",
			"screens": [
				"https://static.gamezop.com/SysZvGUt_ye/game-1.png",
				"https://static.gamezop.com/SysZvGUt_ye/game-2.png",
				"https://static.gamezop.com/SysZvGUt_ye/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SysZvGUt_ye/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SysZvGUt_ye/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": [
				"Adventure",
				"Boys",
				"Endless",
				"Fun",
				"Arcade"
			]
		},
		"width": 800,
		"height": 600,
		"colorMuted": "#413439",
		"colorVibrant": "#1956a2",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 4665487,
		"hasIntegratedAds": false
	},
	{
		"code": "HJE-oa2z_l-",
		"url": "https://9786.play.gamezop.com/g/HJE-oa2z_l-",
		"name": {
			"en": "Mirror Me"
		},
		"isPortrait": true,
		"description": {
			"en": "Mirror Me is a relaxing puzzle game that exercises your brain. You have to reflect symmetric shapes for the patterns shown."
		},
		"gamePreviews": {
			"en": "https://youtu.be/OPWXUqzAtoo"
		},
		"assets": {
			"cover": "https://static.gamezop.com/HJE-oa2z_l-/cover.jpg",
			"brick": "https://static.gamezop.com/HJE-oa2z_l-/brick.png",
			"thumb": "https://static.gamezop.com/HJE-oa2z_l-/thumb.png",
			"wall": "https://static.gamezop.com/HJE-oa2z_l-/wall.png",
			"square": "https://static.gamezop.com/HJE-oa2z_l-/square.png",
			"screens": [
				"https://static.gamezop.com/HJE-oa2z_l-/game-1.png",
				"https://static.gamezop.com/HJE-oa2z_l-/game-2.png",
				"https://static.gamezop.com/HJE-oa2z_l-/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/HJE-oa2z_l-/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/HJE-oa2z_l-/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": [
				"Logic",
				"Fun",
				"Kids",
				"Level-based"
			]
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#6c3c74",
		"colorVibrant": "#9c2c24",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 970890,
		"hasIntegratedAds": false
	},
	{
		"code": "SklmW1ad_",
		"url": "https://9786.play.gamezop.com/g/SklmW1ad_",
		"name": {
			"en": "Let Me Grow"
		},
		"isPortrait": true,
		"description": {
			"en": "Control the water flow to make sure all flowers remain hydrated in this amazing puzzle game."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/SklmW1ad_/cover.jpg",
			"brick": "https://static.gamezop.com/SklmW1ad_/brick.png",
			"thumb": "https://static.gamezop.com/SklmW1ad_/thumb.png",
			"wall": "https://static.gamezop.com/SklmW1ad_/wall.png",
			"square": "https://static.gamezop.com/SklmW1ad_/square.png",
			"screens": [
				"https://static.gamezop.com/SklmW1ad_/game-1.png",
				"https://static.gamezop.com/SklmW1ad_/game-2.png",
				"https://static.gamezop.com/SklmW1ad_/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SklmW1ad_/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SklmW1ad_/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": [
				"Logic",
				"Family",
				"Food",
				"Fun",
				"Girls",
				"Kids",
				"Strategy",
				"Level-based",
				"Puzzle"
			]
		},
		"width": 640,
		"height": 832,
		"colorMuted": "#738342",
		"colorVibrant": "#8fa037",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 2041034,
		"hasIntegratedAds": false
	},
	{
		"code": "Rt5ytrd0m",
		"url": "https://9786.play.gamezop.com/g/Rt5ytrd0m",
		"name": {
			"en": "Kingdom Fight 2.0"
		},
		"isPortrait": true,
		"description": {
			"en": "A battle so awesome: we came with chapter two. The army of the undead just wants to get through. Slow them down, fry them up, let them take the arrows you spew!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/Rt5ytrd0m/cover.jpg",
			"brick": "https://static.gamezop.com/Rt5ytrd0m/brick.png",
			"thumb": "https://static.gamezop.com/Rt5ytrd0m/thumb.png",
			"wall": "https://static.gamezop.com/Rt5ytrd0m/wall.png",
			"square": "https://static.gamezop.com/Rt5ytrd0m/square.png",
			"screens": [
				"https://static.gamezop.com/Rt5ytrd0m/game-1.png",
				"https://static.gamezop.com/Rt5ytrd0m/game-2.png",
				"https://static.gamezop.com/Rt5ytrd0m/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/Rt5ytrd0m/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/Rt5ytrd0m/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": []
		},
		"width": 768,
		"height": 1024,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 361593,
		"hasIntegratedAds": true
	},
	{
		"code": "yr4TqJhLr",
		"url": "https://9786.play.gamezop.com/g/yr4TqJhLr",
		"name": {
			"en": "Blaze Rider"
		},
		"isPortrait": true,
		"description": {
			"en": "Set the road on fire, melt the tar with the heat of your tire, Blaze Rider is on the prowl, and it's time for enemies to just retire."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/yr4TqJhLr/cover.jpg",
			"brick": "https://static.gamezop.com/yr4TqJhLr/brick.png",
			"thumb": "https://static.gamezop.com/yr4TqJhLr/thumb.png",
			"wall": "https://static.gamezop.com/yr4TqJhLr/wall.png",
			"square": "https://static.gamezop.com/yr4TqJhLr/square.png",
			"screens": [
				"https://static.gamezop.com/yr4TqJhLr/game-1.png",
				"https://static.gamezop.com/yr4TqJhLr/game-2.png",
				"https://static.gamezop.com/yr4TqJhLr/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/yr4TqJhLr/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/yr4TqJhLr/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": []
		},
		"width": 1080,
		"height": 1920,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 1840354,
		"hasIntegratedAds": false
	},
	{
		"code": "H1be5Ef0Qp",
		"url": "https://9786.play.gamezop.com/g/H1be5Ef0Qp",
		"name": {
			"en": "Vegetables vs. Chef"
		},
		"isPortrait": true,
		"description": {
			"en": "Rumour has it that the unforgiving blade has been chopping veggies for years. Break its momentum."
		},
		"gamePreviews": {
			"en": "https://youtu.be/Hu7TM3RWg9U"
		},
		"assets": {
			"cover": "https://static.gamezop.com/H1be5Ef0Qp/cover.jpg",
			"brick": "https://static.gamezop.com/H1be5Ef0Qp/brick.png",
			"thumb": "https://static.gamezop.com/H1be5Ef0Qp/thumb.png",
			"wall": "https://static.gamezop.com/H1be5Ef0Qp/wall.png",
			"square": "https://static.gamezop.com/H1be5Ef0Qp/square.png",
			"screens": [
				"https://static.gamezop.com/H1be5Ef0Qp/game-1.png",
				"https://static.gamezop.com/H1be5Ef0Qp/game-2.png",
				"https://static.gamezop.com/H1be5Ef0Qp/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/H1be5Ef0Qp/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/H1be5Ef0Qp/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Arcade"
			]
		},
		"tags": {
			"en": [
				"Action",
				"Adventure",
				"Endless",
				"Food",
				"Fun",
				"Racing",
				"Arcade",
				"HD",
				"Cute",
				"Difficult"
			]
		},
		"width": 338,
		"height": 600,
		"colorMuted": "#542c2e",
		"colorVibrant": "#800e1e",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 10919432,
		"hasIntegratedAds": false
	},
	{
		"code": "SJRX12TXcRH",
		"url": "https://9786.play.gamezop.com/g/SJRX12TXcRH",
		"name": {
			"en": "Ludo Dash"
		},
		"isPortrait": true,
		"description": {
			"en": "A lightning fast ludo game with a rapid fire twist! No more waiting for 6 on the cice, but... blink and you miss!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/SJRX12TXcRH/cover.jpg",
			"brick": "https://static.gamezop.com/SJRX12TXcRH/brick.png",
			"thumb": "https://static.gamezop.com/SJRX12TXcRH/thumb.png",
			"wall": "https://static.gamezop.com/SJRX12TXcRH/wall.png",
			"square": "https://static.gamezop.com/SJRX12TXcRH/square.png",
			"screens": [
				"https://static.gamezop.com/SJRX12TXcRH/game-1.png",
				"https://static.gamezop.com/SJRX12TXcRH/game-2.png",
				"https://static.gamezop.com/SJRX12TXcRH/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SJRX12TXcRH/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SJRX12TXcRH/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": []
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": false,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 6751084,
		"hasIntegratedAds": false
	},
	{
		"code": "r1zG1h6m90H",
		"url": "https://9786.play.gamezop.com/g/r1zG1h6m90H",
		"name": {
			"en": "Candy Fiesta"
		},
		"isPortrait": true,
		"description": {
			"en": "Merge delicious candies and unlock beautiful new combos! Candy Fiesta is a delicious match-three puzzle game loved by millions!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/r1zG1h6m90H/cover.jpg",
			"brick": "https://static.gamezop.com/r1zG1h6m90H/brick.png",
			"thumb": "https://static.gamezop.com/r1zG1h6m90H/thumb.png",
			"wall": "https://static.gamezop.com/r1zG1h6m90H/wall.png",
			"square": "https://static.gamezop.com/r1zG1h6m90H/square.png",
			"screens": [
				"https://static.gamezop.com/r1zG1h6m90H/game-1.png",
				"https://static.gamezop.com/r1zG1h6m90H/game-2.png",
				"https://static.gamezop.com/r1zG1h6m90H/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/r1zG1h6m90H/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/r1zG1h6m90H/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": []
		},
		"width": 768,
		"height": 1024,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 2,
		"gamePlays": 26665541,
		"hasIntegratedAds": false
	},
	{
		"code": "HkxQnLtmJe",
		"url": "https://9786.play.gamezop.com/g/HkxQnLtmJe",
		"name": {
			"en": "Rabbit Punch"
		},
		"isPortrait": false,
		"description": {
			"en": "Punch rabbits as they come out of the magician's hat. DON'T punch the magicians. Speed is key!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/HkxQnLtmJe/cover.jpg",
			"brick": "https://static.gamezop.com/HkxQnLtmJe/brick.png",
			"thumb": "https://static.gamezop.com/HkxQnLtmJe/thumb.png",
			"wall": "https://static.gamezop.com/HkxQnLtmJe/wall.png",
			"square": "https://static.gamezop.com/HkxQnLtmJe/square.png",
			"screens": [
				"https://static.gamezop.com/HkxQnLtmJe/game-1.png",
				"https://static.gamezop.com/HkxQnLtmJe/game-2.png",
				"https://static.gamezop.com/HkxQnLtmJe/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/HkxQnLtmJe/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/HkxQnLtmJe/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Action"
			]
		},
		"tags": {
			"en": [
				"Action",
				"Boys",
				"Endless",
				"Family",
				"Fun",
				"Animal",
				"Girls",
				"Time Mgmt.",
				"Arcade",
				"Pixel"
			]
		},
		"width": 800,
		"height": 450,
		"colorMuted": "#335463",
		"colorVibrant": "#15597a",
		"privateAllowed": false,
		"rating": 2.75,
		"numberOfRatings": 1,
		"gamePlays": 1837037,
		"hasIntegratedAds": false
	},
	{
		"code": "rkxMV8TI6Wg",
		"url": "https://9786.play.gamezop.com/g/rkxMV8TI6Wg",
		"name": {
			"en": "Zombies Can't Jump 2"
		},
		"isPortrait": false,
		"description": {
			"en": "Help the Mexican gunfighters Pedro and Juana to survive the attacks of bloodthirsty zombies."
		},
		"gamePreviews": {
			"en": "https://youtu.be/thlytlfqeNA"
		},
		"assets": {
			"cover": "https://static.gamezop.com/rkxMV8TI6Wg/cover.jpg",
			"brick": "https://static.gamezop.com/rkxMV8TI6Wg/brick.png",
			"thumb": "https://static.gamezop.com/rkxMV8TI6Wg/thumb.png",
			"wall": "https://static.gamezop.com/rkxMV8TI6Wg/wall.png",
			"square": "https://static.gamezop.com/rkxMV8TI6Wg/square.png",
			"screens": [
				"https://static.gamezop.com/rkxMV8TI6Wg/game-1.png",
				"https://static.gamezop.com/rkxMV8TI6Wg/game-2.png",
				"https://static.gamezop.com/rkxMV8TI6Wg/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/rkxMV8TI6Wg/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/rkxMV8TI6Wg/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Action"
			]
		},
		"tags": {
			"en": [
				"Action",
				"Boys",
				"Shooting",
				"Fun",
				"Strategy",
				"Zombie",
				"Level-based",
				"HD"
			]
		},
		"width": 1260,
		"height": 945,
		"colorMuted": "#494c35",
		"colorVibrant": "#9e2c17",
		"privateAllowed": true,
		"rating": 4.18,
		"numberOfRatings": 7,
		"gamePlays": 14918103,
		"hasIntegratedAds": false
	},
	{
		"code": "SyfxJ3a75Cr",
		"url": "https://9786.play.gamezop.com/g/SyfxJ3a75Cr",
		"name": {
			"en": "Kingdom Fight"
		},
		"isPortrait": true,
		"description": {
			"en": "Monsters are coming in. Use arrows, electric bolts, fire catapults, and time warpers - build a defense for your kingdom. New maps every day!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/iZmv6aaWro4"
		},
		"assets": {
			"cover": "https://static.gamezop.com/SyfxJ3a75Cr/cover.jpg",
			"brick": "https://static.gamezop.com/SyfxJ3a75Cr/brick.png",
			"thumb": "https://static.gamezop.com/SyfxJ3a75Cr/thumb.png",
			"wall": "https://static.gamezop.com/SyfxJ3a75Cr/wall.png",
			"square": "https://static.gamezop.com/SyfxJ3a75Cr/square.png",
			"screens": [
				"https://static.gamezop.com/SyfxJ3a75Cr/game-1.png",
				"https://static.gamezop.com/SyfxJ3a75Cr/game-2.png",
				"https://static.gamezop.com/SyfxJ3a75Cr/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SyfxJ3a75Cr/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SyfxJ3a75Cr/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": []
		},
		"width": 768,
		"height": 1024,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 23925842,
		"hasIntegratedAds": false
	},
	{
		"code": "B1jZWUoXUIe",
		"url": "https://9786.play.gamezop.com/g/B1jZWUoXUIe",
		"name": {
			"en": "Valley of Terror"
		},
		"isPortrait": false,
		"description": {
			"en": "A group of zombies is out on the streets. Your task is to clean them up and guard your town."
		},
		"gamePreviews": {
			"en": "https://youtu.be/hUDvPEKHsZ4"
		},
		"assets": {
			"cover": "https://static.gamezop.com/B1jZWUoXUIe/cover.jpg",
			"brick": "https://static.gamezop.com/B1jZWUoXUIe/brick.png",
			"thumb": "https://static.gamezop.com/B1jZWUoXUIe/thumb.png",
			"wall": "https://static.gamezop.com/B1jZWUoXUIe/wall.png",
			"square": "https://static.gamezop.com/B1jZWUoXUIe/square.png",
			"screens": [
				"https://static.gamezop.com/B1jZWUoXUIe/game-1.png",
				"https://static.gamezop.com/B1jZWUoXUIe/game-2.png",
				"https://static.gamezop.com/B1jZWUoXUIe/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/B1jZWUoXUIe/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/B1jZWUoXUIe/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Action"
			]
		},
		"tags": {
			"en": [
				"Action",
				"Endless",
				"Shooting",
				"Zombie"
			]
		},
		"width": 800,
		"height": 450,
		"colorMuted": "#434344",
		"colorVibrant": "#040c0c",
		"privateAllowed": true,
		"rating": 2.75,
		"numberOfRatings": 1,
		"gamePlays": 4181645,
		"hasIntegratedAds": false
	},
	{
		"code": "Nr1P9rmbi",
		"url": "https://9786.play.gamezop.com/g/Nr1P9rmbi",
		"name": {
			"en": "Harbor Dash"
		},
		"isPortrait": false,
		"description": {
			"en": "Navigate the waters, chart your course; dock your boats with skill and force! Unlock new regions, face the test, conquer the waves and be the best!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/Nr1P9rmbi/cover.jpg",
			"brick": "https://static.gamezop.com/Nr1P9rmbi/brick.png",
			"thumb": "https://static.gamezop.com/Nr1P9rmbi/thumb.png",
			"wall": "https://static.gamezop.com/Nr1P9rmbi/wall.png",
			"square": "https://static.gamezop.com/Nr1P9rmbi/square.png",
			"screens": [
				"https://static.gamezop.com/Nr1P9rmbi/game-1.png",
				"https://static.gamezop.com/Nr1P9rmbi/game-2.png",
				"https://static.gamezop.com/Nr1P9rmbi/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/Nr1P9rmbi/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/Nr1P9rmbi/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": [
				"New Games"
			]
		},
		"width": 1024,
		"height": 768,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 19554,
		"hasIntegratedAds": false
	},
	{
		"code": "Skz4pzkDqyX",
		"url": "https://9786.play.gamezop.com/g/Skz4pzkDqyX",
		"name": {
			"en": "Escape Run"
		},
		"isPortrait": true,
		"description": {
			"en": "Help the mountain man escape the eyes of media while he peacefully runs in the cold. Collect fruits to buy power-ups for the escape!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/EdYq6hIB13o"
		},
		"assets": {
			"cover": "https://static.gamezop.com/Skz4pzkDqyX/cover.jpg",
			"brick": "https://static.gamezop.com/Skz4pzkDqyX/brick.png",
			"thumb": "https://static.gamezop.com/Skz4pzkDqyX/thumb.png",
			"wall": "https://static.gamezop.com/Skz4pzkDqyX/wall.png",
			"square": "https://static.gamezop.com/Skz4pzkDqyX/square.png",
			"screens": [
				"https://static.gamezop.com/Skz4pzkDqyX/game-1.png",
				"https://static.gamezop.com/Skz4pzkDqyX/game-2.png",
				"https://static.gamezop.com/Skz4pzkDqyX/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/Skz4pzkDqyX/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/Skz4pzkDqyX/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": []
		},
		"width": 452,
		"height": 804,
		"colorMuted": "#f89b67",
		"colorVibrant": "#a2452a",
		"privateAllowed": true,
		"rating": 3,
		"numberOfRatings": 10,
		"gamePlays": 163971090,
		"hasIntegratedAds": false
	},
	{
		"code": "rJWX-kadu",
		"url": "https://9786.play.gamezop.com/g/rJWX-kadu",
		"name": {
			"en": "Salazar"
		},
		"isPortrait": true,
		"description": {
			"en": "This wise wizard is trying to create a powerful new artifact but needs your help in seeing it through!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/33y9uGStYbE"
		},
		"assets": {
			"cover": "https://static.gamezop.com/rJWX-kadu/cover.jpg",
			"brick": "https://static.gamezop.com/rJWX-kadu/brick.png",
			"thumb": "https://static.gamezop.com/rJWX-kadu/thumb.png",
			"wall": "https://static.gamezop.com/rJWX-kadu/wall.png",
			"square": "https://static.gamezop.com/rJWX-kadu/square.png",
			"screens": [
				"https://static.gamezop.com/rJWX-kadu/game-1.png",
				"https://static.gamezop.com/rJWX-kadu/game-2.png",
				"https://static.gamezop.com/rJWX-kadu/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/rJWX-kadu/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/rJWX-kadu/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": [
				"Board",
				"Logic",
				"Endless",
				"Family",
				"Fun",
				"Girls",
				"Strategy",
				"Puzzle"
			]
		},
		"width": 640,
		"height": 780,
		"colorMuted": "#542745",
		"colorVibrant": "#79591a",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 2845631,
		"hasIntegratedAds": false
	},
	{
		"code": "B1Gbjphf_gZ",
		"url": "https://9786.play.gamezop.com/g/B1Gbjphf_gZ",
		"name": {
			"en": "Saucer Dodge"
		},
		"isPortrait": true,
		"description": {
			"en": "Wade through space and keep your space ship away from flying saucers."
		},
		"gamePreviews": {
			"en": "https://youtu.be/3jKFaxNP-5I"
		},
		"assets": {
			"cover": "https://static.gamezop.com/B1Gbjphf_gZ/cover.jpg",
			"brick": "https://static.gamezop.com/B1Gbjphf_gZ/brick.png",
			"thumb": "https://static.gamezop.com/B1Gbjphf_gZ/thumb.png",
			"wall": "https://static.gamezop.com/B1Gbjphf_gZ/wall.png",
			"square": "https://static.gamezop.com/B1Gbjphf_gZ/square.png",
			"screens": [
				"https://static.gamezop.com/B1Gbjphf_gZ/game-1.png",
				"https://static.gamezop.com/B1Gbjphf_gZ/game-2.png",
				"https://static.gamezop.com/B1Gbjphf_gZ/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/B1Gbjphf_gZ/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/B1Gbjphf_gZ/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": [
				"Action",
				"Boys",
				"Endless",
				"Kids",
				"Space",
				"Arcade"
			]
		},
		"width": 640,
		"height": 1136,
		"colorMuted": "#305b55",
		"colorVibrant": "#215f78",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 9126266,
		"hasIntegratedAds": false
	},
	{
		"code": "B1PMIp4XCe",
		"url": "https://9786.play.gamezop.com/g/B1PMIp4XCe",
		"name": {
			"en": "Sway Bay"
		},
		"isPortrait": true,
		"description": {
			"en": "Jump from stump to stump, but keep an eye out. The jungle ropes aren't known to be forgiving!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/3ucMAGLzQFk"
		},
		"assets": {
			"cover": "https://static.gamezop.com/B1PMIp4XCe/cover.jpg",
			"brick": "https://static.gamezop.com/B1PMIp4XCe/brick.png",
			"thumb": "https://static.gamezop.com/B1PMIp4XCe/thumb.png",
			"wall": "https://static.gamezop.com/B1PMIp4XCe/wall.png",
			"square": "https://static.gamezop.com/B1PMIp4XCe/square.png",
			"screens": [
				"https://static.gamezop.com/B1PMIp4XCe/game-1.png",
				"https://static.gamezop.com/B1PMIp4XCe/game-2.png",
				"https://static.gamezop.com/B1PMIp4XCe/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/B1PMIp4XCe/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/B1PMIp4XCe/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": [
				"Adventure",
				"Boys",
				"Endless",
				"Fun",
				"Kids",
				"Physics",
				"Arcade"
			]
		},
		"width": 338,
		"height": 600,
		"colorMuted": "#5a4028",
		"colorVibrant": "#1d665a",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 12622571,
		"hasIntegratedAds": false
	},
	{
		"code": "V1IZG_1f-qg",
		"url": "https://9786.play.gamezop.com/g/V1IZG_1f-qg",
		"name": {
			"en": "Sheep Stacking"
		},
		"isPortrait": true,
		"description": {
			"en": "It's time to stack some sheep! Drop them right and create the highest possible tower!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/GJgRbjSDivQ"
		},
		"assets": {
			"cover": "https://static.gamezop.com/V1IZG_1f-qg/cover.jpg",
			"brick": "https://static.gamezop.com/V1IZG_1f-qg/brick.png",
			"thumb": "https://static.gamezop.com/V1IZG_1f-qg/thumb.png",
			"wall": "https://static.gamezop.com/V1IZG_1f-qg/wall.png",
			"square": "https://static.gamezop.com/V1IZG_1f-qg/square.png",
			"screens": [
				"https://static.gamezop.com/V1IZG_1f-qg/game-1.png",
				"https://static.gamezop.com/V1IZG_1f-qg/game-2.png",
				"https://static.gamezop.com/V1IZG_1f-qg/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/V1IZG_1f-qg/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/V1IZG_1f-qg/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Arcade"
			]
		},
		"tags": {
			"en": [
				"Endless",
				"Animal",
				"Arcade",
				"Cute"
			]
		},
		"width": 400,
		"height": 600,
		"colorMuted": "#306745",
		"colorVibrant": "#a4bd0f",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 8952585,
		"hasIntegratedAds": false
	},
	{
		"code": "B1H5NfCXa",
		"url": "https://9786.play.gamezop.com/g/B1H5NfCXa",
		"name": {
			"en": "Homerun Hit"
		},
		"isPortrait": true,
		"description": {
			"en": "Step up to the plate for a great baseball batting experience. Be careful, 10 strikes and you lose."
		},
		"gamePreviews": {
			"en": "https://youtu.be/SGPids_pqNo"
		},
		"assets": {
			"cover": "https://static.gamezop.com/B1H5NfCXa/cover.jpg",
			"brick": "https://static.gamezop.com/B1H5NfCXa/brick.png",
			"thumb": "https://static.gamezop.com/B1H5NfCXa/thumb.png",
			"wall": "https://static.gamezop.com/B1H5NfCXa/wall.png",
			"square": "https://static.gamezop.com/B1H5NfCXa/square.png",
			"screens": [
				"https://static.gamezop.com/B1H5NfCXa/game-1.png",
				"https://static.gamezop.com/B1H5NfCXa/game-2.png",
				"https://static.gamezop.com/B1H5NfCXa/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/B1H5NfCXa/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/B1H5NfCXa/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": [
				"Boys",
				"Fun",
				"Sports",
				"Arcade",
				"HD"
			]
		},
		"width": 493,
		"height": 600,
		"colorMuted": "#30211a",
		"colorVibrant": "#5f141c",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 9971300,
		"hasIntegratedAds": false
	},
	{
		"code": "8WGtd7TLH",
		"url": "https://9786.play.gamezop.com/g/8WGtd7TLH",
		"name": {
			"en": "Tower Buster"
		},
		"isPortrait": true,
		"description": {
			"en": "The war is here. It's the need of the hour. Block by block, tower after tower, it's time you prove your tank's dominance & power!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/8WGtd7TLH/cover.jpg",
			"brick": "https://static.gamezop.com/8WGtd7TLH/brick.png",
			"thumb": "https://static.gamezop.com/8WGtd7TLH/thumb.png",
			"wall": "https://static.gamezop.com/8WGtd7TLH/wall.png",
			"square": "https://static.gamezop.com/8WGtd7TLH/square.png",
			"screens": [
				"https://static.gamezop.com/8WGtd7TLH/game-1.png",
				"https://static.gamezop.com/8WGtd7TLH/game-2.png",
				"https://static.gamezop.com/8WGtd7TLH/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/8WGtd7TLH/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/8WGtd7TLH/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Action"
			]
		},
		"tags": {
			"en": []
		},
		"width": 720,
		"height": 1200,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 162671,
		"hasIntegratedAds": false
	},
	{
		"code": "S1VZ-LjQUUl",
		"url": "https://9786.play.gamezop.com/g/S1VZ-LjQUUl",
		"name": {
			"en": "Fizz Fuss"
		},
		"isPortrait": false,
		"description": {
			"en": "Is bartending on your bucket-list? Now's your chance! Serve your customers well."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/S1VZ-LjQUUl/cover.jpg",
			"brick": "https://static.gamezop.com/S1VZ-LjQUUl/brick.png",
			"thumb": "https://static.gamezop.com/S1VZ-LjQUUl/thumb.png",
			"wall": "https://static.gamezop.com/S1VZ-LjQUUl/wall.png",
			"square": "https://static.gamezop.com/S1VZ-LjQUUl/square.png",
			"screens": [
				"https://static.gamezop.com/S1VZ-LjQUUl/game-1.png",
				"https://static.gamezop.com/S1VZ-LjQUUl/game-2.png",
				"https://static.gamezop.com/S1VZ-LjQUUl/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/S1VZ-LjQUUl/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/S1VZ-LjQUUl/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Arcade"
			]
		},
		"tags": {
			"en": [
				"Boys",
				"Food",
				"Strategy",
				"Physics",
				"Level-based"
			]
		},
		"width": 1500,
		"height": 640,
		"colorMuted": "#5c3634",
		"colorVibrant": "#643423",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 1410198,
		"hasIntegratedAds": false
	},
	{
		"code": "BJAqNMC7T",
		"url": "https://9786.play.gamezop.com/g/BJAqNMC7T",
		"name": {
			"en": "Alfy"
		},
		"isPortrait": false,
		"description": {
			"en": "This warrior wants be a legendary forest spirit. Step into this magical world of the fern flower."
		},
		"gamePreviews": {
			"en": "https://youtu.be/4pwuxF85bio"
		},
		"assets": {
			"cover": "https://static.gamezop.com/BJAqNMC7T/cover.jpg",
			"brick": "https://static.gamezop.com/BJAqNMC7T/brick.png",
			"thumb": "https://static.gamezop.com/BJAqNMC7T/thumb.png",
			"wall": "https://static.gamezop.com/BJAqNMC7T/wall.png",
			"square": "https://static.gamezop.com/BJAqNMC7T/square.png",
			"screens": [
				"https://static.gamezop.com/BJAqNMC7T/game-1.png",
				"https://static.gamezop.com/BJAqNMC7T/game-2.png",
				"https://static.gamezop.com/BJAqNMC7T/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/BJAqNMC7T/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/BJAqNMC7T/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": [
				"Adventure",
				"Fun",
				"Girls",
				"Kids",
				"Strategy",
				"Arcade",
				"Level-based",
				"Story-based",
				"HD",
				"Cute",
				"Puzzle"
			]
		},
		"width": 800,
		"height": 450,
		"colorMuted": "#5d2b29",
		"colorVibrant": "#964c07",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 6400173,
		"hasIntegratedAds": false
	},
	{
		"code": "BydCYS-ON",
		"url": "https://9786.play.gamezop.com/g/BydCYS-ON",
		"name": {
			"en": "Greedy Gnomes"
		},
		"isPortrait": false,
		"description": {
			"en": "Your aim is to make a column, row, or diagonal of at least four rubies in this multiplayer game."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/BydCYS-ON/cover.jpg",
			"brick": "https://static.gamezop.com/BydCYS-ON/brick.png",
			"thumb": "https://static.gamezop.com/BydCYS-ON/thumb.png",
			"wall": "https://static.gamezop.com/BydCYS-ON/wall.png",
			"square": "https://static.gamezop.com/BydCYS-ON/square.png",
			"screens": [
				"https://static.gamezop.com/BydCYS-ON/game-1.png",
				"https://static.gamezop.com/BydCYS-ON/game-2.png",
				"https://static.gamezop.com/BydCYS-ON/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/BydCYS-ON/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/BydCYS-ON/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": [
				"Board",
				"Logic",
				"Family",
				"Fun",
				"Strategy",
				"Match-3",
				"Multi-player",
				"Zombie",
				"Puzzle"
			]
		},
		"width": 800,
		"height": 600,
		"colorMuted": "#5d3563",
		"colorVibrant": "#0f5b38",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 447300,
		"hasIntegratedAds": false
	},
	{
		"code": "ByvOVQZkK",
		"url": "https://9786.play.gamezop.com/g/ByvOVQZkK",
		"name": {
			"en": "Skill Shot"
		},
		"isPortrait": true,
		"description": {
			"en": "Blast from barrel to barrel avoiding the yellow critters, reach as high as you can."
		},
		"gamePreviews": {
			"en": "https://youtu.be/wfbrDEq1F5E"
		},
		"assets": {
			"cover": "https://static.gamezop.com/ByvOVQZkK/cover.jpg",
			"brick": "https://static.gamezop.com/ByvOVQZkK/brick.png",
			"thumb": "https://static.gamezop.com/ByvOVQZkK/thumb.png",
			"wall": "https://static.gamezop.com/ByvOVQZkK/wall.png",
			"square": "https://static.gamezop.com/ByvOVQZkK/square.png",
			"screens": [
				"https://static.gamezop.com/ByvOVQZkK/game-1.png",
				"https://static.gamezop.com/ByvOVQZkK/game-2.png",
				"https://static.gamezop.com/ByvOVQZkK/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/ByvOVQZkK/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/ByvOVQZkK/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Arcade"
			]
		},
		"tags": {
			"en": [
				"Adventure",
				"Endless",
				"Arcade",
				"Pixel",
				"Minimal"
			]
		},
		"width": 320,
		"height": 480,
		"colorMuted": "#2c4c54",
		"colorVibrant": "#97950a",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 855759,
		"hasIntegratedAds": false
	},
	{
		"code": "Bk4ML6470x",
		"url": "https://9786.play.gamezop.com/g/Bk4ML6470x",
		"name": {
			"en": "Odd One Out"
		},
		"isPortrait": false,
		"description": {
			"en": "Jump the good guys to safety, dump the evil ones to death. Watch out for the timer!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/dM0c8_L4fcw"
		},
		"assets": {
			"cover": "https://static.gamezop.com/Bk4ML6470x/cover.jpg",
			"brick": "https://static.gamezop.com/Bk4ML6470x/brick.png",
			"thumb": "https://static.gamezop.com/Bk4ML6470x/thumb.png",
			"wall": "https://static.gamezop.com/Bk4ML6470x/wall.png",
			"square": "https://static.gamezop.com/Bk4ML6470x/square.png",
			"screens": [
				"https://static.gamezop.com/Bk4ML6470x/game-1.png",
				"https://static.gamezop.com/Bk4ML6470x/game-2.png",
				"https://static.gamezop.com/Bk4ML6470x/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/Bk4ML6470x/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/Bk4ML6470x/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": [
				"Adventure",
				"Boys",
				"Endless",
				"Match-3",
				"Zombie"
			]
		},
		"width": 800,
		"height": 450,
		"colorMuted": "#5c5430",
		"colorVibrant": "#631f0e",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 7838319,
		"hasIntegratedAds": false
	},
	{
		"code": "BJ9bvzIKdJl",
		"url": "https://9786.play.gamezop.com/g/BJ9bvzIKdJl",
		"name": {
			"en": "Brick Plunge"
		},
		"isPortrait": true,
		"description": {
			"en": "Are you nostalgic of the timeless brick arranging game? Who isn't? You are in the right place!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/uXox8MV0884"
		},
		"assets": {
			"cover": "https://static.gamezop.com/BJ9bvzIKdJl/cover.jpg",
			"brick": "https://static.gamezop.com/BJ9bvzIKdJl/brick.png",
			"thumb": "https://static.gamezop.com/BJ9bvzIKdJl/thumb.png",
			"wall": "https://static.gamezop.com/BJ9bvzIKdJl/wall.png",
			"square": "https://static.gamezop.com/BJ9bvzIKdJl/square.png",
			"screens": [
				"https://static.gamezop.com/BJ9bvzIKdJl/game-1.png",
				"https://static.gamezop.com/BJ9bvzIKdJl/game-2.png",
				"https://static.gamezop.com/BJ9bvzIKdJl/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/BJ9bvzIKdJl/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/BJ9bvzIKdJl/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": [
				"Logic",
				"Classics",
				"Kids",
				"Strategy",
				"Arcade",
				"Level-based",
				"Puzzle"
			]
		},
		"width": 960,
		"height": 1440,
		"colorMuted": "#5c2e44",
		"colorVibrant": "#0a327f",
		"privateAllowed": true,
		"rating": 3.63,
		"numberOfRatings": 4,
		"gamePlays": 16837330,
		"hasIntegratedAds": false
	},
	{
		"code": "Sy6b98udz0",
		"url": "https://9786.play.gamezop.com/g/Sy6b98udz0",
		"name": {
			"en": "Cuby Dash"
		},
		"isPortrait": true,
		"description": {
			"en": "Here's a snake that likes... carrots! Swiftly move left and right, collect as many carrots as you can!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/qbOCr4Fr3KE"
		},
		"assets": {
			"cover": "https://static.gamezop.com/Sy6b98udz0/cover.jpg",
			"brick": "https://static.gamezop.com/Sy6b98udz0/brick.png",
			"thumb": "https://static.gamezop.com/Sy6b98udz0/thumb.png",
			"wall": "https://static.gamezop.com/Sy6b98udz0/wall.png",
			"square": "https://static.gamezop.com/Sy6b98udz0/square.png",
			"screens": [
				"https://static.gamezop.com/Sy6b98udz0/game-1.png",
				"https://static.gamezop.com/Sy6b98udz0/game-2.png",
				"https://static.gamezop.com/Sy6b98udz0/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/Sy6b98udz0/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/Sy6b98udz0/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Arcade"
			]
		},
		"tags": {
			"en": [
				"Classics",
				"Endless",
				"Fun",
				"Kids",
				"Arcade"
			]
		},
		"width": 337,
		"height": 600,
		"colorMuted": "#3f442b",
		"colorVibrant": "#745e11",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 17418134,
		"hasIntegratedAds": false
	},
	{
		"code": "BJzGTMJv91Q",
		"url": "https://9786.play.gamezop.com/g/BJzGTMJv91Q",
		"name": {
			"en": "Gerbil Jump"
		},
		"isPortrait": true,
		"description": {
			"en": "Take the Gerbil to new heights: don't rush or you will fall off the buildings!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/9KS-xl4Y7zc"
		},
		"assets": {
			"cover": "https://static.gamezop.com/BJzGTMJv91Q/cover.jpg",
			"brick": "https://static.gamezop.com/BJzGTMJv91Q/brick.png",
			"thumb": "https://static.gamezop.com/BJzGTMJv91Q/thumb.png",
			"wall": "https://static.gamezop.com/BJzGTMJv91Q/wall.png",
			"square": "https://static.gamezop.com/BJzGTMJv91Q/square.png",
			"screens": [
				"https://static.gamezop.com/BJzGTMJv91Q/game-1.png",
				"https://static.gamezop.com/BJzGTMJv91Q/game-2.png",
				"https://static.gamezop.com/BJzGTMJv91Q/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/BJzGTMJv91Q/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/BJzGTMJv91Q/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Action"
			]
		},
		"tags": {
			"en": []
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#2c5164",
		"colorVibrant": "#0c7cc4",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 5981831,
		"hasIntegratedAds": false
	},
	{
		"code": "Hk3bj6nMdgb",
		"url": "https://9786.play.gamezop.com/g/Hk3bj6nMdgb",
		"name": {
			"en": "Laser Locked"
		},
		"isPortrait": true,
		"description": {
			"en": "Rotate the discs to match faces of the same color. You clear a level when the laser connects all discs!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/Ui0ayiqCdfI"
		},
		"assets": {
			"cover": "https://static.gamezop.com/Hk3bj6nMdgb/cover.jpg",
			"brick": "https://static.gamezop.com/Hk3bj6nMdgb/brick.png",
			"thumb": "https://static.gamezop.com/Hk3bj6nMdgb/thumb.png",
			"wall": "https://static.gamezop.com/Hk3bj6nMdgb/wall.png",
			"square": "https://static.gamezop.com/Hk3bj6nMdgb/square.png",
			"screens": [
				"https://static.gamezop.com/Hk3bj6nMdgb/game-1.png",
				"https://static.gamezop.com/Hk3bj6nMdgb/game-2.png",
				"https://static.gamezop.com/Hk3bj6nMdgb/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/Hk3bj6nMdgb/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/Hk3bj6nMdgb/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": [
				"Logic",
				"Fun",
				"Strategy",
				"Match-3",
				"Level-based",
				"Puzzle"
			]
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#6b4969",
		"colorVibrant": "#1b6868",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 1539829,
		"hasIntegratedAds": false
	},
	{
		"code": "YCVAFCL0i",
		"url": "https://9786.play.gamezop.com/g/YCVAFCL0i",
		"name": {
			"en": "Panda Tropical Wedding Story"
		},
		"isPortrait": false,
		"description": {
			"en": "The Bride is here with the theme you set, for the cute panda wedding - this day she won't forget. Adorned with blooms so bright and a vibe so right, her dream makeover is a pure delight."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/YCVAFCL0i/cover.jpg",
			"brick": "https://static.gamezop.com/YCVAFCL0i/brick.png",
			"thumb": "https://static.gamezop.com/YCVAFCL0i/thumb.png",
			"wall": "https://static.gamezop.com/YCVAFCL0i/wall.png",
			"square": "https://static.gamezop.com/YCVAFCL0i/square.png",
			"screens": [
				"https://static.gamezop.com/YCVAFCL0i/game-1.png",
				"https://static.gamezop.com/YCVAFCL0i/game-2.png",
				"https://static.gamezop.com/YCVAFCL0i/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/YCVAFCL0i/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/YCVAFCL0i/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": [
				"New Games"
			]
		},
		"width": 1400,
		"height": 600,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 13306,
		"hasIntegratedAds": false
	},
	{
		"code": "NJ8gGuyMZ5e",
		"url": "https://9786.play.gamezop.com/g/NJ8gGuyMZ5e",
		"name": {
			"en": "Pie Attack"
		},
		"isPortrait": true,
		"description": {
			"en": "Shoot the bad guys that are occupying the tower. Take them down and be mindful of the civilians."
		},
		"gamePreviews": {
			"en": "https://youtu.be/vf3dlSYVbqo"
		},
		"assets": {
			"cover": "https://static.gamezop.com/NJ8gGuyMZ5e/cover.jpg",
			"brick": "https://static.gamezop.com/NJ8gGuyMZ5e/brick.png",
			"thumb": "https://static.gamezop.com/NJ8gGuyMZ5e/thumb.png",
			"wall": "https://static.gamezop.com/NJ8gGuyMZ5e/wall.png",
			"square": "https://static.gamezop.com/NJ8gGuyMZ5e/square.png",
			"screens": [
				"https://static.gamezop.com/NJ8gGuyMZ5e/game-1.png",
				"https://static.gamezop.com/NJ8gGuyMZ5e/game-2.png",
				"https://static.gamezop.com/NJ8gGuyMZ5e/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/NJ8gGuyMZ5e/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/NJ8gGuyMZ5e/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Action"
			]
		},
		"tags": {
			"en": [
				"Action",
				"Adventure",
				"Endless",
				"Fun",
				"Kids",
				"Cute"
			]
		},
		"width": 353,
		"height": 600,
		"colorMuted": "#335461",
		"colorVibrant": "#147434",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 3974515,
		"hasIntegratedAds": false
	},
	{
		"code": "HkRMTzJDck7",
		"url": "https://9786.play.gamezop.com/g/HkRMTzJDck7",
		"name": {
			"en": "Rollout"
		},
		"isPortrait": true,
		"description": {
			"en": "Steer away from obstacles in this highway in the sky. This is sure to remind you of a few classics!"
		},
		"gamePreviews": {
			"en": "https://youtu.be/DCZbSqxORaQ"
		},
		"assets": {
			"cover": "https://static.gamezop.com/HkRMTzJDck7/cover.jpg",
			"brick": "https://static.gamezop.com/HkRMTzJDck7/brick.png",
			"thumb": "https://static.gamezop.com/HkRMTzJDck7/thumb.png",
			"wall": "https://static.gamezop.com/HkRMTzJDck7/wall.png",
			"square": "https://static.gamezop.com/HkRMTzJDck7/square.png",
			"screens": [
				"https://static.gamezop.com/HkRMTzJDck7/game-1.png",
				"https://static.gamezop.com/HkRMTzJDck7/game-2.png",
				"https://static.gamezop.com/HkRMTzJDck7/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/HkRMTzJDck7/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/HkRMTzJDck7/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Adventure"
			]
		},
		"tags": {
			"en": []
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#3e5458",
		"colorVibrant": "#d10f0e",
		"privateAllowed": true,
		"rating": 3.75,
		"numberOfRatings": 7,
		"gamePlays": 77958235,
		"hasIntegratedAds": false
	},
	{
		"code": "SJgx126Qc0H",
		"url": "https://9786.play.gamezop.com/g/SJgx126Qc0H",
		"name": {
			"en": "Sudoku Classic"
		},
		"isPortrait": true,
		"description": {
			"en": "Gamezop brings to you one of the most popular brain games - Sudoku! fill a 9×9 grid with numbers so that each row, column and 3×3 section contain all of the digits between 1 and 9."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/SJgx126Qc0H/cover.jpg",
			"brick": "https://static.gamezop.com/SJgx126Qc0H/brick.png",
			"thumb": "https://static.gamezop.com/SJgx126Qc0H/thumb.png",
			"wall": "https://static.gamezop.com/SJgx126Qc0H/wall.png",
			"square": "https://static.gamezop.com/SJgx126Qc0H/square.png",
			"screens": [
				"https://static.gamezop.com/SJgx126Qc0H/game-1.png",
				"https://static.gamezop.com/SJgx126Qc0H/game-2.png",
				"https://static.gamezop.com/SJgx126Qc0H/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/SJgx126Qc0H/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/SJgx126Qc0H/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": []
		},
		"width": 720,
		"height": 1280,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": false,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 1374907,
		"hasIntegratedAds": false
	},
	{
		"code": "EJaG_JfW9l",
		"url": "https://9786.play.gamezop.com/g/EJaG_JfW9l",
		"name": {
			"en": "Groovy Ski"
		},
		"isPortrait": true,
		"description": {
			"en": "Ski down the most dangerous slopes without hitting the roadblocks in this endless HTML5 game."
		},
		"gamePreviews": {
			"en": "https://youtu.be/N5nRMqWR9sI"
		},
		"assets": {
			"cover": "https://static.gamezop.com/EJaG_JfW9l/cover.jpg",
			"brick": "https://static.gamezop.com/EJaG_JfW9l/brick.png",
			"thumb": "https://static.gamezop.com/EJaG_JfW9l/thumb.png",
			"wall": "https://static.gamezop.com/EJaG_JfW9l/wall.png",
			"square": "https://static.gamezop.com/EJaG_JfW9l/square.png",
			"screens": [
				"https://static.gamezop.com/EJaG_JfW9l/game-1.png",
				"https://static.gamezop.com/EJaG_JfW9l/game-2.png",
				"https://static.gamezop.com/EJaG_JfW9l/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/EJaG_JfW9l/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/EJaG_JfW9l/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Sports & Racing"
			]
		},
		"tags": {
			"en": [
				"Action",
				"Adventure",
				"Boys",
				"Endless",
				"Family",
				"Fun",
				"Girls",
				"Sports",
				"Arcade",
				"Difficult"
			]
		},
		"width": 353,
		"height": 600,
		"colorMuted": "#6c4b2c",
		"colorVibrant": "#5b3f25",
		"privateAllowed": true,
		"rating": 4.75,
		"numberOfRatings": 2,
		"gamePlays": 169268730,
		"hasIntegratedAds": false
	},
	{
		"code": "BJlg94zA76",
		"url": "https://9786.play.gamezop.com/g/BJlg94zA76",
		"name": {
			"en": "Zigzag Clash"
		},
		"isPortrait": false,
		"description": {
			"en": "Colourful and modern snake game with snazzier enemies and much cooler movements!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/BJlg94zA76/cover.jpg",
			"brick": "https://static.gamezop.com/BJlg94zA76/brick.png",
			"thumb": "https://static.gamezop.com/BJlg94zA76/thumb.png",
			"wall": "https://static.gamezop.com/BJlg94zA76/wall.png",
			"square": "https://static.gamezop.com/BJlg94zA76/square.png",
			"screens": [
				"https://static.gamezop.com/BJlg94zA76/game-1.png",
				"https://static.gamezop.com/BJlg94zA76/game-2.png",
				"https://static.gamezop.com/BJlg94zA76/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/BJlg94zA76/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/BJlg94zA76/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Strategy"
			]
		},
		"tags": {
			"en": [
				"Boys",
				"Classics",
				"Endless",
				"Exclusive",
				"Family",
				"Animal",
				"Arcade",
				"HD"
			]
		},
		"width": 800,
		"height": 450,
		"colorMuted": "#4b3866",
		"colorVibrant": "#3c145c",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 1466889,
		"hasIntegratedAds": false
	},
	{
		"code": "rkWfy2pXq0r",
		"url": "https://9786.play.gamezop.com/g/rkWfy2pXq0r",
		"name": {
			"en": "Fruit Chop"
		},
		"isPortrait": false,
		"description": {
			"en": "Swipe the screen to chop fruits but don't hit the bombs! So unsheathe your sword and get ready to play the most fun fruit slice game online."
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/rkWfy2pXq0r/cover.jpg",
			"brick": "https://static.gamezop.com/rkWfy2pXq0r/brick.png",
			"thumb": "https://static.gamezop.com/rkWfy2pXq0r/thumb.png",
			"wall": "https://static.gamezop.com/rkWfy2pXq0r/wall.png",
			"square": "https://static.gamezop.com/rkWfy2pXq0r/square.png",
			"screens": [
				"https://static.gamezop.com/rkWfy2pXq0r/game-1.png",
				"https://static.gamezop.com/rkWfy2pXq0r/game-2.png",
				"https://static.gamezop.com/rkWfy2pXq0r/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/rkWfy2pXq0r/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/rkWfy2pXq0r/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Arcade"
			]
		},
		"tags": {
			"en": []
		},
		"width": 640,
		"height": 360,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 4,
		"numberOfRatings": 1,
		"gamePlays": 79809631,
		"hasIntegratedAds": false
	},
	{
		"code": "BkpeAKrW_E",
		"url": "https://9786.play.gamezop.com/g/BkpeAKrW_E",
		"name": {
			"en": "Veggi Rabbit"
		},
		"isPortrait": false,
		"description": {
			"en": "Cute bunny is a great chap but has one problem: can only eat fruits if in a set of 3! Help at will!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/BkpeAKrW_E/cover.jpg",
			"brick": "https://static.gamezop.com/BkpeAKrW_E/brick.png",
			"thumb": "https://static.gamezop.com/BkpeAKrW_E/thumb.png",
			"wall": "https://static.gamezop.com/BkpeAKrW_E/wall.png",
			"square": "https://static.gamezop.com/BkpeAKrW_E/square.png",
			"screens": [
				"https://static.gamezop.com/BkpeAKrW_E/game-1.png",
				"https://static.gamezop.com/BkpeAKrW_E/game-2.png",
				"https://static.gamezop.com/BkpeAKrW_E/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/BkpeAKrW_E/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/BkpeAKrW_E/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Puzzle & Logic"
			]
		},
		"tags": {
			"en": [
				"Food",
				"Animal",
				"Strategy",
				"Match-3",
				"Level-based",
				"Cute",
				"Puzzle"
			]
		},
		"width": 800,
		"height": 600,
		"colorMuted": "#3e4443",
		"colorVibrant": "#998b1c",
		"privateAllowed": false,
		"rating": 3.75,
		"numberOfRatings": 0,
		"gamePlays": 1940942,
		"hasIntegratedAds": false
	},
	{
		"code": "Bkozyhpmc0H",
		"url": "https://9786.play.gamezop.com/g/Bkozyhpmc0H",
		"name": {
			"en": "Hop Kangaroo Hop"
		},
		"isPortrait": true,
		"description": {
			"en": "The Kangaroo is so plump, and it needs to cross the swamp, so it's time to Hop, Skip'n Jump, let's go thump thump thump!"
		},
		"gamePreviews": {
			"en": ""
		},
		"assets": {
			"cover": "https://static.gamezop.com/Bkozyhpmc0H/cover.jpg",
			"brick": "https://static.gamezop.com/Bkozyhpmc0H/brick.png",
			"thumb": "https://static.gamezop.com/Bkozyhpmc0H/thumb.png",
			"wall": "https://static.gamezop.com/Bkozyhpmc0H/wall.png",
			"square": "https://static.gamezop.com/Bkozyhpmc0H/square.png",
			"screens": [
				"https://static.gamezop.com/Bkozyhpmc0H/game-1.png",
				"https://static.gamezop.com/Bkozyhpmc0H/game-2.png",
				"https://static.gamezop.com/Bkozyhpmc0H/game-3.png"
			],
			"coverTiny": "https://static.gamezop.com/Bkozyhpmc0H/cover-tiny.jpg",
			"brickTiny": "https://static.gamezop.com/Bkozyhpmc0H/brick-tiny.png"
		},
		"categories": {
			"en": [
				"Arcade"
			]
		},
		"tags": {
			"en": []
		},
		"width": 768,
		"height": 1360,
		"colorMuted": "#2F0743",
		"colorVibrant": "#41295A",
		"privateAllowed": true,
		"rating": 0,
		"numberOfRatings": 0,
		"gamePlays": 1658674,
		"hasIntegratedAds": false
	}
]